'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactDom = require('react-dom');
var React = require('react');
var PropTypes = require('prop-types');
require('react-dom/server');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var reactDom__default = /*#__PURE__*/_interopDefaultLegacy(reactDom);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/* Mondrian Site Utils */\n/* Mondrian scss pontual Components */\n@font-face {\n  font-family: 'swiper-icons';\n  src: url(\"data:application/font-woff;charset=utf-8;base64, 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\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal; }\n\n:root {\n  --swiper-theme-color: #007aff; }\n\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1; }\n\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column; }\n\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box; }\n\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0); }\n\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap; }\n\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column; }\n\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto; }\n\n.swiper-container-pointer-events {\n  touch-action: pan-y; }\n  .swiper-container-pointer-events.swiper-container-vertical {\n    touch-action: pan-x; }\n\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform; }\n\n.swiper-slide-invisible-blank {\n  visibility: hidden; }\n\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto; }\n\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height; }\n\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px; }\n  .swiper-container-3d .swiper-wrapper,\n  .swiper-container-3d .swiper-slide,\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom,\n  .swiper-container-3d .swiper-cube-shadow {\n    transform-style: preserve-3d; }\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10; }\n  .swiper-container-3d .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n\n/* CSS Mode */\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */ }\n  .swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n    display: none; }\n\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start; }\n\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory; }\n\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory; }\n\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000; }\n\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */ }\n\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color)); }\n  .swiper-button-prev.swiper-button-disabled,\n  .swiper-button-next.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: auto;\n    pointer-events: none; }\n  .swiper-button-prev:after,\n  .swiper-button-next:after {\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    text-transform: none !important;\n    letter-spacing: 0;\n    text-transform: none;\n    font-variant: initial;\n    line-height: 1; }\n\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto; }\n  .swiper-button-prev:after,\n  .swiper-container-rtl .swiper-button-next:after {\n    content: 'prev'; }\n\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto; }\n  .swiper-button-next:after,\n  .swiper-container-rtl .swiper-button-prev:after {\n    content: 'next'; }\n\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff; }\n\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000; }\n\n.swiper-button-lock {\n  display: none; }\n\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */ }\n\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10; }\n  .swiper-pagination.swiper-pagination-hidden {\n    opacity: 0; }\n\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%; }\n\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0; }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative; }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n    transform: scale(1); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n    transform: scale(1); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n    transform: scale(0.66); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33); }\n\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #000;\n  opacity: 0.2; }\n  button.swiper-pagination-bullet {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none; }\n  .swiper-pagination-clickable .swiper-pagination-bullet {\n    cursor: pointer; }\n  .swiper-pagination-bullet:only-child {\n    display: none !important; }\n\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color)); }\n\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0); }\n  .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 6px 0;\n    display: block; }\n  .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px; }\n    .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n      display: inline-block;\n      transition: 200ms transform, 200ms top; }\n\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px; }\n\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap; }\n  .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 200ms transform, 200ms left; }\n\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right; }\n\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute; }\n  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top; }\n  .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    transform-origin: right top; }\n  .swiper-container-horizontal > .swiper-pagination-progressbar,\n  .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0; }\n  .swiper-container-vertical > .swiper-pagination-progressbar,\n  .swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0; }\n\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff; }\n\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000; }\n\n.swiper-pagination-lock {\n  display: none; }\n\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1); }\n  .swiper-container-horizontal > .swiper-scrollbar {\n    position: absolute;\n    left: 1%;\n    bottom: 3px;\n    z-index: 50;\n    height: 5px;\n    width: 98%; }\n  .swiper-container-vertical > .swiper-scrollbar {\n    position: absolute;\n    right: 3px;\n    top: 1%;\n    z-index: 50;\n    width: 5px;\n    height: 98%; }\n\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0; }\n\n.swiper-scrollbar-cursor-drag {\n  cursor: move; }\n\n.swiper-scrollbar-lock {\n  display: none; }\n\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out; }\n\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity; }\n  .swiper-container-fade .swiper-slide .swiper-slide {\n    pointer-events: none; }\n\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto; }\n\n.mdn-Swiper * {\n  box-sizing: border-box;\n  position: relative; }\n\n.mdn-Swiper .mdn-Image {\n  width: auto; }\n\n.mdn-Swiper .mdn-Swiper-slide {\n  display: initial; }\n\n.mdn-Swiper .mdn-SwiperSlide-buttons {\n  display: flex;\n  width: 100% !important; }\n\n.mdn-Swiper .mdn-Swiper-button-next {\n  margin-left: var(--theme-spacing-inline-xxs); }\n\n.mdn-Swiper--auto .swiper-slide {\n  width: auto !important; }\n\n.mdn-Swiper--bullets .mdn-SwiperSlide-buttonNext,\n.mdn-Swiper--bullets .mdn-SwiperSlide-buttonPrev {\n  display: none; }\n\n.mdn-Swiper--bullets .swiper-button-prev,\n.mdn-Swiper--bullets .swiper-button-next {\n  display: none; }\n\n.mdn-Swiper--bullets .mdn-SwiperSlide-pagination {\n  display: block;\n  display: flex;\n  justify-content: center;\n  width: 100% !important; }\n\n.mdn-Swiper--bullets .swiper-pagination-bullets {\n  margin-top: var(--spacing-stack-md); }\n\n.mdn-Swiper--bullets .swiper-pagination-bullet {\n  width: var(--theme-font-size-sm) !important;\n  height: var(--theme-border-radius-xs) !important;\n  background-color: var(--theme-color-neutral-medium) !important;\n  border-radius: 0 !important;\n  display: inline-block !important;\n  opacity: 1 !important;\n  transition: 300ms ease-out !important;\n  margin: 0 var(--spacing-stack-xxxs); }\n\n.mdn-Swiper--bullets .swiper-pagination-bullet-active {\n  width: 40px !important;\n  height: var(--theme-border-radius-xs) !important;\n  background-color: var(--theme-color-brand-primary-medium) !important;\n  transition: 300ms ease-in !important; }\n\n.mdn-Swiper .swiper-button-prev,\n.mdn-Swiper .swiper-button-next {\n  display: none !important; }\n\n@keyframes loading {\n  0% {\n    transform: translateX(0); }\n  50%,\n  100% {\n    transform: translateX(500px); } }\n\n.mdn-skeleton-paragraph--xxxl {\n  height: var(--spacing-stack-xxxl);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--xxl {\n  height: var(--spacing-stack-xxl);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--xl {\n  height: var(--spacing-stack-xl);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--lg {\n  height: var(--spacing-stack-lg);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--md {\n  height: var(--spacing-stack-md);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--sm {\n  height: var(--spacing-stack-sm);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--xs {\n  height: var(--spacing-stack-xs);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--xxs {\n  height: var(--spacing-stack-xxs);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph--xxxs {\n  height: var(--spacing-stack-xxxs);\n  width: 100%;\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-paragraph::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--spacing-inset-xl);\n  height: 100%;\n  background: linear-gradient(to right, var(--color-neutral-light), var(--color-neutral-medium), var(--color-neutral-light));\n  animation: loading 2s infinite linear; }\n\n.mdn-skeleton-circle--xxxl {\n  width: var(--spacing-stack-xxxl);\n  height: var(--spacing-stack-xxxl);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--xxl {\n  width: var(--spacing-stack-xxl);\n  height: var(--spacing-stack-xxl);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--xl {\n  width: var(--spacing-stack-xl);\n  height: var(--spacing-stack-xl);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--lg {\n  width: var(--spacing-stack-lg);\n  height: var(--spacing-stack-lg);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--md {\n  width: var(--spacing-stack-md);\n  height: var(--spacing-stack-md);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--sm {\n  width: var(--spacing-stack-sm);\n  height: var(--spacing-stack-sm);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--xs {\n  width: var(--spacing-stack-xs);\n  height: var(--spacing-stack-xs);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--xxs {\n  width: var(--spacing-stack-xxs);\n  height: var(--spacing-stack-xxs);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle--xxxs {\n  width: var(--spacing-stack-xxxs);\n  height: var(--spacing-stack-xxxs);\n  border-radius: var(--border-radius-circle);\n  background: var(--color-neutral-light);\n  position: relative;\n  overflow: hidden; }\n\n.mdn-skeleton-circle::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--spacing-inset-xl);\n  height: 100%;\n  background: linear-gradient(to right, var(--color-neutral-light), var(--color-neutral-medium), var(--color-neutral-light));\n  animation: loading 2s infinite linear; }\n\n/**\n * Default Props Card\n */\n.mdn--Card {\n  display: flex;\n  flex-direction: column;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  appearance: none;\n  border: none; }\n  .mdn--Card, .mdn--Card--horizontal {\n    height: var(--theme-border-width-thin);\n    flex-direction: row;\n    width: 100%;\n    margin: var(--theme-spacing-stack-xs) 0; }\n  .mdn--Card--vertical {\n    margin: 0 var(--theme-spacing-inline-xs);\n    height: 100%;\n    width: var(--theme-border-width-thin); }\n  .mdn--Card--primary, .mdn--Card--default {\n    background-color: var(--theme-color-neutral-medium); }\n  .mdn--Card--inverse {\n    background-color: var(--theme-color-neutral-lightest); }\n\n/**\n * Default Props Divider\n */\n.mdn--Divider {\n  display: flex;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: none;\n  display: flex;\n  appearance: none;\n  border: none; }\n  .mdn--Divider, .mdn--Divider--horizontal {\n    height: var(--theme-border-width-thin);\n    width: 100%;\n    margin: var(--theme-spacing-stack-xs) 0; }\n  .mdn--Divider--vertical {\n    margin: 0 var(--theme-spacing-inline-xs);\n    height: 100%;\n    width: var(--theme-border-width-thin); }\n  .mdn--Divider--primary, .mdn--Divider--default {\n    background-color: var(--theme-color-neutral-medium); }\n  .mdn--Divider--inverse {\n    background-color: var(--theme-color-neutral-lightest); }\n\n.mdn-TabSelect .mdn-TabSelect-anchor {\n  background: inherit;\n  border: none; }\n";
styleInject(css_248z$1);

var version = "3.2.21";

/*!
* Mondrian Tokens Claro 1.6.3
* Build do dia 08/06/2022 as 19:38:55 GTM-0300 
*
* https://mondrian.claro.com.br
* Copyright (c) 2019 - 2022 Claro <designopsoficial@globalhitss.com.br>
* Todos os direitos reservados.
*
* A redistribuicao ou alteracao sem a permissao dos proprietarios do software e proibida.
*/
var claroTokensLatest_common = {
  borderStyleDefault: "solid",
  borderWidthNone: "0",
  borderWidthThin: "1px",
  borderWidthMedium: "2px",
  borderWidthThick: "4px",
  borderRadiusNone: "0",
  borderRadiusXs: "4px",
  borderRadiusSm: "8px",
  borderRadiusMd: "16px",
  borderRadiusLg: "24px",
  borderRadiusPill: "500px",
  borderRadiusCircle: "50%",
  colorBrandPrimaryDarkest: "#67160D",
  colorBrandPrimaryDark: "#A61D19",
  colorBrandPrimaryMedium: "#E3262E",
  colorBrandPrimaryLight: "#FE918D",
  colorBrandPrimaryLightest: "#FDE6E3",
  colorSupportSuccessLight: "#EDFFCA",
  colorSupportSuccessDark: "#00850F",
  colorSupportSuccessMedium: "#015305",
  colorSupportDangerLight: "#FFF1D8",
  colorSupportDangerMedium: "#B84D01",
  colorSupportDangerDark: "#B84D01",
  colorSupportHighlightDarkest: "#B84D01",
  colorSupportHighlightDark: "#F09905",
  colorSupportHighlightLightest: "#FFF1D8",
  colorSupportHighlightLight: "#FFD183",
  colorSupportHighlightMedium: "#FFBC4A",
  colorNeutralLightest: "#FFFFFF",
  colorNeutralLight: "#F8F8F8",
  colorNeutralMedium: "#D4D7DE",
  colorNeutralDark: "#51555D",
  colorNeutralDarkest: "#000000",
  colorGlobalDark: "#F09905",
  colorGlobalDarkest: "#B84D01",
  colorGlobalMedium: "#FFBC4A",
  colorGlobalLight: "#FFD183",
  colorGlobalLightest: "#FFF1D8",
  opacitySemiOpaque: "0.8",
  opacityIntense: "0.64",
  opacityMedium: "0.32",
  opacityLight: "0.16",
  opacitySemiTransparent: "0.08",
  shadowOffsetXNone: "0",
  shadowOffsetYLevel1: "4px",
  shadowOffsetYLevel2: "4px",
  shadowOffsetYLevel3: "16px",
  shadowOffsetYLevel4: "16px",
  shadowBlurRadiusLevel1: "8px",
  shadowBlurRadiusLevel2: "8px",
  shadowBlurRadiusLevel3: "24px",
  shadowBlurRadiusLevel4: "24px",
  shadowSpreadRadiusDefault: "-4",
  shadowSpreadRadiusLight: "-16",
  spacingInlineXxxs: "4px",
  spacingInlineXxs: "8px",
  spacingInlineXs: "16px",
  spacingInlineSm: "24px",
  spacingInlineMd: "32px",
  spacingInlineLg: "48px",
  spacingInlineXl: "64px",
  spacingInsetXxs: "4px",
  spacingInsetXs: "8px",
  spacingInsetSm: "16px",
  spacingInsetMd: "24px",
  spacingInsetLg: "32px",
  spacingInsetXl: "48px",
  spacingSquishXxxs: "4px 8px",
  spacingSquishXxs: "4px 16px",
  spacingSquishXs: "8px 16px",
  spacingSquishSm: "8px 24px",
  spacingSquishMd: "16px 24px",
  spacingSquishLg: "16px 32px",
  spacingSquishXl: "24px 32px",
  spacingSquishXxl: "32px 48px",
  spacingStackXxxs: "4px",
  spacingStackXxs: "8px",
  spacingStackXs: "16px",
  spacingStackSm: "24px",
  spacingStackMd: "32px",
  spacingStackLg: "48px",
  spacingStackXl: "64px",
  spacingStackXxl: "96px",
  spacingStackXxxl: "128px",
  fontFamilyHighlight: "DIN OT",
  fontFamilyBase: "DIN OT",
  fontLineHeightNone: "0",
  fontLineHeightXxxs: "16px",
  fontLineHeightXxs: "20px",
  fontLineHeightXs: "24px",
  fontLineHeightSm: "28px",
  fontLineHeightMd: "32px",
  fontLineHeightLg: "36px",
  fontLineHeightXl: "40px",
  fontLineHeightXxl: "52px",
  fontLineHeightXxxl: "68px",
  fontSizeXxxs: "12px",
  fontSizeXxs: "16px",
  fontSizeXs: "20px",
  fontSizeSm: "24px",
  fontSizeMd: "28px",
  fontSizeLg: "32px",
  fontSizeXl: "36px",
  fontSizeXxl: "48px",
  fontSizeXxxl: "64px",
  fontWeightRegular: "400",
  fontWeightMedium: "500",
  fontWeightBold: "700",
  textUnderline: "underline",
  textStrike: "line-through",
  textUppercase: "uppercase",
  opticalAdjustsXs: "-1",
  opticalAdjustsSm: "-2",
  screenSizeXxs: "480px",
  screenSizeSm: "640px",
  screenSizeMd: "768px",
  screenSizeLg: "992px",
  screenSizeXl: "1024px",
  screenSizeXxl: "1200px",
  screenSizeXxxl: "1440px",
  screenSizeUl: "1920px",
};

const blackFridayBody = {
  backgroundColor: claroTokensLatest_common.colorNeutralDarkest
};

const blackFriday = {
  general: {
    colors: {
      background: {
        "--theme-background-color--default": claroTokensLatest_common.colorNeutralLightest,
        "--theme-background-color--primary": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-background-color--primary-dark": claroTokensLatest_common.colorBrandPrimaryDark,
        "--theme-background-color--primary-darkest": claroTokensLatest_common.colorBrandPrimaryDarkest,
        "--theme-background-color--secondary": claroTokensLatest_common.colorNeutralLightest,
        "--theme-background-color--light": claroTokensLatest_common.colorNeutralLight,
        "--theme-background-color--lightest": claroTokensLatest_common.colorNeutralLightest,
        "--theme-background-color--medium": claroTokensLatest_common.colorNeutralMedium,
        "--theme-background-color--dark": claroTokensLatest_common.colorNeutralDark,
        "--theme-background-color--darkest": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-background-color--global": claroTokensLatest_common.colorGlobalMedium,
      },
      text: {
        "--theme-text-color--default": claroTokensLatest_common.colorNeutralDark,
        "--theme-text-color--primary": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-text-color--primary-inverse": claroTokensLatest_common.colorBrandPrimaryDark,
        "--theme-text-color--secondary": claroTokensLatest_common.colorNeutralLightest,
        "--theme-text-color--light": claroTokensLatest_common.colorNeutralMedium,
        "--theme-text-color--dark": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-text-color--inverse": claroTokensLatest_common.colorNeutralLightest,
        "--theme-text-color--disabled": claroTokensLatest_common.colorNeutralDarkest
      },
      // bgs always turn to black
      bg: {
        '--color-brand-primary-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-brand-primary-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-brand-primary-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-brand-primary-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-brand-primary-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-success-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-success-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-success-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-danger-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-danger-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-danger-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-highlight-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-highlight-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-highlight-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-highlight-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-support-highlight-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-neutral-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-neutral-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-neutral-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-neutral-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-neutral-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-global-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-global-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-global-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-global-light-bg': claroTokensLatest_common.colorNeutralDarkest,
        '--color-global-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
      },
      // contents always turn to white
      content: {
        '--color-brand-primary-darkest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-lightest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-darkest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-lightest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-lightest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-darkest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-dark-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-darkest-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-medium-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-light-content': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-lightest-content': claroTokensLatest_common.colorNeutralLightest,
      },
      // contents always turn to color neutral lightest (in black friday)
      clickable: {
        '--color-brand-primary-darkest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-brand-primary-lightest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-success-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-danger-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-darkest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-lightest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-support-highlight-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-lightest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-neutral-darkest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-dark-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-darkest-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-medium-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-light-clickable': claroTokensLatest_common.colorNeutralLightest,
        '--color-global-lightest-clickable': claroTokensLatest_common.colorNeutralLightest,
      },
    }
  },
  components: {
    Alert: {
      "--theme-backgroundColor-Alert-success-light": claroTokensLatest_common.colorSupportSuccessLight,
      "--theme-backgroundColor-Alert-success-dark": claroTokensLatest_common.colorSupportSuccessDark,
      "--theme-backgroundColor-Alert-danger-light": claroTokensLatest_common.colorSupportDangerLight,
      "--theme-backgroundColor-Alert-danger-dark": claroTokensLatest_common.colorSupportDangerDark,
      "--theme-textColor-Alert-success-light": claroTokensLatest_common.colorSupportSuccessDark,
      "--theme-textColor-Alert-success-dark": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Alert-danger-light": claroTokensLatest_common.colorSupportDangerDark,
      "--theme-textColor-Alert-danger-dark": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Alert-button-success-light": claroTokensLatest_common.colorSupportSuccessDark,
      "--theme-textColor-Alert-button-success-dark": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Alert-button-danger-light": claroTokensLatest_common.colorSupportDangerDark,
      "--theme-textColor-Alert-button-danger-dark": claroTokensLatest_common.colorNeutralLightest,
      "--theme-borderColor-Alert-default": "transparent",
    },
    Button: {
      primary: {
        default: {
          "--theme-text-decoration-Button": "none",
          "--theme-text-decoration-hover-Button": "none",
          "--theme-background-color-Button--primary": claroTokensLatest_common.colorBrandPrimaryMedium,
          "--theme-text-color-Button--primary": claroTokensLatest_common.colorNeutralLightest,
          "--theme-border-color-Button--primary": claroTokensLatest_common.colorBrandPrimaryMedium,
          "--theme-background-color-Button-hover--primary": claroTokensLatest_common.colorBrandPrimaryDark,
          "--theme-text-color-Button-hover--primary": claroTokensLatest_common.colorNeutralLightest,
          "--theme-border-color-Button-hover--primary": claroTokensLatest_common.colorBrandPrimaryDark,
        },
        inverse: {
          "--theme-background-color-Button--primary-inverse": claroTokensLatest_common.colorNeutralLightest,
          "--theme-text-color-Button--primary-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
          "--theme-border-color-Button--primary-inverse": claroTokensLatest_common.colorNeutralLightest,
          "--theme-background-color-Button-hover--primary-inverse": claroTokensLatest_common.colorNeutralLight,
          "--theme-text-color-Button-hover--primary-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
          "--theme-border-color-Button-hover--primary-inverse": claroTokensLatest_common.colorNeutralLightest,
        }
      },
      secondary: {
        default: {
          "--theme-background-color-Button--secondary": "transparent",
          "--theme-text-color-Button--secondary": claroTokensLatest_common.colorNeutralDarkest,
          "--theme-border-color-Button--secondary": claroTokensLatest_common.colorNeutralMedium,
          "--theme-background-color-Button-hover--secondary": "transparent",
          "--theme-text-color-Button-hover--secondary": claroTokensLatest_common.colorNeutralDarkest,
          "--theme-border-color-Button-hover--secondary": claroTokensLatest_common.colorNeutralDarkest,
        },
        inverse: {
          "--theme-background-color-Button--secondary-inverse": 'transparent',
          "--theme-text-color-Button--secondary-inverse": claroTokensLatest_common.colorNeutralLightest,
          "--theme-border-color-Button--secondary-inverse": claroTokensLatest_common.colorNeutralLightest,
          "--theme-background-color-Button-hover--secondary-inverse": 'transparent',
          "--theme-text-color-Button-hover--secondary-inverse": claroTokensLatest_common.colorNeutralLightest,
          "--theme-border-color-Button-hover--secondary-inverse": claroTokensLatest_common.colorBrandPrimaryDark,
        }
      },
      global: {
        "--theme-background-color-Button--global": claroTokensLatest_common.colorSupportHighlightLight,
        "--theme-text-color-Button--global": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-border-color-Button--global": claroTokensLatest_common.colorSupportHighlightLight,
        "--theme-background-color-Button-hover--global": claroTokensLatest_common.colorSupportHighlightMedium,
        "--theme-text-color-Button-hover--global": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-border-color-Button-hover--global": claroTokensLatest_common.colorSupportHighlightMedium,
      }
    },
    Text: {
      "--theme-text-color-Heading--default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-color-Heading--inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Subtitle--default": claroTokensLatest_common.colorNeutralDark,
      "--theme-text-color-Subtitle--inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Text--default": claroTokensLatest_common.colorNeutralDark,
      "--theme-text-color-Text--inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Link--default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-color-Link--inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Link--dark": claroTokensLatest_common.colorNeutralDark,
      "--theme-text-color-Label--default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-color-Label--inverse": claroTokensLatest_common.colorNeutralLightest
    },
    Tooltip: {
      "--theme-borderColor-Tooltip": "transparent",
      "--theme-borderColor-Tooltip-Content": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Tooltip-arrow": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-backgroundColor-Tooltip-Content-arrow": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Tooltip-Content-arrow-back": claroTokensLatest_common.colorNeutralMedium
    },
    Checkbox: {
      default: {
        "--theme-borderColor-Checkbox-default": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-textColor-Checkbox-default": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-borderColor-Checkbox-default--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-borderColor-Checkbox-default-check--checked": claroTokensLatest_common.colorNeutralLightest,
        "--theme-backgroundColor-Checkbox-default": claroTokensLatest_common.colorNeutralLightest,
        "--theme-backgroundColor-Checkbox-default--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
      },
      inverse: {
        "--theme-borderColor-Checkbox-inverse": claroTokensLatest_common.colorNeutralLightest,
        "--theme-textColor-Checkbox-inverse": claroTokensLatest_common.colorNeutralLightest,
        "--theme-borderColor-Checkbox-inverse--checked": claroTokensLatest_common.colorNeutralLightest,
        "--theme-borderColor-Checkbox-inverse-check--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-backgroundColor-Checkbox-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-backgroundColor-Checkbox-inverse--checked": claroTokensLatest_common.colorNeutralLightest
      }
    },
    CopyContainer: {
      "--theme-backgroundColor-CopyContainer": claroTokensLatest_common.colorNeutralLight,
      "--theme-color-CopyContainer": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-borderColor-CopyContainer": 'transparent'
    },
    Radio: {
      default: {
        "--theme-borderColor-Radio-default": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-textColor-Radio-default": claroTokensLatest_common.colorNeutralDarkest,
        "--theme-borderColor-Radio-default--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-borderColor-Radio-default-check--checked": claroTokensLatest_common.colorNeutralLightest,
        "--theme-backgroundColor-Radio-default": claroTokensLatest_common.colorNeutralLightest,
        "--theme-backgroundColor-Radio-default--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
      },
      inverse: {
        "--theme-borderColor-Radio-inverse": claroTokensLatest_common.colorNeutralLightest,
        "--theme-textColor-Radio-inverse": claroTokensLatest_common.colorNeutralLightest,
        "--theme-borderColor-Radio-inverse--checked": claroTokensLatest_common.colorNeutralLightest,
        "--theme-borderColor-Radio-inverse-check--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-backgroundColor-Radio-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
        "--theme-backgroundColor-Radio-inverse--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
      }
    },
    ProgressBar: {
      "--theme-backgroundColor-ProgressBar-value-fill--default": claroTokensLatest_common.colorBrandPrimaryMedium,
    },
    Tag: {
      "--theme-text-color-Label--light": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Label--dark": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-color-Label--hat": claroTokensLatest_common.colorNeutralMedium,
      "--theme-text-color-Label--highlight": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-text-color-Label--feedback": claroTokensLatest_common.colorSupportHighlightDark,
      "--theme-text-color-Label--feedbackInverse": claroTokensLatest_common.colorSupportHighlightLight
    },
    Breadcrumb: {
      "--theme-text-color-Breadcrumb--medium": claroTokensLatest_common.colorNeutralMedium,
      "--theme-text-color-Breadcrumb--darkest": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-color-Breadcrumb-icon": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-text-decoration-Breadcrumb-link": "none",
    },
    Accordion: {
      "--theme-borderColor-Accordion-default": claroTokensLatest_common.colorNeutralMedium,
      "--theme-borderColor-Accordion-body-default": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Accordion-header-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Accordion-body-default": claroTokensLatest_common.colorNeutralMedium,
    },
    Banner: {
      "--theme-backgroundColor-Shape-transparent": "transparent",
      "--theme-backgroundColor-Swiper-pagination-bullet-default": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Swiper-pagination-bullet-active": claroTokensLatest_common.colorBrandPrimaryMedium
    },
    Avatar: {
      "--theme-background-Avatar-color--light": claroTokensLatest_common.colorNeutralLight,
      "--theme-Color-Avatar-icon": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-borderWidth-Avatar-default": 0,
      "--theme-borderColor-Avatar-default": "transparent",
      "--theme-borderColor-Avatar-notification-default": claroTokensLatest_common.colorNeutralLightest
    },
    Card: {
      "--theme-borderWidth-Card-default": 0,
      "--theme-borderColor-CardInstitutional-inverse": "transparent"
    },
    Link: {
      "--theme-textDecoration-Link-arrow-default": 'none',
      "--theme-color-Link-arrow-icon-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Link-arrow-icon-inverse": claroTokensLatest_common.colorNeutralLightest,
    },
    Modal: {
      "--theme-background-color-Modal-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-border-color-Modal-default": claroTokensLatest_common.colorNeutralLightest
    },
    LinkList: {
      "--theme-color-LinkList-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-LinkList-inverse": claroTokensLatest_common.colorNeutralLightest,
    },
    Price: {
      "--theme-color-Price-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Price-inverse": claroTokensLatest_common.colorNeutralLightest
    },
    Header: {
      "--theme-color-Header-logoSvg-inverse": "initial",
      "--theme-backgroundColor-Header-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Header-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-borderBottomWidth-Header-default": claroTokensLatest_common.borderWidthNone,
      "--theme-borderBottomColor-Header-default": claroTokensLatest_common.colorNeutralLightest
    },
    Progress: {
      "--theme-borderWidth-Progress-default": 0,
      "--theme-borderColor-Progress-default": "transparent"
    },
    Rating: {
      "--theme-color-Rating-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-Rating-read-only-default": claroTokensLatest_common.colorBrandPrimaryMedium
    },
    Shortcut: {
      "--theme-borderWidth-Shortcut-default": 0,
      "--theme-borderColor-Shortcut-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-borderColor-Shortcut-inverse": claroTokensLatest_common.colorNeutralMedium,
      "--theme-color-Shortcut-icon-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Shortcut-icon-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-Shortcut-text-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Shortcut-text-inverse": claroTokensLatest_common.colorNeutralDarkest
    },
    Slider: {
      "--theme-backgroundColor-Slider-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Slider-bar-default": claroTokensLatest_common.colorNeutralLight,
      "--theme-backgroundColor-Slider-bar-progress": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Slider-thumb-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Slider-thumb-hover": claroTokensLatest_common.colorBrandPrimaryDark
    },
    Spinner: {
      "--theme-color-Spinner-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Spinner-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Spinner-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Spinner-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
    },
    Steps: {
      "--theme-color-Steps-icon": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Steps--checked": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Steps--active": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Steps--doing": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Steps-bar": claroTokensLatest_common.colorNeutralLight,
      "--theme-borderColor-Steps": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-borderColor-Steps--disabled": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Steps--disabled": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Steps--disabledRgba": '227, 38, 46'
    },
    Topic: {
      "--theme-backgroundColor-Topic-icon-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-backgroundColor-Topic-icon-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Topic--default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Topic-horizontal-icon-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Topic-horizontal-icon-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Topic-icon-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Topic-icon-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-Topic-icon-number-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Topic-icon-number-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Topic-text-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Topic-text-inverse": claroTokensLatest_common.colorNeutralLightest
    },
    Input: {
      "--theme-borderColor-Input--hover": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Input--activated": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Input-action--activated": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-backgroundColor-Input-action--default": claroTokensLatest_common.colorNeutralLight,
      "--theme-backgroundColor-Input-action--hover": claroTokensLatest_common.colorBrandsPrimaryDark,
      "--theme-borderColor-Input-action--hover": claroTokensLatest_common.colorBrandPrimaryDark,
      "--theme-color-Input-action--hover": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-Input-action--search": claroTokensLatest_common.colorNeutralDark,
      "--theme-backgroundColor-Input-action--attention": claroTokensLatest_common.colorGlobalMedium,
      "--theme-color-Input-action--default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-Input--attention": claroTokensLatest_common.colorSupportHighlightDarkest,
      "--theme-color-Input--attentionInverse": claroTokensLatest_common.colorSupportHighlightLight
    },
    TabSelect: {
      "--theme-color-link-TabSelect-default": claroTokensLatest_common.colorNeutralDark,
      "--theme-borderColor-link-TabSelect-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-link-active-TabSelect-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-link-hover-TabSelect-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-link-TabSelect-inverse": claroTokensLatest_common.colorBrandPrimaryLight,
      "--theme-borderColor-link-TabSelect-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-link-active-TabSelect-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-link-hover-TabSelect-inverse": claroTokensLatest_common.colorNeutralLightest
    },
    Menu: {
      "--theme-backgroundColor-Menu-top": claroTokensLatest_common.colorBrandPrimaryDark, //black
      "--theme-linkColor-Menu-top": claroTokensLatest_common.colorNeutralLightest, //yellow
      "--theme-backgroundColor-Menu-default": claroTokensLatest_common.colorBrandPrimaryMedium, //black
      "--theme-toggleColor-Menu-default": claroTokensLatest_common.colorNeutralLightest, //yellow
      "--theme-backgroundColor-Menu-list": claroTokensLatest_common.colorNeutralLightest, //black
      "--theme-linkColor-Menu-list": claroTokensLatest_common.colorNeutralDarkest, //yellow
      "--theme-linkColor-Menu-list-desk": claroTokensLatest_common.colorNeutralLightest, //yellow
      "--theme-borderColor-Menu": claroTokensLatest_common.colorNeutralMedium, //white
      "--theme-borderColor-Menu-desk": claroTokensLatest_common.colorNeutralLight, //white
      "--theme-borderColor-Menu-top": 'transparent',
      "--theme-borderColor-Menu-notification-item": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-borderColor-Menu-contracts": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-Menu-contracts-hover": claroTokensLatest_common.colorNeutralLight,
      "--theme-borderColor-Menu-arrow": claroTokensLatest_common.colorNeutralLightest,
      "--theme-borderColor-Menu-shortcut": claroTokensLatest_common.colorNeutralLight, //white
      "--theme-linkColor-Menu-shortcut": claroTokensLatest_common.colorNeutralDarkest, //yellow
      "--theme-backgroundColor-Menu-shortcut": claroTokensLatest_common.colorNeutralLight, //black
      "--theme-backgroundColor-Menu-active": 'rgba(166, 29, 25, 0.3)', //black
      "--theme-textDecoration-Menu": 'none',
      "--theme-backgroundColor-Menu-top-item-focus": "#901916"
    },
    Calendar: {
      "--theme-background-Calendar": claroTokensLatest_common.colorNeutralLightest,
      "--theme-background-Calendar-day": claroTokensLatest_common.colorNeutralLightest,
      "--theme-borderColor-Calendar-day": 'transparent',
      "--theme-borderColor-Calendar-day--hover": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Calendar-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-textColor-Calendar-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Calendar-link-default": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-textColor-Calendar-link-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Calendar-link--hover": claroTokensLatest_common.colorNeutralLightest,
      "--theme-textColor-Calendar-link--readOnly": claroTokensLatest_common.colorNeutralDark,
      "--theme-textDecoration-Calendar-anchor--hover": 'none'

    },
    Toggle: {
      "--theme-backgroundColor-Toggle-default": claroTokensLatest_common.colorNeutralMedium,
      "--theme-borderColor-Toggle-default": "transparent",
      "--theme-backgroundColor-circle-Toggle-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-active-Toggle-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-circle-active-Toggle-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Toggle-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-borderColor-Toggle-inverse": 'transparent',
      "--theme-backgroundColor-circle-Toggle-inverse": claroTokensLatest_common.colorNeutralMedium,
      "--theme-backgroundColor-circle-active-Toggle-inverse": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-active-Toggle-inverse": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Toggle-attention": claroTokensLatest_common.colorSupportHighlightDarkest,
      "--theme-backgroundColor-circle-Toggle-attention": claroTokensLatest_common.colorNeutralLightest,
      "--theme-backgroundColor-Toggle-inverse-attention": claroTokensLatest_common.colorSupportHighlightLight,
      "--theme-backgroundColor-circle-Toggle-inverse-attention": claroTokensLatest_common.colorSupportHighlightDarkest
    },
    Collpase: {
      "--theme-borderColor-Collapse-default": "transparent",
      "--theme-borderStyle-Collapse-default": "none",
      "--theme-borderWidth-Collapse-default": 0,
    },
    Swiper: {
      "--theme-borderColor-Swiper-default": "transparent",
      "--theme-borderStyle-Swiper-default": "none",
      "--theme-borderWidth-Swiper-default": 0,
      "--theme-background-Swiper-bullet-background-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-background-Swiper-bullet-background-hover": claroTokensLatest_common.colorBrandPrimaryDark,
      "--theme-background-Swiper-bullet-icon-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-background-Swiper-inverse-bullet-background-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-background-Swiper-inverse-bullet-background-hover": claroTokensLatest_common.colorNeutralLight,
      "--theme-backgroundColor-bullet-hover": claroTokensLatest_common.colorBrandPrimaryDarkest
    },
    HelpPassword: {
      "--theme-backgroundColor-HelpPassword-default": claroTokensLatest_common.colorNeutralLight,
      "--theme-text-color-HelpPassword": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-borderColor-HelpPassword-default": claroTokensLatest_common.colorNeutralLight,
    },
    Footer: {
      "--theme-borderColor-Footer-default": "transparent",
      "--theme-borderStyle-Footer-default": "none",
      "--theme-borderWidth-Footer-default": 0,
      "--theme-color-Footer-logoSvg-inverse": "initial",
      "--theme-backgroundColor-Footer-default": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-Footer-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-icon-Footer-default": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-icon-Footer-hover-default": claroTokensLatest_common.colorBrandPrimaryDark,
      "--theme-backgroundColor-Footer-secondary": claroTokensLatest_common.colorNeutralLight,
      "--theme-color-Footer-secondary": claroTokensLatest_common.colorNeutralDark,
      "--theme-color-icon-Footer-secondary": claroTokensLatest_common.colorNeutralDark,
      "--theme-color-icon-Footer-hover-secondary": claroTokensLatest_common.colorNeutralDarkest,
    },
    BrandGroup: {
      "--theme-textColor-BrandGroup-etc-default": claroTokensLatest_common.colorNeutralDark
    },
    IconGroup: {
      "--theme-textColor-IconGroup-plus-default": claroTokensLatest_common.colorBrandPrimaryLight
    },
    Countdown: {
      "--theme-borderColor-Countdown--bar": 'transparent',
      "--theme-borderWidth-Countdown--bar": 0,
      "--theme-backgroundColor-Countdown--progress": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-backgroundColor-Countdown--progress--isOpen": claroTokensLatest_common.colorNeutralLightest,
      "--theme-text-color-Countdown--progress": claroTokensLatest_common.colorNeutralLightest
    },
    Others: {
      "--theme-color-neutral-darkest": claroTokensLatest_common.colorNeutralDarkest,
      "--theme-color-neutral-dark": claroTokensLatest_common.colorNeutralDark,
      "--theme-color-neutral-medium": claroTokensLatest_common.colorNeutralMedium,
      "--theme-color-neutral-light": claroTokensLatest_common.colorNeutralLight,
      "--theme-color-neutral-lightest": claroTokensLatest_common.colorNeutralLightest,
      "--theme-color-brand-primary-darkest": claroTokensLatest_common.colorBrandPrimaryDarkest,
      "--theme-color-brand-primary-dark": claroTokensLatest_common.colorBrandPrimaryDark,
      "--theme-color-brand-primary-medium": claroTokensLatest_common.colorBrandPrimaryMedium,
      "--theme-color-brand-primary-light": claroTokensLatest_common.colorBrandPrimaryLight,
      "--theme-color-brand-primary-lightest": claroTokensLatest_common.colorBrandPrimaryLightest,
      "--theme-color-global-dark": claroTokensLatest_common.colorGlobalDark,
      "--theme-color-global-darkest": claroTokensLatest_common.colorGlobalDarkest,
      "--theme-color-global-medium": claroTokensLatest_common.colorGlobalMedium,
      "--theme-color-global-light": claroTokensLatest_common.colorGlobalLight,
      "--theme-color-global-lightest": claroTokensLatest_common.colorGlobalLightest
    },
    Typography: {
      "--theme-fontFamily-heading-default": claroTokensLatest_common.fontFamilyHighlight,
      "--theme-font-family-text-default": claroTokensLatest_common.fontFamilyBase
    }
  }
};

const acessibilityYellow = "#fff333";
const acessibilityYellowHover = "#e6da30";

const contrastBody = {
    backgroundColor: claroTokensLatest_common.colorNeutralDarkest,
};

const contrast = {
    general: {
        colors: {
            contrast: {
                "--theme-border-color--contrast--clickable": acessibilityYellow,
                "--theme-border-color--contrast": claroTokensLatest_common.colorNeutralLightest,
                "--theme-background-color--contrast--clickable": acessibilityYellow,
                "--theme-background-color--contrast": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-text--contrast--clickable": acessibilityYellow,
                "--theme-text--contrast": claroTokensLatest_common.colorNeutralLightest,
            },
            background: {
                "--theme-background-color--default": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--primary": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--primary-dark": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--primary-darkest": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--secondary": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--light": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--lightest": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--medium": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--dark": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--darkest": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-background-color--global": claroTokensLatest_common.colorNeutralDarkest,
            },
            text: {
                "--theme-text-color--default": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--primary": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--primary-inverse": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--secondary": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--light": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--dark": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--inverse": claroTokensLatest_common.colorNeutralLightest,
                "--theme-text-color--disabled": claroTokensLatest_common.colorNeutralLightest,
            },
            // bgs always turn to black
            bg: {
                '--theme-color-brand-primary-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-brand-primary-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-brand-primary-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-brand-primary-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-brand-primary-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-success-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-success-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-success-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-danger-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-danger-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-danger-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-highlight-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-highlight-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-highlight-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-highlight-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-support-highlight-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-neutral-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-neutral-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-neutral-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-neutral-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-neutral-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-global-dark-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-global-darkest-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-global-medium-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-global-light-bg': claroTokensLatest_common.colorNeutralDarkest,
                '--theme-color-global-lightest-bg': claroTokensLatest_common.colorNeutralDarkest,
            },
            // contents always turn to white
            content: {
                '--theme-color-brand-primary-darkest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-brand-primary-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-brand-primary-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-brand-primary-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-brand-primary-lightest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-success-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-success-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-success-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-danger-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-danger-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-danger-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-highlight-darkest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-highlight-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-highlight-lightest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-highlight-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-support-highlight-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-neutral-lightest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-neutral-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-neutral-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-neutral-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-neutral-darkest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-global-dark-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-global-darkest-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-global-medium-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-global-light-content': claroTokensLatest_common.colorNeutralLightest,
                '--theme-color-global-lightest-content': claroTokensLatest_common.colorNeutralLightest,
            },
            // contents always turn to acessibilityYellow
            clickable: {
                '--theme-color-brand-primary-darkest-clickable': acessibilityYellow,
                '--theme-color-brand-primary-dark-clickable': acessibilityYellow,
                '--theme-color-brand-primary-medium-clickable': acessibilityYellow,
                '--theme-color-brand-primary-light-clickable': acessibilityYellow,
                '--theme-color-brand-primary-lightest-clickable': acessibilityYellow,
                '--theme-color-support-success-light-clickable': acessibilityYellow,
                '--theme-color-support-success-dark-clickable': acessibilityYellow,
                '--theme-color-support-success-medium-clickable': acessibilityYellow,
                '--theme-color-support-danger-light-clickable': acessibilityYellow,
                '--theme-color-support-danger-medium-clickable': acessibilityYellow,
                '--theme-color-support-danger-dark-clickable': acessibilityYellow,
                '--theme-color-support-highlight-darkest-clickable': acessibilityYellow,
                '--theme-color-support-highlight-dark-clickable': acessibilityYellow,
                '--theme-color-support-highlight-lightest-clickable': acessibilityYellow,
                '--theme-color-support-highlight-light-clickable': acessibilityYellow,
                '--theme-color-support-highlight-medium-clickable': acessibilityYellow,
                '--theme-color-neutral-lightest-clickable': acessibilityYellow,
                '--theme-color-neutral-light-clickable': acessibilityYellow,
                '--theme-color-neutral-medium-clickable': acessibilityYellow,
                '--theme-color-neutral-dark-clickable': acessibilityYellow,
                '--theme-color-neutral-darkest-clickable': acessibilityYellow,
                '--theme-color-global-dark-clickable': acessibilityYellow,
                '--theme-color-global-darkest-clickable': acessibilityYellow,
                '--theme-color-global-medium-clickable': acessibilityYellow,
                '--theme-color-global-light-clickable': acessibilityYellow,
                '--theme-color-global-lightest-clickable': acessibilityYellow,
            },
        },
    },
    components: {
        Skeleton: {
            "--theme-skeleton-color--medium": claroTokensLatest_common.colorNeutralDark,
            "--theme-skeleton-color--dark": claroTokensLatest_common.colorNeutralDarkest,
        },
        Alert: {
            "--theme-backgroundColor-Alert-success-light": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Alert-success-dark": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Alert-danger-light": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Alert-danger-dark": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-textColor-Alert-success-light": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Alert-success-dark": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Alert-danger-light": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Alert-danger-dark": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Alert-button-success-light": acessibilityYellow,
            "--theme-textColor-Alert-button-success-dark": acessibilityYellow,
            "--theme-textColor-Alert-button-danger-light": acessibilityYellow,
            "--theme-textColor-Alert-button-danger-dark": acessibilityYellow,
            "--theme-borderColor-Alert-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Button: {
            primary: {
                default: {
                    "--theme-text-decoration-Button": claroTokensLatest_common.textUnderline,
                    "--theme-text-decoration-hover-Button": "none",
                    "--theme-background-color-Button--primary": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button--primary": acessibilityYellow,
                    "--theme-border-color-Button--primary": acessibilityYellow,
                    "--theme-background-color-Button-hover--primary": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button-hover--primary": acessibilityYellow,
                    "--theme-border-color-Button-hover--primary": acessibilityYellow,
                },
                inverse: {
                    "--theme-background-color-Button--primary-inverse": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button--primary-inverse": acessibilityYellow,
                    "--theme-border-color-Button--primary-inverse": acessibilityYellow,
                    "--theme-background-color-Button-hover--primary-inverse": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button-hover--primary-inverse": acessibilityYellow,
                    "--theme-border-color-Button-hover--primary-inverse": acessibilityYellow,
                },
            },
            secondary: {
                default: {
                    "--theme-background-color-Button--secondary": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button--secondary": acessibilityYellow,
                    "--theme-border-color-Button--secondary": acessibilityYellow,
                    "--theme-background-color-Button-hover--secondary": claroTokensLatest_common.colorNeutralDarkest,
                    "--theme-text-color-Button-hover--secondary": acessibilityYellow,
                    "--theme-border-color-Button-hover--secondary": acessibilityYellow,
                },
                inverse: {
                    "--theme-background-color-Button--secondary-inverse": 'transparent',
                    "--theme-text-color-Button--secondary-inverse": acessibilityYellow,
                    "--theme-border-color-Button--secondary-inverse": acessibilityYellow,
                    "--theme-background-color-Button-hover--secondary-inverse": 'transparent',
                    "--theme-text-color-Button-hover--secondary-inverse": acessibilityYellow,
                    "--theme-border-color-Button-hover--secondary-inverse": acessibilityYellow,
                },
            },
            global: {
                "--theme-background-color-Button--global": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-text-color-Button--global": acessibilityYellow,
                "--theme-border-color-Button--global": acessibilityYellow,
                "--theme-background-color-Button-hover--global": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-text-color-Button-hover--global": acessibilityYellow,
                "--theme-border-color-Button-hover--global": acessibilityYellow,
            },
        },
        Text: {
            "--theme-text-color-Heading--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Heading--inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Subtitle--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Subtitle--inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Text--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Text--inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Link--default": acessibilityYellow,
            "--theme-text-color-Link--inverse": acessibilityYellow,
            "--theme-text-color-Link--dark": acessibilityYellow,
            "--theme-text-color-Label--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--inverse": claroTokensLatest_common.colorNeutralLightest,
        },
        Tooltip: {
            "--theme-borderColor-Tooltip": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Tooltip-Content": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Tooltip-arrow": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Tooltip-arrow-border": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Tooltip-Content-arrow": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Tooltip-Content-arrow-back": claroTokensLatest_common.colorNeutralLightest,
        },
        Checkbox: {
            default: {
                "--theme-borderColor-Checkbox-default": acessibilityYellow,
                "--theme-textColor-Checkbox-default": acessibilityYellow,
                "--theme-borderColor-Checkbox-default--checked": acessibilityYellow,
                "--theme-borderColor-Checkbox-default-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-default": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-default--checked": acessibilityYellow,
            },
            inverse: {
                "--theme-borderColor-Checkbox-inverse": acessibilityYellow,
                "--theme-textColor-Checkbox-inverse": acessibilityYellow,
                "--theme-borderColor-Checkbox-inverse--checked": acessibilityYellow,
                "--theme-borderColor-Checkbox-inverse-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-inverse": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-inverse--checked": acessibilityYellow,
            },
            darkest: {
                "--theme-borderColor-Checkbox-darkest": acessibilityYellow,
                "--theme-textColor-Checkbox-darkest": acessibilityYellow,
                "--theme-borderColor-Checkbox-darkest--checked": acessibilityYellow,
                "--theme-borderColor-Checkbox-darkest-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-darkest": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Checkbox-darkest--checked": acessibilityYellow,
            },
        },
        CopyContainer: {
            "--theme-backgroundColor-CopyContainer": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-CopyContainer": "transparent",
            "--theme-borderColor-CopyContainer": acessibilityYellow,
            "--theme-color-CopyContainer-icon": acessibilityYellow,

        },
        Radio: {
            default: {
                "--theme-borderColor-Radio-default": acessibilityYellow,
                "--theme-textColor-Radio-default": acessibilityYellow,
                "--theme-borderColor-Radio-default--checked": acessibilityYellow,
                "--theme-borderColor-Radio-default-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-default": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-default--checked": acessibilityYellow,
            },
            inverse: {
                "--theme-borderColor-Radio-inverse": acessibilityYellow,
                "--theme-textColor-Radio-inverse": acessibilityYellow,
                "--theme-borderColor-Radio-inverse--checked": acessibilityYellow,
                "--theme-borderColor-Radio-inverse-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-inverse": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-inverse--checked": claroTokensLatest_common.colorNeutralDarkest,
            },
            darkest: {
                "--theme-borderColor-Radio-darkest": acessibilityYellow,
                "--theme-textColor-Radio-darkest": acessibilityYellow,
                "--theme-borderColor-Radio-darkest--checked": acessibilityYellow,
                "--theme-borderColor-Radio-darkest-check--checked": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-darkest": claroTokensLatest_common.colorNeutralDarkest,
                "--theme-backgroundColor-Radio-darkest--checked": claroTokensLatest_common.colorNeutralDarkest,
            },
        },
        ProgressBar: {
            "--theme-backgroundColor-ProgressBar-value-fill--default": claroTokensLatest_common.colorNeutralLightest,
        },
        Tag: {
            "--theme-text-color-Label--light": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--dark": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--hat": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--highlight": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--feedback": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Label--feedbackInverse": claroTokensLatest_common.colorNeutralLightest,
        },
        Breadcrumb: {
            "--theme-text-color-Breadcrumb--medium": acessibilityYellow,
            "--theme-text-color-Breadcrumb--darkest": acessibilityYellow,
            "--theme-text-color-Breadcrumb-icon": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-decoration-Breadcrumb-link": claroTokensLatest_common.textUnderline,
            "--theme-text-color-BreadcrumbLink--default": acessibilityYellow,
            "--theme-text-color-BreadcrumbIcon--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-BreadcrumbLink--hover": acessibilityYellow
        },
        Accordion: {
            "--theme-borderColor-Accordion-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Accordion-body-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Accordion-header-default": acessibilityYellow,
            "--theme-backgroundColor-Accordion-body-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Accordion-toggle-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Accordion-icon-default": claroTokensLatest_common.colorNeutralDarkest
        },
        Banner: {
            "--theme-backgroundColor-Shape-transparent": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Swiper-pagination-bullet-default": acessibilityYellow,
            "--theme-backgroundColor-Swiper-pagination-bullet-active": claroTokensLatest_common.colorNeutralLightest,
        },
        Avatar: {
            "--theme-background-Avatar-color--light": acessibilityYellow,
            "--theme-Color-Avatar-icon": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-borderWidth-Avatar-default": claroTokensLatest_common.borderWidthThin,
            "--theme-borderColor-Avatar-default": acessibilityYellow,
            "--theme-borderColor-Avatar-notification-default": acessibilityYellow,
        },
        Card: {
            "--theme-borderWidth-Card-default": claroTokensLatest_common.borderWidthThin,
            "--theme-borderColor-CardInstitutional-inverse": claroTokensLatest_common.colorNeutralLightest,
        },
        Link: {
            "--theme-textDecoration-Link-arrow-default": 'underline',
            "--theme-color-Link-arrow-icon-default": acessibilityYellow,
            "--theme-color-Link-arrow-icon-inverse": acessibilityYellow,
        },
        Modal: {
            "--theme-background-color-Modal-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-border-color-Modal-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-modal": claroTokensLatest_common.colorNeutralLightest
        },
        LinkList: {
            "--theme-color-LinkList-default": acessibilityYellow,
            "--theme-color-LinkList-inverse": acessibilityYellow,
        },
        Price: {
            "--theme-color-Price-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Price-value-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Price-inverse": claroTokensLatest_common.colorNeutralLightest,
        },
        Header: {
            "--theme-color-Header-logoSvg-inverse": "brightness(100)",
            "--theme-backgroundColor-Header-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Header-inverse": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-borderBottomWidth-Header-default": claroTokensLatest_common.borderWidthThin,
            "--theme-borderBottomColor-Header-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Progress: {
            "--theme-borderWidth-Progress-default": claroTokensLatest_common.borderWidthThin,
            "--theme-borderColor-Progress-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Rating: {
            "--theme-color-Rating-default": acessibilityYellow,
            "--theme-color-Rating-read-only-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Shortcut: {
            "--theme-borderWidth-Shortcut-default": claroTokensLatest_common.borderWidthThin,
            "--theme-borderColor-Shortcut-default-hover": claroTokensLatest_common.colorNeutralDark,
            "--theme-borderColor-Shortcut-default": acessibilityYellow,
            "--theme-borderColor-Shortcut-inverse": acessibilityYellow,
            "--theme-color-Shortcut-icon-default": acessibilityYellow,
            "--theme-color-Shortcut-icon-inverse": acessibilityYellow,
            "--theme-color-Shortcut-text-default": acessibilityYellow,
            "--theme-color-Shortcut-text-inverse": acessibilityYellow,
        },
        Slider: {
            "--theme-backgroundColor-Slider-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Slider-bar-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Slider-bar-progress": acessibilityYellow,
            "--theme-backgroundColor-Slider-thumb-default": acessibilityYellow,
            "--theme-backgroundColor-Slider-thumb-hover": acessibilityYellow,
        },
        Spinner: {
            "--theme-color-Spinner-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Spinner-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Spinner-inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Spinner-inverse": claroTokensLatest_common.colorNeutralDarkest,
        },
        Steps: {
            "--theme-color-Steps-icon": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Steps--checked": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Steps--active": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Steps--doing": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Steps-bar": claroTokensLatest_common.colorNeutralLight,
            "--theme-borderColor-Steps": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Steps--disabled": claroTokensLatest_common.colorNeutralMedium,
            "--theme-backgroundColor-Steps--disabled": claroTokensLatest_common.colorNeutralMedium,
            "--theme-backgroundColor-Steps--disabledRgba": '212, 215, 222',
        },
        Topic: {
            "--theme-backgroundColor-Topic-icon-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Topic-icon-inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic--default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-horizontal-icon-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-horizontal-icon-inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-icon-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Topic-icon-inverse": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Topic-icon-number-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-icon-number-inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-text-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Topic-text-inverse": claroTokensLatest_common.colorNeutralLightest,
        },
        Input: {
            "--theme-borderColor-Input--hover": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Input": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Input--disabled": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input--disabled": claroTokensLatest_common.colorNeutralMedium,
            "--theme-color-Input-label": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input-label--disabled": claroTokensLatest_common.colorNeutralDark,
            "--theme-color-Input--activated": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input-action--activated": acessibilityYellow,
            "--theme-backgroundColor-Input-action--default": acessibilityYellow,
            "--theme-backgroundColor-Input-action--hover": acessibilityYellow,
            "--theme-borderColor-Input-action--hover": acessibilityYellow,
            "--theme-color-Input-action--search": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Input-action--attention": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input-action--default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Input-action--hover": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Input--attention": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input--attentionInverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-Input-select-custom-hover-option": claroTokensLatest_common.colorNeutralDark
        },
        TabSelect: {
            "--theme-color-link-TabSelect-default": acessibilityYellow,
            "--theme-borderColor-link-TabSelect-default": acessibilityYellow,
            "--theme-color-link-active-TabSelect-default": acessibilityYellow,
            "--theme-color-link-hover-TabSelect-default": acessibilityYellow,
            "--theme-color-link-TabSelect-inverse": acessibilityYellow,
            "--theme-borderColor-link-TabSelect-inverse": acessibilityYellow,
            "--theme-color-link-active-TabSelect-inverse": acessibilityYellow,
            "--theme-color-link-hover-TabSelect-inverse": acessibilityYellow,
        },
        Menu: {
            "--theme-backgroundColor-Menu-top": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-linkColor-Menu-top": acessibilityYellow, //yellow
            "--theme-backgroundColor-Menu-default": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-toggleColor-Menu-default": acessibilityYellow, //yellow
            "--theme-backgroundColor-Menu-list": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-linkColor-Menu-list": acessibilityYellow, //yellow
            "--theme-linkColor-Menu-list-desk": acessibilityYellow, //yellow
            "--theme-borderColor-Menu": claroTokensLatest_common.colorNeutralLightest, //white
            "--theme-borderColor-Menu-desk": claroTokensLatest_common.colorNeutralLightest, //white
            "--theme-borderColor-Menu-top": claroTokensLatest_common.colorNeutralLightest, //white
            "--theme-borderColor-Menu-notification-item": claroTokensLatest_common.colorNeutralLightest, //white
            "--theme-borderColor-Menu-contracts": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Menu-contracts-hover": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-borderColor-Menu-arrow": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-Menu-shortcut": claroTokensLatest_common.colorNeutralLightest, //white
            "--theme-linkColor-Menu-shortcut": acessibilityYellow, //yellow
            "--theme-backgroundColor-Menu-shortcut": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-backgroundColor-Menu-active": claroTokensLatest_common.colorNeutralDarkest, //black
            "--theme-textDecoration-Menu": 'underline',
            "--theme-backgroundColor-Menu-top-item-focus": claroTokensLatest_common.colorNeutralDarkest,
        },
        Calendar: {
            "--theme-background-Calendar-day": claroTokensLatest_common.colorNeutralLightest,
            "--theme-background-Calendar": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-borderColor-Calendar-day": acessibilityYellow,
            "--theme-borderColor-Calendar-day--hover": acessibilityYellow,
            "--theme-textColor-Calendar-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Calendar-inverse": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textColor-Calendar-link-default": acessibilityYellow,
            "--theme-textColor-Calendar-link-inverse": acessibilityYellow,
            "--theme-textColor-Calendar-link--hover": acessibilityYellow,
            "--theme-textColor-Calendar-link--readOnly": claroTokensLatest_common.colorNeutralLightest,
            "--theme-textDecoration-Calendar-anchor--hover": claroTokensLatest_common.textUnderline,
        },
        Toggle: {
            "--theme-backgroundColor-Toggle-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-borderColor-Toggle-default": acessibilityYellow,
            "--theme-backgroundColor-circle-Toggle-default": acessibilityYellow,
            "--theme-backgroundColor-active-Toggle-default": acessibilityYellow,
            "--theme-backgroundColor-circle-active-Toggle-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-Toggle-inverse": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-borderColor-Toggle-inverse": 'transparent',
            "--theme-backgroundColor-circle-Toggle-inverse": acessibilityYellow,
            "--theme-backgroundColor-circle-active-Toggle-inverse": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-active-Toggle-inverse": acessibilityYellow,
            "--theme-backgroundColor-Toggle-attention": claroTokensLatest_common.colorSupportHighlightLight,
            "--theme-backgroundColor-circle-Toggle-attention": claroTokensLatest_common.colorSupportHighlightDark,
            "--theme-backgroundColor-Toggle-inverse-attention": claroTokensLatest_common.colorSupportHighlightLight,
            "--theme-backgroundColor-circle-Toggle-inverse-attention": claroTokensLatest_common.colorSupportHighlightDark,
            "--theme-backgroundColor-Toggle-darkest": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-circle-Toggle-darkest": acessibilityYellow,
            "--theme-backgroundColor-circle-active-Toggle-darkest": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-active-Toggle-darkest": acessibilityYellow,
            "--theme-backgroundColor-Toggle-darkest-attention": claroTokensLatest_common.colorSupportHighlightLight,
            "--theme-backgroundColor-circle-Toggle-darkest-attention": claroTokensLatest_common.colorSupportHighlightDark,
        },
        Collpase: {
            "--theme-borderColor-Collapse-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderStyle-Collapse-default": claroTokensLatest_common.borderStyleDefault,
            "--theme-borderWidth-Collapse-default": claroTokensLatest_common.borderWidthThin,
        },
        Swiper: {
            "--theme-borderColor-Swiper-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderStyle-Swiper-default": claroTokensLatest_common.borderStyleDefault,
            "--theme-borderWidth-Swiper-default": 0,
            "--theme-background-Swiper-bullet-background-default": acessibilityYellow,
            "--theme-background-Swiper-bullet-background-hover": acessibilityYellowHover,
            "--theme-background-Swiper-bullet-icon-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-background-Swiper-bullet-icon-hover": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-background-Swiper-inverse-bullet-background-default": acessibilityYellow,
            "--theme-background-Swiper-inverse-bullet-background-hover": acessibilityYellowHover,
            "--theme-background-Swiper-inverse-bullet-icon-hover": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-backgroundColor-bullet-hover": acessibilityYellowHover,
        },
        HelpPassword: {
            "--theme-backgroundColor-HelpPassword-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-text-color-HelpPassword": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderColor-HelpPassword-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Footer: {
            "--theme-borderColor-Footer-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderStyle-Footer-default": claroTokensLatest_common.borderStyleDefault,
            "--theme-borderWidth-Footer-default": claroTokensLatest_common.borderWidthThin,
            "--theme-color-Footer-logoSvg-inverse": "brightness(100)",
            "--theme-backgroundColor-Footer-default": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Footer-default": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-icon-Footer-default": acessibilityYellow,
            "--theme-color-icon-Footer-hover-default": acessibilityYellow,
            "--theme-backgroundColor-Footer-secondary": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-Footer-secondary": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-icon-Footer-secondary": acessibilityYellow,
            "--theme-color-icon-Footer-hover-secondary": acessibilityYellow,
        },
        BrandGroup: {
            "--theme-textColor-BrandGroup-etc-default": claroTokensLatest_common.colorNeutralDarkest,
        },
        IconGroup: {
            "--theme-textColor-IconGroup-plus-default": claroTokensLatest_common.colorNeutralLightest,
        },
        Countdown: {
            "--theme-borderColor-Countdown--bar": claroTokensLatest_common.colorNeutralLightest,
            "--theme-borderWidth-Countdown--bar": claroTokensLatest_common.borderWidthThin,
            "--theme-backgroundColor-Countdown--progress": claroTokensLatest_common.colorNeutralLightest,
            "--theme-backgroundColor-Countdown--progress--isOpen": claroTokensLatest_common.colorNeutralLightest,
            "--theme-text-color-Countdown--progress": claroTokensLatest_common.colorNeutralDarkest,
        },
        Others: {
            "--theme-color-neutral-darkest": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-neutral-dark": claroTokensLatest_common.colorNeutralDark,
            "--theme-color-neutral-medium": claroTokensLatest_common.colorNeutralMedium,
            "--theme-color-neutral-light": claroTokensLatest_common.colorNeutralLight,
            "--theme-color-neutral-lightest": claroTokensLatest_common.colorNeutralLightest,
            "--theme-color-brand-primary-darkest": claroTokensLatest_common.colorBrandPrimaryDarkest,
            "--theme-color-brand-primary-dark": claroTokensLatest_common.colorBrandPrimaryDark,
            "--theme-color-brand-primary-medium": claroTokensLatest_common.colorNeutralDarkest,
            "--theme-color-brand-primary-light": claroTokensLatest_common.colorBrandPrimaryLight,
            "--theme-color-brand-primary-lightest": claroTokensLatest_common.colorBrandPrimaryLightest,
            "--theme-color-global-dark": claroTokensLatest_common.colorGlobalDark,
            "--theme-color-global-darkest": claroTokensLatest_common.colorGlobalDarkest,
            "--theme-color-global-medium": claroTokensLatest_common.colorGlobalMedium,
            "--theme-color-global-light": claroTokensLatest_common.colorGlobalLight,
            "--theme-color-global-lightest": claroTokensLatest_common.colorGlobalLightest,
        },
        Typography: {
            "--theme-fontFamily-heading-default": claroTokensLatest_common.fontFamilyHighlight,
            "--theme-font-family-text-default": claroTokensLatest_common.fontFamilyBase,
        },
    }
};

const data = {
  'black-friday' : {
    title: 'black-friday',
    styles : blackFriday,
    bodyStyle : blackFridayBody
  },
  contrast : {
    title: 'contrast',
    styles : contrast,
    bodyStyle : contrastBody
  }
};

const setCookie = (cookieKey, cookieValue, expirationDays) => {
  let expiryDate = '';

  if (expirationDays) {
    const date = new Date();

    date.setTime(`${date.getTime()}${(expirationDays || 30 * 24 * 60 * 60 * 1000)}`);

    expiryDate = `; expiryDate=" ${date.toUTCString()}`;
  }

  document.cookie = `${cookieKey}=${cookieValue || ''}${expiryDate}; path=/`;
};

function themeChanger(themeName) {    
  setCookie('mdnTheme', themeName, 30);
  let currentObject =  data[themeName];

  clearClassListAndBodyBg();

  if (!currentObject) {
    // force claro (none) if unknown theme name:
    return;
  }

  insertClassListAndBodyBg(currentObject);
}

function insertClassListAndBodyBg(currentObject) {  
  let themeTitle = currentObject.title;
  if (!themeTitle) return;
  
  let propertiesObjects = getObjectWithoutParents(currentObject.styles, null);
  let propertiesList = getAsAList(propertiesObjects);
  let className = `mdn-Theme--${themeTitle}`;  

    document.documentElement.classList.add(`mdn-Theme`, className);

  let styles = `body { background-color: ${currentObject.bodyStyle.backgroundColor}; }\n`;
  styles += `.${className} {`;
  styles += propertiesList.join(";");
  styles += `}`;

  let styleTag = document.createElement("style");
  styleTag.id = "mdn-Theme-style";
  styleTag.innerText = styles;

  document.body.appendChild(styleTag);

}

function getAsAList(object) {
  let finalArray = [];
  for (const variable in object) {
    finalArray.push(`${variable}:${object[variable]}`);
  }
  return finalArray;
}

function clearClassListAndBodyBg() {
  document.documentElement.classList.remove(`mdn-Theme`);
  let themeStyleTag = document.getElementById(`mdn-Theme-style`);
  themeStyleTag && themeStyleTag.parentNode.removeChild(themeStyleTag);
  for (const variable in data) {
    document.documentElement.classList.remove(`mdn-Theme--${variable}`);
  }
}

function getObjectWithoutParents(currentObject, finalObject) {
  // if(!limitStack) return;
  finalObject = finalObject || {};
  for (const key in currentObject) {
    if (key.match(/^--theme/)) {
      finalObject[key] = currentObject[key];
    } else {
      finalObject = {
        ...getObjectWithoutParents(currentObject[key], finalObject)
      };
    }
  }
  return finalObject;
}

const resolveCurrentProperty = (customProps, properties, name) => {
  let finalClass = '';
  if (!Array.isArray(properties)) return finalClass

  const propKeys = Object.keys(customProps);

  // Check user props inside Component Schema
  for (let i = 0, lgt = propKeys.length; i < lgt; i += 1) {
    const currentPropName = propKeys[i];
    if (customProps[currentPropName] === true) {
      if (
        properties.find(
          (prop) => prop === currentPropName || prop.title === currentPropName
        )
      ) {
        finalClass += `mdn-${name}--${currentPropName} `;
      }
    }
  }

  // If user props does not match Component Schema, find default value:
  if (!finalClass) {
    const defaultValue = properties.find((prop) => prop.isDefault === true);
    if (defaultValue) finalClass += `mdn-${name}--${defaultValue.title} `;
  }

  return finalClass
};

const resolveProps = (props, config, name) => {
  let finalClassName = `mdn-${name} `;

  finalClassName += resolveCurrentProperty(props, config.types, name);
  finalClassName += resolveCurrentProperty(props, config.modifiers, name);
  finalClassName += resolveCurrentProperty(props, config.states, name);

  finalClassName += props.className || '';

  return finalClassName
};

function resolveFns(...fns){
  return (...args) => {
      fns.forEach( fn => fn && fn(...args) );
  }
}

var config$B = {
  types: ['success', 'danger'],
  modifiers: ['light', 'dark']
};
function Alert(props) {
  var children = props.children,
      onClick = props.onClick,
      _props$isOpen = props.isOpen,
      isOpen = _props$isOpen === void 0 ? true : _props$isOpen;
      props.success;
      props.danger;
      props.light;
      props.dark;

  var _React$useState = React__default["default"].useState(isOpen),
      state = _React$useState[0],
      setState = _React$useState[1];

  var handleClick = function handleClick(e) {
    var newState = !state;
    setState(newState);
    onClick && onClick(e);
  };

  React__default["default"].useEffect(function () {
    setState(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$B, 'Alert') + "\n      " + (state ? 'mdn-isOpen' : ''),
    "aria-hidden": state ? 'false' : 'true',
    tabIndex: 0
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Alert-content"
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Text mdn-Text--body"
  }, children)), /*#__PURE__*/React__default["default"].createElement("button", {
    role: "button",
    type: "button",
    className: "mdn-Alert-close mdn-Button mdn-Button--icon mdn-Button--secondary",
    onClick: function onClick(e) {
      return handleClick(e);
    },
    "aria-label": "Button close alert"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-fechar mdn-Icon--sm"
  })));
}
Alert.propTypes = {
  children: PropTypes__default["default"].node.isRequired
};

/* eslint-disable multiline-ternary */
var config$A = {
  types: ['sm', {
    title: 'md',
    isDefault: true
  }, 'lg'],
  modifiers: [],
  state: []
};

function BrandGroup(props) {
  props.sm;
      props.md;
      props.lg;
      var brands = props.brands;
  var displayedBrands = brands == null ? void 0 : brands.filter(function (brand) {
    return (brand == null ? void 0 : brand.isVisible) === true;
  });
  var hidedBrands = brands == null ? void 0 : brands.filter(function (brand) {
    return (brand == null ? void 0 : brand.isVisible) === false;
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$A, 'BrandGroup')
  }, displayedBrands == null ? void 0 : displayedBrands.map(function (brand, index) {
    return /*#__PURE__*/React__default["default"].createElement("figure", {
      key: "displayed_" + index,
      className: "mdn-BrandGroup-image"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      className: "mdn-BrandGroup-image",
      src: brand.src,
      alt: brand.alt
    }), /*#__PURE__*/React__default["default"].createElement("figcaption", {
      className: "mdn-BrandGroup-image-caption mdn-Tooltip mdn-Tooltip--top"
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Text mdn-Text--caption mdn-Text--inverse"
    }, brand.alt)));
  }), hidedBrands.length >= 1 ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-BrandGroup-etc"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-BrandGroup-etc-value"
  }, "+", hidedBrands.length), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-BrandGroup-etc-items mdn-Tooltip mdn-Tooltip--left mdn-Tooltip--content"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-TopicDetails mdn-TopicDetails--brand"
  }, hidedBrands.map(function (brand, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: "etc_" + index,
      className: "mdn-TopicDetails-group"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic mdn-Topic--horizontal mdn-Topic--sm"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic-symbol"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: brand.src,
      alt: brand.alt
    })), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Topic-description"
    }, brand.alt)));
  })))) : '');
}
BrandGroup.propTypes = {
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  brands: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    src: PropTypes__default["default"].string,
    alt: PropTypes__default["default"].string,
    isVisible: PropTypes__default["default"].bool
  }))
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends$8 = unwrapExports(_extends_1);

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutPropertiesLoose$2 = unwrapExports(objectWithoutPropertiesLoose);

var _excluded$E = ["primary", "secondary", "primaryInverse", "secondaryInverse", "global", "icon", "iconName", "md", "sm", "lg", "block", "children", "disabled", "data", "href", "target", "gtm"];
var config$z = {
  types: [{
    title: 'primary',
    isDefault: true
  }, 'secondary', 'primaryInverse', 'secondaryInverse', 'global', 'icon'],
  modifiers: [{
    title: 'md',
    isDefault: true
  }, 'sm', 'lg', 'block'],
  states: ['disabled']
};
function Button(props) {
  props.primary;
      props.secondary;
      props.primaryInverse;
      props.secondaryInverse;
      props.global;
      var icon = props.icon,
      iconName = props.iconName;
      props.md;
      props.sm;
      props.lg;
      props.block;
      var children = props.children,
      disabled = props.disabled;
      props.data;
      var href = props.href,
      target = props.target,
      _props$gtm = props.gtm,
      gtm = _props$gtm === void 0 ? {} : _props$gtm,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$E);

  var TagName = href ? 'a' : 'button';
  var _gtm$gtmClassName = gtm.gtmClassName,
      gtmClassName = _gtm$gtmClassName === void 0 ? '' : _gtm$gtmClassName,
      _gtm$dataGTM = gtm.dataGTM,
      dataGTM = _gtm$dataGTM === void 0 ? {} : _gtm$dataGTM;
  return /*#__PURE__*/React__default["default"].createElement(TagName, _extends$8({}, rest, {
    className: resolveProps(props, config$z, 'Button') + " " + (!!gtmClassName ? gtmClassName : ''),
    disabled: disabled,
    href: href,
    target: target,
    role: href ? 'link' : 'button',
    "aria-label": href ? 'link' : 'button'
  }, dataGTM), " ", icon ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-" + (iconName || 'fechar') + " mdn-Icon--sm "
  }) : children);
}
Button.propTypes = {
  children: PropTypes__default["default"].node,
  disabled: PropTypes__default["default"].bool,
  icon: PropTypes__default["default"].bool,
  primary: PropTypes__default["default"].bool,
  secondary: PropTypes__default["default"].bool,
  primaryInverse: PropTypes__default["default"].bool,
  secondaryInverse: PropTypes__default["default"].bool,
  global: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  iconName: PropTypes__default["default"].string,
  sm: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  block: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].bool,
  href: PropTypes__default["default"].string,
  target: PropTypes__default["default"].string,
  gtm: PropTypes__default["default"].object
};

var config$y = {
  types: [],
  modifiers: [],
  state: []
};

function CopyContainer(props) {
  var value = props.value;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "" + resolveProps(props, config$y, 'CopyContainer'),
    onClick: function onClick() {
      navigator.clipboard.writeText(value);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CopyContainer-content"
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-CopyContainer-content-toCopy mdn-Heading mdn-Heading--xxs",
    "mdn-copycontainer-value": value,
    "mdn-copycontainer-after": "Clique para copiar"
  }, value)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CopyContainer-icon"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-duplicar mdn-Icon--md"
  })));
}
CopyContainer.propTypes = {
  value: PropTypes__default["default"].string.isRequired
};

var _excluded$D = ["dataDivider", "inverse", "vertical", "primary"];
var config$x = {
  types: [{
    title: 'horizontal',
    isDefault: true
  }, 'vertical'],
  modifiers: [{
    title: 'default',
    isDefault: true
  }, 'primary', 'inverse'],
  states: []
};
function Divider(props) {
  props.dataDivider;
      props.inverse;
      props.vertical;
      props.primary;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$D);

  return /*#__PURE__*/React__default["default"].createElement("hr", _extends$8({}, rest, {
    className: resolveProps(props, config$x, 'Divider')
  }));
}
Divider.propTypes = {
  inverse: PropTypes__default["default"].bool,
  primary: PropTypes__default["default"].bool,
  vertical: PropTypes__default["default"].bool,
  dataDivider: PropTypes__default["default"].array
};

var _excluded$C = ["children", "tag", "xxs", "xs", "sm", "md", "xl", "lg", "xxl", "inverse"];
var configs$1 = {
  types: ['inverse'],
  modifiers: ['xxs', 'xs', 'sm', {
    title: 'md',
    isDefault: true
  }, 'lg', 'xl', 'xxl']
};

function Heading(props) {
  var children = props.children,
      tag = props.tag;
      props.xxs;
      props.xs;
      props.sm;
      props.md;
      props.xl;
      props.lg;
      props.xxl;
      props.inverse;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$C);

  var CustomTag = tag || 'h1';
  return /*#__PURE__*/React__default["default"].createElement(CustomTag, _extends$8({}, rest, {
    className: resolveProps(props, configs$1, 'Heading')
  }), children);
}

Heading.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  tag: PropTypes__default["default"].string,
  xxs: PropTypes__default["default"].bool,
  xs: PropTypes__default["default"].bool,
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  xl: PropTypes__default["default"].bool,
  xxl: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  configs: PropTypes__default["default"].shape({
    types: PropTypes__default["default"].arrayOf(PropTypes.string),
    modifiers: PropTypes__default["default"].array
  })
};

var _excluded$B = ["body", "caption", "inverse", "children"];
var config$w = {
  types: [],
  modifiers: ['inverse', 'body', 'caption'],
  states: []
};
function Text(props) {
  props.body;
      props.caption;
      props.inverse;
      var children = props.children,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$B);

  return /*#__PURE__*/React__default["default"].createElement("p", _extends$8({}, rest, {
    className: resolveProps(props, config$w, 'Text')
  }), children);
}
Text.propTypes = {
  body: PropTypes__default["default"].bool,
  caption: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node
};

var _excluded$A = ["brandSrc", "brandHref", "brandAlt", "simpleLight", "children"];
var config$v = {
  types: [{
    title: 'simple',
    isDefault: true
  }],
  modifiers: ['simpleLight'],
  states: []
};
function Header(props) {
  var brandSrc = props.brandSrc,
      brandHref = props.brandHref,
      brandAlt = props.brandAlt,
      simpleLight = props.simpleLight,
      children = props.children,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$A);

  return /*#__PURE__*/React__default["default"].createElement("header", _extends$8({}, rest, {
    className: resolveProps(props, config$v, 'Header'),
    role: "banner"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Header--simple-content"
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: brandHref || '/'
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    className: "mdn-logoSvg",
    src: brandSrc || (simpleLight ? 'https://mondrian.claro.com.br/brands/horizontal/default/claro.svg' : 'https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg'),
    alt: brandAlt || 'Logotipo da Claro'
  })), /*#__PURE__*/React__default["default"].createElement("div", null, children))));
}
Header.propTypes = {
  etc: PropTypes__default["default"].object,
  inverse: PropTypes__default["default"].bool,
  brandSrc: PropTypes__default["default"].string,
  brandAlt: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node,
  brandHref: PropTypes__default["default"].string,
  simpleLight: PropTypes__default["default"].bool
};

var _excluded$z = ["children", "data", "tag", "secondary", "gtm"];

var config$u = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'secondary'],
  modifiers: [{
    title: 'signature',
    isDefault: true
  }, 'bottom']
};
function Footer(props) {
  var children = props.children,
      data = props.data,
      tag = props.tag;
      props.secondary;
      props.gtm;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$z);

  var dataFooter = data;
  var CustomTag = tag || 'footer';
  var isSimple = !(dataFooter != null && dataFooter.social) && !React__default["default"].Children.toArray(children).some(function (x) {
    var _x$type;

    return ((_x$type = x.type) == null ? void 0 : _x$type.name) === 'FooterList';
  });
  var disclaimer = React__default["default"].Children.toArray(children).filter(function (x) {
    return typeof x === 'string';
  });
  return /*#__PURE__*/React__default["default"].createElement(CustomTag, _extends$8({}, rest, {
    className: resolveProps(props, config$u, 'Footer') + " " + (isSimple ? 'mdn-Footer--simple' : ''),
    role: "contentinfo"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Footer-content"
  }, /*#__PURE__*/React__default["default"].createElement(FooterList, _extends$8({
    social: dataFooter == null ? void 0 : dataFooter.social
  }, props)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Footer-disclaimer",
    style: {
      textAlign: !isSimple ? 'center' : 'left'
    }
  }, Boolean(disclaimer.toString().trim()) && /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Text mdn-Text--caption mdn-Text--inverse"
  }, /*#__PURE__*/React__default["default"].createElement("strong", null, children))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Footer-logo"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    className: "mdn-Footer-logo-image",
    src: (dataFooter == null ? void 0 : dataFooter.imageSrc) || 'https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png',
    alt: (dataFooter == null ? void 0 : dataFooter.imageAlt) || 'Logo da Claro'
  })))));
}
function FooterList(_ref) {
  var social = _ref.social,
      _ref$gtm = _ref.gtm,
      gtm = _ref$gtm === void 0 ? {} : _ref$gtm,
      children = _ref.children;
  var componentList = React__default["default"].Children.toArray(children).filter(function (x) {
    var _x$type2;

    return ((_x$type2 = x.type) == null ? void 0 : _x$type2.name) === 'FooterList';
  });

  if (social) {
    return /*#__PURE__*/React__default["default"].createElement("ul", {
      className: "mdn-Footer-list"
    }, social == null ? void 0 : social.map(function (icon, index) {
      //const hasHref =
      var _gtm$gtmClassName = gtm.gtmClassName,
          gtmClassName = _gtm$gtmClassName === void 0 ? "" : _gtm$gtmClassName,
          _gtm$dataGTM = gtm.dataGTM,
          dataGTM = _gtm$dataGTM === void 0 ? {} : _gtm$dataGTM;
      return /*#__PURE__*/React__default["default"].createElement("li", {
        key: index,
        className: "mdn-Footer-list-item"
      }, icon != null && icon.href ? /*#__PURE__*/React__default["default"].createElement("a", _extends$8({
        href: icon.href,
        className: "" + gtmClassName
      }, dataGTM), /*#__PURE__*/React__default["default"].createElement("span", {
        className: "mdn-Icon-" + icon.icon + " mdn-Icon--md"
      })) : /*#__PURE__*/React__default["default"].createElement("span", {
        className: "mdn-Icon-" + icon.icon + " mdn-Icon--md mdn-Text--inverse"
      }));
    }));
  }

  if (!!componentList.length) {
    var child = componentList[0];
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Footer-list"
    }, child.props.children);
  }

  return null;
}
Footer.propTypes = {
  children: PropTypes__default["default"].node,
  secondary: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].object,
  tag: PropTypes__default["default"].string
};

var _excluded$y = ["href", "children", "inverse", "arrow", "gtm"];
var config$t = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'arrow'],
  modifiers: ['inverse'],
  states: []
};
function Link(props) {
  var href = props.href,
      children = props.children;
      props.inverse;
      var arrow = props.arrow,
      _props$gtm = props.gtm,
      gtm = _props$gtm === void 0 ? {} : _props$gtm,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$y);

  var _gtm$gtmClassName = gtm.gtmClassName,
      gtmClassName = _gtm$gtmClassName === void 0 ? '' : _gtm$gtmClassName,
      _gtm$dataGTM = gtm.dataGTM,
      dataGTM = _gtm$dataGTM === void 0 ? {} : _gtm$dataGTM;
  return !arrow ? /*#__PURE__*/React__default["default"].createElement("a", _extends$8({}, rest, {
    href: href
  }, dataGTM, {
    className: "" + resolveProps(props, config$t, 'Link') + gtmClassName
  }), children) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: "" + resolveProps(props, config$t, 'Link')
  }, /*#__PURE__*/React__default["default"].createElement("a", _extends$8({}, rest, {
    className: "mdn-Link-anchor " + gtmClassName,
    href: href
  }, dataGTM), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Link-anchor-label"
  }, children), /*#__PURE__*/React__default["default"].createElement("span", {
    className: 'mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm'
  })));
}
Link.propTypes = {
  config: PropTypes__default["default"].object,
  disabled: PropTypes__default["default"].bool,
  arrow: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  href: PropTypes__default["default"].string,
  gtm: PropTypes__default["default"].object
};

var config$s = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'inverse'],
  modifiers: [],
  state: []
};

function IconGroup(props) {
  props.inverse;
      var icons = props.icons;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$s, 'IconGroup')
  }, icons == null ? void 0 : icons.map(function (icon, index) {
    if (index + 1 === icons.length) {
      return /*#__PURE__*/React__default["default"].createElement("i", {
        key: index,
        className: icon.name + " mdn-Icon--" + icon.size,
        "aria-label": icon.ariaLabel
      });
    }

    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, {
      key: index
    }, /*#__PURE__*/React__default["default"].createElement("i", {
      "aria-label": icon.ariaLabel,
      className: icon.name + " mdn-Icon--" + icon.size
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-IconGroup-plus"
    }, "+"));
  }));
}
IconGroup.propTypes = {
  inverse: PropTypes__default["default"].bool,
  icons: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    name: PropTypes__default["default"].string.isRequired,
    ariaLabel: PropTypes__default["default"].string.isRequired,
    size: PropTypes__default["default"].string.isRequired
  }).isRequired)
};

/* eslint-disable prefer-regex-literals */
class Contract {
  constructor() {
    this.errors = [];
  }

  isRequired(value, message) {
    if (!value || value.length <= 0) {
      this.errors.push(message);
    }
  }

  hasMinLen(value, min, message) {
    if (!value || value.length < min) {
      this.errors.push(message);
    }
  }

  hasMaxLen(value, max, message) {
    if (!value || value.length > max) {
      this.errors.push(message);
    }
  }

  isFixedLen(value, len, message) {
    if (value.length !== len) {
      this.errors.push(message);
    }
  }

  isEmail(value, message) {
    const reg = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    if (!reg.test(value)) {
      this.errors.push(message);
    }
  }

  isCep(value, message) {
    const reg = new RegExp(/^\d{5} - \d{3}$/);
    if (!reg.test(value)) {
      this.errors.push(message);
    }
  }

  isPhone(value, message) {
    const reg = new RegExp(
      /(?:\+?55\s?)?(?:\(?\d{2}\)?[-\s]?)?\d{4,5}[-\s]?\d{4}/g
    );
    if (!reg.test(value)) {
      this.errors.push(message);
    }
  }

  isCpf(value, message) {
    const reg = new RegExp(/^\d{3}\.\d{3}.\d{3}-\d{2}$/g);
    if (!reg.test(value)) {
      this.errors.push(message);
    }
  }

  isHTML(value, message) {
    const reg = new RegExp(/<\/?[\w\s="']+\/?>/gi);
    if (!reg.test(value)) { this.errors.push(message); }
  }

  validateCpf(value, message) {
    let sum = 0;
    let rest = 0;
    const newValue = value.replace(/\D/g, '');
    if (
      newValue === '00000000000' ||
      newValue === '11111111111' ||
      newValue === '22222222222' ||
      newValue === '33333333333' ||
      newValue === '44444444444' ||
      newValue === '55555555555' ||
      newValue === '66666666666' ||
      newValue === '77777777777' ||
      newValue === '88888888888' ||
      newValue === '99999999999'
    ) {
      this.errors.push(message);
    }
    for (let i = 1; i <= 9; i++) {
      sum = sum + parseInt(newValue.substring(i - 1, i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(newValue.substring(9, 10))) {
      return this.errors.push(message)
    }
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum = sum + parseInt(newValue.substring(i - 1, i)) * (12 - i);
    }
    rest = (sum * 10) % 11;
    if (rest === 10 || rest === 11) rest = 0;
    if (rest !== parseInt(newValue.substring(10, 11))) {
      return this.errors.push(message)
    }
  }

  validateCNPJ(value, message) {
    value = value.replace(/[^\d]+/g, '');
    const validTypes =
      typeof value === 'string' ||
      Number.isInteger(value) ||
      Array.isArray(value);

    // Elimina valor em formato inválido
    if (!validTypes) return this.errors.push(message)

    // Guarda um array com todos os dígitos do valor
    const match = value.toString().match(/\d/g);
    const numbers = Array.isArray(match) ? match.map(Number) : [];

    // Valida a quantidade de dígitos
    if (numbers.length !== 14) return this.errors.push(message)

    // Elimina inválidos com todos os dígitos iguais
    const items = [...new Set(numbers)];
    if (items.length === 1) return this.errors.push(message)

    // Cálculo validador
    const calc = (x) => {
      const slice = numbers.slice(0, x);
      let factor = x - 7;
      let sum = 0;

      for (let i = x; i >= 1; i--) {
        const n = slice[x - i];
        sum += n * factor--;
        if (factor < 2) factor = 9;
      }

      const result = 11 - (sum % 11);

      return result > 9 ? 0 : result
    };

    // Separa os 2 últimos dígitos de verificadores
    const digits = numbers.slice(12);

    // Valida 1o. dígito verificador
    const digit0 = calc(12);
    if (digit0 !== digits[0]) return this.errors.push(message)

    // Valida 2o. dígito verificador
    const digit1 = calc(13);
    return digit1 === digits[1]
  }

  clear() {
    this.errors = [];
  }

  isValid() {
    return this.errors.length === 0
  }
}

var _ref, _ref2;
var contract = new Contract();
var config$r = [{
  title: 'email',
  type: 'email',
  tag: 'input',
  fn: function fn(value, message) {
    contract.clear();
    contract.isEmail(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  },
  pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}, {
  title: 'cep',
  tag: 'InputMask',
  type: 'zipcode',
  mask: '99999 - 999',
  pattern: /^\d{5} - \d{3}$/,
  fn: function fn(value, message) {
    contract.clear();
    contract.isCep(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'cpf',
  type: 'text',
  tag: 'InputMask',
  mask: '999.999.999-99',
  pattern: /^\d{3}\.\d{3}.\d{3}-\d{2}$/,
  fn: function fn(value, message) {
    contract.clear();
    contract.validateCpf(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'cnpj',
  tag: 'InputMask',
  mask: '99.999.999/9999-99',
  pattern: /^\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2}$/,
  value: /_| |-|\./g,
  fn: function fn(value, message) {
    contract.clear();
    contract.validateCNPJ(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'cpf-cnpj',
  tag: 'InputMask',
  mask: '999.999.999-99',
  pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
  fn: function fn(value, message) {
    contract.clear();
    value.replace(/\D/g, '').length <= 11 ? contract.validateCpf(value, message) : contract.validateCNPJ(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'cpfCnpj',
  tag: 'InputMask',
  mask: '999.999.999-99',
  pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
  fn: function fn(value, message) {
    contract.clear();
    value.replace(/\D/g, '').length <= 11 ? contract.validateCpf(value, message) : contract.validateCNPJ(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'cpfCnpj',
  tag: 'InputMask',
  mask: '999.999.999-99',
  pattern: /^(\d{3}\.\d{3}.\d{3}-\d{2})|(\d{2}\.\d{3}.\d{3}\/\d{4}-\d{2})$/,
  fn: function fn(value, message) {
    contract.clear();
    value.replace(/\D/g, '').length <= 11 ? contract.validateCpf(value, message) : contract.validateCNPJ(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'phone',
  type: 'tel',
  tag: 'InputMask',
  pattern: '',
  mask: '(99) 9999-9999',
  fn: function fn(value, message) {
    contract.clear();
    contract.isPhone(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'phoneMobile',
  type: 'tel',
  tag: 'InputMask',
  pattern: '',
  mask: '(99) 99999-9999',
  fn: function fn(value, message) {
    contract.clear();
    contract.isPhone(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'phoneFixed',
  type: 'tel',
  tag: 'InputMask',
  pattern: '',
  mask: '(99) 9999-9999',
  fn: function fn(value, message) {
    contract.clear();
    contract.isPhone(value, message);
    return {
      hasError: !contract.isValid(),
      message: message
    };
  }
}, {
  title: 'text',
  type: 'text',
  tag: 'input',
  pattern: ''
}, {
  title: 'email',
  type: 'email',
  tag: 'input',
  pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}, {
  title: 'number',
  pattern: '',
  tag: 'input',
  type: 'number'
}, {
  title: 'password',
  type: 'password',
  tag: 'input',
  pattern: '',
  icons: ['mdn-Icon-ocultar', 'mdn-Icon-exibir']
}, {
  title: 'search',
  pattern: '',
  tag: 'input',
  type: 'search',
  icons: [{
    name: 'mdn-Icon-busca',
    ariaLabel: 'Search'
  }, {
    name: 'mdn-Icon-fechar',
    ariaLabel: 'Search'
  }]
}, {
  title: 'action',
  tag: 'input',
  type: 'text',
  icons: 'mdn-Icon-direita',
  pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}, (_ref = {
  tag: 'textarea',
  title: 'textarea'
}, _ref["tag"] = 'textarea', _ref.pattern = '', _ref), {
  title: 'select',
  pattern: '',
  tag: 'select',
  type: 'select'
}, (_ref2 = {
  tag: 'date',
  title: 'date'
}, _ref2["tag"] = 'date', _ref2.pattern = '', _ref2)];

var _excluded$x = ["value", "errorMessage", "hasError"];
function useInput(props) {
  var _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? 'Por favor, preencha este campo corretamente.' : _props$errorMessage,
      _props$hasError = props.hasError,
      hasError = _props$hasError === void 0 ? false : _props$hasError,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$x);

  var _React$useState = React__default["default"].useState({
    title: 'text',
    type: 'text'
  }),
      inputType = _React$useState[0],
      setInputData = _React$useState[1];

  var _React$useState2 = React__default["default"].useState(value),
      currentValue = _React$useState2[0],
      setCurrentValue = _React$useState2[1];

  var _React$useState3 = React__default["default"].useState(true),
      hidden = _React$useState3[0],
      setHidden = _React$useState3[1];

  var _React$useState4 = React__default["default"].useState(true),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var _React$useState5 = React__default["default"].useState(''),
      mask = _React$useState5[0],
      setMask = _React$useState5[1];

  var _React$useState6 = React__default["default"].useState({
    message: errorMessage,
    hasError: hasError
  }),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  function handleChange(event) {
    var value = event.target.value;
    setCurrentValue(value);
  }

  function beforeMaskedStateChange(_ref) {
    var nextState = _ref.nextState;
    if (!nextState) return nextState;
    var value = nextState.value;
    var newValue = value.replace(/\D/g, '');

    if (inputType.title === 'phone') {
      value = phoneFormat(value);
      newValue.length <= 10 ? setMask('(99) 9999-99999') : setMask('(99) 99999-9999');
    }

    if (inputType.title === 'cpf-cnpj' || inputType.title === 'cpfCnpj') {
      value = cpfCnpjFormat(value);
      newValue.length > 11 ? setMask('99.999.999/9999-99') : setMask('999.999.999-999');
    }

    return _extends$8({}, nextState, {
      value: value
    });
  }

  function phoneFormat(value) {
    var newValue = value.replace(/\D/g, '');
    if (newValue.length < 10) return value;
    if (newValue.length == 10) return newValue.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    return newValue.replace(/^(\d{2})(\d{5})(\d{4})(\d*)$/, '($1) $2-$3');
  }

  function cpfCnpjFormat(value) {
    var newValue = value.replace(/\D/g, '');
    return newValue.length === 11 ? newValue.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2') : value;
  }

  function handleBlur(event) {
    if (typeof inputType.fn !== 'undefined' && typeof inputType.fn === 'function') {
      var isValid = inputType.fn(event.target.value, props == null ? void 0 : props.errorMessage);
      setError({
        hasError: isValid.hasError,
        message: errorMessage
      });
    }

    if (props != null && props.required) {
      var isEmpty = event.target.value.length <= 0;
      setError({
        hasError: isEmpty,
        message: errorMessage
      });
    }
  }

  var fetchInputType = function fetchInputType() {
    var currentInput = config$r.filter(function (it) {
      return Object.keys(props).includes(it.title);
    }).reduce(function (_, item) {
      return _extends$8({}, item);
    }, {}) || InitialState;
    return Promise.resolve(currentInput);
  };

  React__default["default"].useEffect(function () {
    if (!!value) {
      setCurrentValue(value);
    }
  }, [value]);
  React__default["default"].useEffect(function () {
    fetchInputType().then(function (res) {
      setInputData(res);
      setMask(res.mask || mask);
      setLoading(false);
    });
  }, []);

  function renderOption(options) {
    return options == null ? void 0 : options.map(function (option, index) {
      return /*#__PURE__*/React__default["default"].createElement("option", {
        key: index,
        value: option.value
      }, option.label);
    });
  }

  return {
    config: config$r,
    value: value,
    currentValue: currentValue,
    hidden: hidden,
    setHidden: setHidden,
    error: error,
    loading: loading,
    beforeMaskedStateChange: beforeMaskedStateChange,
    handleChange: handleChange,
    handleBlur: handleBlur,
    setCurrentValue: setCurrentValue,
    inputType: inputType,
    renderOption: renderOption,
    mask: mask,
    setMask: setMask,
    rest: rest
  };
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var reactInputMask_production_min = createCommonjsModule(function (module) {
function t(t){return t&&"object"==typeof t&&"default"in t?t.default:t}var e=React__default["default"],n=t(e),i=reactDom__default["default"];var r=t(invariant_1);function a(){return (a=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i]);}return t}).apply(this,arguments)}function o(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,function(t,e){for(var n=Object.getOwnPropertyNames(e),i=0;i<n.length;i++){var r=n[i],a=Object.getOwnPropertyDescriptor(e,r);a&&a.configurable&&void 0===t[r]&&Object.defineProperty(t,r,a);}}(t,e);}function l(t,e){if(null==t)return {};var n,i,r={},a=Object.keys(t);for(i=0;i<a.length;i++)n=a[i],e.indexOf(n)>=0||(r[n]=t[n]);return r}function u(t){return requestAnimationFrame(t)}function s(t){cancelAnimationFrame(t);}function c(t){var e=t.ownerDocument;return e.hasFocus()&&e.activeElement===t}function f(t){return null==t?void 0:t.ownerDocument}function h(t){var e=function(t){var e;return null==(e=f(t))?void 0:e.defaultView}(t);return !!e&&t instanceof e.HTMLElement}function g(t){return e.useCallback((function(){var e=t.current,n="undefined"!=typeof window&&h(e);if(!e||!n)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e}),[t])}function v(t,n){var i,r,a,o,l=e.useRef({start:null,end:null}),f=g(t),h=e.useCallback((function(){return function(t){var e=t.selectionStart,n=t.selectionEnd;return {start:e,end:n,length:n-e}}(f())}),[f]),v=e.useCallback((function(){return l.current}),[]),d=e.useCallback((function(t){var e=f();e&&c(e)&&(!function(t,e,n){void 0===n&&(n=e),t.setSelectionRange(e,n);}(e,t.start,t.end),l.current=h());}),[f,h]),p=e.useCallback((function(){l.current=h();}),[h]),m=(i=p,r=e.useRef(null),a=e.useCallback((function(){null===r.current&&function t(){i(),r.current=u(t);}();}),[i]),o=e.useCallback((function(){s(r.current),r.current=null;}),[]),e.useEffect((function(){r.current&&(o(),a());}),[a,o]),e.useEffect(s,[]),[a,o]),P=m[0],k=m[1];return e.useLayoutEffect((function(){if(n){var t=f();return t.addEventListener("focus",P),t.addEventListener("blur",k),c(t)&&P(),function(){t.removeEventListener("focus",P),t.removeEventListener("blur",k),k();}}})),{getSelection:h,getLastSelection:v,setSelection:d}}function d(t,n){var i=e.useRef(),r=v(i,n),a=r.getSelection,o=r.getLastSelection,l=r.setSelection,u=function(t,n){var i=g(t),r=e.useRef(n);return {getValue:e.useCallback((function(){return i().value}),[i]),getLastValue:e.useCallback((function(){return r.current}),[]),setValue:e.useCallback((function(t){r.current=t;var e=i();e&&(e.value=t);}),[i])}}(i,t),s=u.getValue,c=u.getLastValue,f=u.setValue;return {inputRef:i,getInputState:function(){return {value:s(),selection:a()}},getLastInputState:function(){return {value:c(),selection:o()}},setInputState:function(t){var e=t.value,n=t.selection;f(e),l(n);}}}var p=["disabled","onBlur","onChange","onFocus","onMouseDown","readOnly","value"],m={9:/[0-9]/,a:/[A-Za-z]/,"*":/[A-Za-z0-9]/};var P=function(t){var e=this;this.isCharacterAllowedAtPosition=function(t,n){var i=e.maskOptions.maskPlaceholder;return !!e.isCharacterFillingPosition(t,n)||!!i&&i[n]===t},this.isCharacterFillingPosition=function(t,n){var i=e.maskOptions.mask;if(!t||n>=i.length)return !1;if(!e.isPositionEditable(n))return i[n]===t;var r=i[n];return new RegExp(r).test(t)},this.isPositionEditable=function(t){var n=e.maskOptions,i=n.mask,r=n.permanents;return t<i.length&&-1===r.indexOf(t)},this.isValueEmpty=function(t){return t.split("").every((function(t,n){return !e.isPositionEditable(n)||!e.isCharacterFillingPosition(t,n)}))},this.isValueFilled=function(t){return e.getFilledLength(t)===e.maskOptions.lastEditablePosition+1},this.getDefaultSelectionForValue=function(t){var n=e.getFilledLength(t),i=e.getRightEditablePosition(n);return {start:i,end:i}},this.getFilledLength=function(t){return function(t,e){for(var n=t.length-1;n>=0;n--){if(e(t[n],n))return n}return -1}(t.split(""),(function(t,n){return e.isPositionEditable(n)&&e.isCharacterFillingPosition(t,n)}))+1},this.getStringFillingLengthAtPosition=function(t,n){return t.split("").reduce((function(t,n){return e.insertCharacterAtPosition(t,n,t.length)}),function(t,e){void 0===e&&(e=1);for(var n="",i=0;i<e;i++)n+=t;return n}(" ",n)).length-n},this.getLeftEditablePosition=function(t){for(var n=t;n>=0;n--)if(e.isPositionEditable(n))return n;return null},this.getRightEditablePosition=function(t){for(var n=e.maskOptions.mask,i=t;i<n.length;i++)if(e.isPositionEditable(i))return i;return null},this.formatValue=function(t){var n=e.maskOptions,i=n.maskPlaceholder,r=n.mask;if(!i){for(t=e.insertStringAtPosition("",t,0);t.length<r.length&&!e.isPositionEditable(t.length);)t+=r[t.length];return t}return e.insertStringAtPosition(i,t,0)},this.clearRange=function(t,n,i){if(!i)return t;var r=n+i,a=e.maskOptions,o=a.maskPlaceholder,l=a.mask,u=t.split("").map((function(t,i){var a=e.isPositionEditable(i);return !o&&i>=r&&!a?"":i<n||i>=r?t:a?o?o[i]:"":l[i]})).join("");return e.formatValue(u)},this.insertCharacterAtPosition=function(t,n,i){var r=e.maskOptions,a=r.mask,o=r.maskPlaceholder;if(i>=a.length)return t;var l=e.isCharacterAllowedAtPosition(n,i),u=e.isPositionEditable(i),s=e.getRightEditablePosition(i),c=o&&s?n===o[s]:null,f=t.slice(0,i);!l&&u||(t=f+(l?n:a[i]));return l||u||c||(t=e.insertCharacterAtPosition(t,n,i+1)),t},this.insertStringAtPosition=function(t,n,i){var r=e.maskOptions,a=r.mask,o=r.maskPlaceholder;if(!n||i>=a.length)return t;var l=n.split(""),u=e.isValueFilled(t)||!!o,s=t.slice(i);if(t=l.reduce((function(t,n){return e.insertCharacterAtPosition(t,n,t.length)}),t.slice(0,i)),u)t+=s.slice(t.length-i);else if(e.isValueFilled(t))t+=a.slice(t.length).join("");else {t=s.split("").filter((function(t,n){return e.isPositionEditable(i+n)})).reduce((function(t,n){var i=e.getRightEditablePosition(t.length);return null===i?t:(e.isPositionEditable(t.length)||(t+=a.slice(t.length,i).join("")),e.insertCharacterAtPosition(t,n,t.length))}),t);}return t},this.processChange=function(t,n){var i=e.maskOptions,r=i.mask,a=i.prefix,o=i.lastEditablePosition,l=t.value,u=t.selection,s=n.value,c=n.selection,f=l,h="",g=0,v=0,d=Math.min(c.start,u.start);if(u.end>c.start?(h=f.slice(c.start,u.end),v=(g=e.getStringFillingLengthAtPosition(h,d))?c.length:0):f.length<s.length&&(v=s.length-f.length),f=s,v){if(1===v&&!c.length)d=c.start===u.start?e.getRightEditablePosition(u.start):e.getLeftEditablePosition(u.start);f=e.clearRange(f,d,v);}return f=e.insertStringAtPosition(f,h,d),(d+=g)>=r.length?d=r.length:d<a.length&&!g?d=a.length:d>=a.length&&d<o&&g&&(d=e.getRightEditablePosition(d)),{value:f=e.formatValue(f),enteredString:h,selection:{start:d,end:d}}},this.maskOptions=function(t){var e=t.mask,n=t.maskPlaceholder,i=[];if(!e)return {maskPlaceholder:null,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};if("string"==typeof e){var r=!1,a="";e.split("").forEach((function(t){r||"\\"!==t?(!r&&m[t]||i.push(a.length),a+=t,r=!1):r=!0;})),e=a.split("").map((function(t,e){return -1===i.indexOf(e)?m[t]:t}));}else e.forEach((function(t,e){"string"==typeof t&&i.push(e);}));n&&(n=1===n.length?e.map((function(t,e){return -1!==i.indexOf(e)?t:n})):n.split(""),i.forEach((function(t){n[t]=e[t];})),n=n.join(""));for(var o=i.filter((function(t,e){return t===e})).map((function(t){return e[t]})).join(""),l=e.length-1;-1!==i.indexOf(l);)l--;return {maskPlaceholder:n,prefix:o,mask:e,lastEditablePosition:l,permanents:i}}(t);},k=function(t){function e(){return t.apply(this,arguments)||this}return o(e,t),e.prototype.render=function(){var t=this.props,e=t.children,i=l(t,["children"]);return n.cloneElement(e,i)},e}(n.Component),b=e.forwardRef((function(t,o){var s=t.alwaysShowMask,h=t.children,v=t.mask,m=t.maskPlaceholder,b=t.beforeMaskedStateChange,E=l(t,["alwaysShowMask","children","mask","maskPlaceholder","beforeMaskedStateChange"]);!function(t){var e=t.mask,n=t.maskPlaceholder;e&&n&&1!==n.length&&n.length!==e.length&&r(!1);}(t);var S,C,y=new P({mask:v,maskPlaceholder:m}),w=!!v,O=!E.disabled&&!E.readOnly,V=null!==t.value&&void 0!==t.value,F=(S=w,C=e.useRef(),e.useEffect((function(){C.current=S;})),C.current),L=d(function(t){return ""+t}((V?t.value:t.defaultValue)||""),w),A=L.inputRef,R=L.getInputState,M=L.setInputState,x=L.getLastInputState,D=g(A);if(w&&V){var j=D(),I=j&&c(j)||s||t.value?y.formatValue(t.value):t.value;b&&(I=b({nextState:{value:I,selection:{start:null,end:null}}}).value),M(a({},x(),{value:I}));}var q=x(),N=q.selection,B=q.value;e.useLayoutEffect((function(){if(w){var t=c(D()),e=N,n=R(),i=a({},n);if(!V){var r=n.value,o=y.formatValue(r),l=y.isValueEmpty(o);!l||t||s?i.value=o:l&&!t&&(i.value="");}t&&!F?i.selection=y.getDefaultSelectionForValue(i.value):V&&t&&e&&null!==e.start&&null!==e.end&&(i.selection=e),b&&(i=b({currentState:n,nextState:i})),M(i);}}));var T=a({},E,{onFocus:function(e){A.current=e.target;var n=R().value;if(w&&!y.isValueFilled(n)){var i=y.formatValue(n),r=y.getDefaultSelectionForValue(i),a={value:i,selection:r};b&&(i=(a=b({currentState:R(),nextState:a})).value,r=a.selection),M(a),i!==n&&t.onChange&&t.onChange(e),u((function(){M(x());}));}t.onFocus&&t.onFocus(e);},onBlur:function(e){var n=R().value,i=x().value;if(w&&!s&&y.isValueEmpty(i)){var r="",a={value:r,selection:{start:null,end:null}};b&&(r=(a=b({currentState:R(),nextState:a})).value),M(a),r!==n&&t.onChange&&t.onChange(e);}t.onBlur&&t.onBlur(e);},onChange:w&&O?function(e){var n=R(),i=x(),r=y.processChange(n,i);b&&(r=b({currentState:n,previousState:i,nextState:r})),M(r),t.onChange&&t.onChange(e);}:t.onChange,onMouseDown:w&&O?function(e){var n=D(),i=R().value,r=f(n);if(!c(n)&&!y.isValueFilled(i)){var o=e.clientX,l=e.clientY,u=(new Date).getTime();r.addEventListener("mouseup",(function t(e){if(r.removeEventListener("mouseup",t),c(n)){var i=Math.abs(e.clientX-o),s=Math.abs(e.clientY-l),f=Math.max(i,s),h=(new Date).getTime()-u;if(f<=10&&h<=200||f<=5&&h<=300){var g=x(),v=a({},g,{selection:y.getDefaultSelectionForValue(g.value)});M(v);}}}));}t.onMouseDown&&t.onMouseDown(e);}:t.onMouseDown,ref:function(t){A.current=i.findDOMNode(t),!function(t){return "function"==typeof t}(o)?null!==o&&"object"==typeof o&&(o.current=t):o(t);},value:w&&V?B:t.value});return h?(function(t,e){p.filter((function(n){return null!=e.props[n]&&e.props[n]!==t[n]})).length&&r(!1);}(t,h),n.createElement(k,T,h)):n.createElement("input",T)}));b.displayName="InputMask",b.defaultProps={alwaysShowMask:!1,maskPlaceholder:"_"},module.exports=b;
});

var reactInputMask = createCommonjsModule(function (module) {
/* eslint-disable import/no-unresolved */

{
  module.exports = reactInputMask_production_min;
}
});

var _excluded$w = ["parentProps", "parentClassName", "className", "options", "disabled", "email", "cep", "cpf", "textarea", "cnpj", "phone", "cpfCnpj", "phoneMobile", "phoneFixed", "text", "date", "number", "password", "search", "action", "select", "required", "id", "onChange", "onBlur", "isDisabled", "children", "actionProps", "buttonProps", "errorMessage", "hasError"],
    _excluded2 = ["buttonClasses", "buttonLabel", "buttonClick"];

var InternalInput = function InternalInput(props, ref) {
  var _props$parentProps = props.parentProps,
      parentProps = _props$parentProps === void 0 ? '' : _props$parentProps,
      _props$parentClassNam = props.parentClassName,
      parentClassName = _props$parentClassNam === void 0 ? '' : _props$parentClassNam,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      options = props.options,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.email;
      props.cep;
      props.cpf;
      props.textarea;
      props.cnpj;
      props.phone;
      props.cpfCnpj;
      props.phoneMobile;
      props.phoneFixed;
      props.text;
      props.date;
      props.number;
      props.password;
      props.search;
      props.action;
      props.select;
      var _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      id = props.id,
      onChange = props.onChange,
      onBlur = props.onBlur,
      isDisabled = props.isDisabled,
      children = props.children;
      props.actionProps;
      var _props$buttonProps = props.buttonProps,
      buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps;
      props.errorMessage;
      props.hasError;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$w);

  var _useInput = useInput(props),
      config = _useInput.config,
      currentValue = _useInput.currentValue,
      hidden = _useInput.hidden,
      error = _useInput.error,
      inputType = _useInput.inputType,
      handleChange = _useInput.handleChange,
      handleBlur = _useInput.handleBlur,
      setHidden = _useInput.setHidden,
      setCurrentValue = _useInput.setCurrentValue,
      beforeMaskedStateChange = _useInput.beforeMaskedStateChange,
      mask = _useInput.mask;

  var inputId = id || "input__" + new Date().valueOf().toString().match(/\d{6}$/)[0];

  var _buttonProps$buttonCl = buttonProps.buttonClasses,
      buttonClasses = _buttonProps$buttonCl === void 0 ? '' : _buttonProps$buttonCl;
      buttonProps.buttonLabel;
      var _buttonProps$buttonCl2 = buttonProps.buttonClick,
      buttonClick = _buttonProps$buttonCl2 === void 0 ? function () {} : _buttonProps$buttonCl2,
      buttonRest = _objectWithoutPropertiesLoose$2(buttonProps, _excluded2);

  var renderInputField = function renderInputField() {
    var _extends2, _extends3, _extends4;

    var fields = {
      textarea: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("textarea", _extends$8({}, rest, {
        className: 'mdn-Input-field ' + (className || ''),
        "data-mdn-type": inputType.title,
        onChange: resolveFns(handleChange, onChange),
        ref: ref,
        onBlur: resolveFns(handleBlur, onBlur),
        disabled: isDisabled || disabled
      })), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: id,
        className: "mdn-Input-label"
      }, children)),
      password: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, {
        id: inputId,
        className: 'mdn-Input-field ' + (className || ''),
        type: hidden ? 'password' : 'text',
        "data-mdn-type": "password",
        ref: ref,
        onChange: resolveFns(handleChange, onChange),
        onBlur: resolveFns(handleBlur, onBlur),
        required: required,
        disabled: isDisabled || disabled
      })), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children), /*#__PURE__*/React__default["default"].createElement("button", {
        className: "mdn-Input-action",
        "data-mdn-action": "reveal-password",
        onClick: resolveFns(function () {
          return setHidden(!hidden);
        }, buttonClick),
        type: "button",
        role: "button"
      }, /*#__PURE__*/React__default["default"].createElement("span", {
        "aria-label": (hidden ? 'Ocultar senha' : 'Exibir senha') + " ",
        className: (hidden ? 'mdn-Icon-exibir' : 'mdn-Icon-ocultar') + " mdn-Icon--md"
      }))),
      action: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, {
        className: "mdn-Input-field " + className + " ",
        "data-mdn-type": inputType.title,
        type: "text",
        id: inputId,
        ref: ref,
        required: required,
        onChange: resolveFns(handleChange, onChange),
        onBlur: resolveFns(handleBlur, onBlur),
        disabled: isDisabled || disabled
      })), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children), /*#__PURE__*/React__default["default"].createElement("button", _extends$8({
        className: "mdn-Input-action " + buttonClasses,
        onClick: resolveFns(buttonClick),
        type: "button",
        "aria-label": "Enviar"
      }, buttonRest), /*#__PURE__*/React__default["default"].createElement("span", {
        className: "mdn-Icon-direita mdn-Icon--md"
      }))),
      date: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, (_extends2 = {
        mask: mask,
        maskPlaceholder: '_',
        ref: ref,
        id: inputId,
        "data-mdn-type": inputType == null ? void 0 : inputType.title,
        className: "mdn-Input-field" //{ + (props?.className || '')}
        ,
        type: inputType == null ? void 0 : inputType.title
      }, _extends2["data-mdn-type"] = inputType.title, _extends2.value = currentValue, _extends2.onChange = resolveFns(handleChange, onChange), _extends2.onBlur = resolveFns(handleBlur, onBlur), _extends2.disabled = isDisabled || disabled, _extends2))), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children)),
      "default": /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(reactInputMask, _extends$8({}, rest, (_extends3 = {
        mask: mask,
        maskPlaceholder: '_',
        ref: ref,
        id: inputId,
        "data-mdn-type": inputType == null ? void 0 : inputType.title,
        className: "mdn-Input-field" //{ + (props?.className || '')}
        ,
        type: inputType == null ? void 0 : inputType.type
      }, _extends3["data-mdn-type"] = inputType.title, _extends3.value = currentValue, _extends3.required = required, _extends3.onChange = resolveFns(handleChange, onChange), _extends3.onBlur = resolveFns(handleBlur, onBlur), _extends3.disabled = isDisabled || disabled, _extends3.beforeMaskedStateChange = beforeMaskedStateChange, _extends3))), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children)),
      search: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, (_extends4 = {
        id: inputId,
        className: "mdn-Input-field",
        type: "text",
        ref: ref
      }, _extends4["id"] = inputId, _extends4["data-mdn-type"] = "search", _extends4.onChange = resolveFns(handleChange, onChange), _extends4.onBlur = resolveFns(handleBlur, onBlur), _extends4.value = currentValue, _extends4))), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children), /*#__PURE__*/React__default["default"].createElement("button", {
        onClick: resolveFns(function () {
          return setCurrentValue('');
        }, buttonClick),
        className: "mdn-Input-action",
        type: "button",
        role: "button"
      }, /*#__PURE__*/React__default["default"].createElement("span", {
        className: (!currentValue ? 'mdn-Icon-busca' : 'mdn-Icon-fechar') + " mdn-Icon--md",
        "aria-label": "Search"
      }))),
      select: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("select", _extends$8({}, rest, {
        className: 'mdn-Input-field ' + (className || ''),
        "data-mdn-type": inputType.title,
        id: inputId,
        onChange: resolveFns(handleChange, onChange),
        value: currentValue,
        ref: ref,
        onBlur: resolveFns(handleBlur, onBlur),
        disabled: isDisabled || disabled
      }), options == null ? void 0 : options.map(function (option, index) {
        return /*#__PURE__*/React__default["default"].createElement("option", {
          key: index,
          value: option.value
        }, option.label);
      })), /*#__PURE__*/React__default["default"].createElement("label", {
        htmlFor: inputId,
        className: "mdn-Input-label"
      }, children))
    };
    return fields[inputType.title] || fields["default"];
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, parentProps, {
    className: (resolveProps(props, config, 'Input') + " " + parentClassName + "\n          " + (currentValue ? 'mdn-Input--activatedField' : '') + "\n          " + (error.hasError ? 'mdn-Input--attentionField' : '')).replace(/\s{2,}/g, ' ').trim()
  }), renderInputField(), /*#__PURE__*/React__default["default"].createElement("small", {
    className: "mdn-Input-errorFeedback"
  }, error.message));
};

var Input = /*#__PURE__*/React__default["default"].forwardRef(InternalInput);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inheritsLoose = createCommonjsModule(function (module) {
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inheritsLoose$1 = unwrapExports(inheritsLoose);

function clearProps(props) {
  const dirtyProps = [
    'lg',
    'md',
    'sm',
    'horizontal',
    'highlight',
    'scroll',
    'body',
    'secondary',
    'primary',
    'proportion-3-2',
    'global',
    'block',
    'xxl',
    'proportion-1-1',
    'proportion-3-4',
    'proportion-1-2',
    'text',
    'email',
    'cep',
    'cpf',
    'cnpj',
    'cpf-cnpj',
    'phone',
    'email',
    'number',
    'password',
    'search',
    'textarea',
    'rate',
    'select',
    'action',
    'date',
    'phone-mobile',
    'phone-fixed',
    'image',
    'icon'
  ];

  const cleanedProps = {};
  for (let i = 0, lgt = dirtyProps.length; i < lgt; i++) {
    cleanedProps[dirtyProps[i]] = undefined;
  }
  return Object.assign({}, props, cleanedProps)
}

var _excluded$v = ["children", "fluid", "className"];

var Container = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Container, _React$Component);

  function Container(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.config = {
      types: [],
      modifiers: [],
      states: []
    };
    return _this;
  }

  var _proto = Container.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        fluid = _this$props.fluid,
        className = _this$props.className;
        _objectWithoutPropertiesLoose$2(_this$props, _excluded$v);

    var props = clearProps(this.props);
    return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, props, {
      className: (fluid ? 'mdn-Container-fluid ' : 'mdn-Container ') + (className || '')
    }), children);
  };

  return Container;
}(React__default["default"].Component);
Container.propTypes = {
  children: PropTypes__default["default"].node
};

var _excluded$u = ["children"];

var Row = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Row, _React$Component);

  function Row(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.config = {
      types: [],
      modifiers: [],
      states: []
    };
    return _this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children;
        _objectWithoutPropertiesLoose$2(_this$props, _excluded$u);

    var props = clearProps(this.props);
    return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, props, {
      className: resolveProps(this.props, this.config, 'Row')
    }), children);
  };

  return Row;
}(React__default["default"].Component);
Row.propTypes = {
  children: PropTypes__default["default"].node
};

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _assertThisInitialized$1 = unwrapExports(assertThisInitialized);

var _excluded$t = ["children"];

var Col = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Col, _React$Component);

  function Col(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.renderCols = _this.renderCols.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = Col.prototype;

  _proto.getColsProperties = function getColsProperties(allProps) {
    var colProps = [];
    allProps.map(function (currentProp) {
      var prefix = currentProp.match(/([a-z]{2})-(\d+)/);
      prefix = prefix ? prefix[1] : prefix;
      var suffix = currentProp.match(/([a-z]{2})-(\d+)/);
      suffix = suffix ? suffix[2] : suffix;

      if (prefix && suffix && prefix.match(/sm|md|lg|xs/) && !isNaN(Number(suffix))) {
        colProps.push(currentProp);
      }
    });
    return colProps;
  };

  _proto.renderCols = function renderCols(props) {
    var className = '';
    props = props || {}; // props always an object

    props = Object.keys(props); // getting object keys list [key, key, key] or []

    props = this.getColsProperties(props); // filtering props and getting only props of Col type

    props.map(function (prop) {
      className += "mdn-Col-" + prop + " ";
    });
    return className + " " + (this.props.className || '');
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children;
        _objectWithoutPropertiesLoose$2(_this$props, _excluded$t);

    var props = clearProps(this.props);
    return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, props, {
      className: this.renderCols(this.props)
    }), children);
  };

  return Col;
}(React__default["default"].Component);
Col.propTypes = {
  children: PropTypes__default["default"].node
};

var _excluded$s = ["config", "onOpen", "onClick", "data", "dataAccordion"];

var configs = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'onlyChild'],
  modifiers: [],
  states: []
};
function Accordion(props) {
  var config = props.config;
      props.onOpen;
      props.onClick;
      var data = props.data,
      dataAccordion = props.dataAccordion,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$s);

  var _React$useState = React__default["default"].useState({
    data: data || dataAccordion,
    currentOpenedIndex: null
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  React__default["default"].useEffect(function () {
    setState(function (prev) {
      return _extends$8({}, prev, {
        data: props.data.map(function (item, idx) {
          if (idx === prev.currentOpenedIndex) {
            return _extends$8({}, item, {
              isOpen: prev.data[idx].isOpen
            });
          } else {
            return _extends$8({}, item);
          }
        })
      });
    });
  }, [props.data, state.currentOpenedIndex]);

  var handleKeyPress = function handleKeyPress(e, index) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleBoxClick(e, index);
    }
  };

  var handleBoxClick = function handleBoxClick(e, index) {
    var data = state.data;
    var onOpen = config == null ? void 0 : config.onOpen;
    var onClose = config == null ? void 0 : config.onClose;
    var currentOpenedIndex = state.currentOpenedIndex;

    if (currentOpenedIndex !== null && currentOpenedIndex >= 0 && currentOpenedIndex !== index) {
      data[currentOpenedIndex].isOpen = false;
      onClose && onClose(e, currentOpenedIndex);
    }

    var isOpen = !data[index].isOpen;
    data[index].isOpen = isOpen; // eslint-disable-next-line object-curly-spacing

    setState(_extends$8({}, state, {
      currentOpenedIndex: index
    }));
    isOpen && onOpen && onOpen(e, index);
    !isOpen && onClose && onClose(e, index);
  };

  var renderAccordion = function renderAccordion(dataAccordion) {
    return dataAccordion == null ? void 0 : dataAccordion.map(function (item, index) {
      var _item$gtmClassName = item.gtmClassName,
          gtmClassName = _item$gtmClassName === void 0 ? '' : _item$gtmClassName,
          _item$dataGTM = item.dataGTM,
          dataGTM = _item$dataGTM === void 0 ? {} : _item$dataGTM;
      return /*#__PURE__*/React__default["default"].createElement("div", {
        key: index,
        "aria-label": "Acordion clic\xE1vel para expandir o conte\xFAdo",
        tabIndex: 0,
        onKeyPress: function onKeyPress(e) {
          return handleKeyPress(e, index);
        },
        className: "mdn-Accordion-box  " + (item.isOpen ? ' is-expanded' : '') + " "
      }, /*#__PURE__*/React__default["default"].createElement("a", _extends$8({
        className: "mdn-Accordion-toggle mdn-Text mdn-Text--body " + gtmClassName,
        role: "button",
        "aria-controls": "content-" + index
      }, dataGTM, {
        onClick: function onClick(e) {
          handleBoxClick(e, index);
        }
      }, item.props), item.title, /*#__PURE__*/React__default["default"].createElement("span", {
        className: "mdn-Accordion-icon mdn-Icon-baixo mdn-Icon--lg"
      })), /*#__PURE__*/React__default["default"].createElement("div", {
        className: "mdn-Accordion-content"
      }, item.content));
    });
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, configs, 'Accordion'),
    "aria-label": "Accordion Control Group"
  }), renderAccordion(state.data));
}
Accordion.propTypes = {
  config: PropTypes__default["default"].shape({
    data: PropTypes__default["default"].shape({
      title: PropTypes__default["default"].string,
      content: PropTypes__default["default"].content
    }),
    onOpen: PropTypes__default["default"].func,
    onClose: PropTypes__default["default"].func
  }),
  data: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
  dataAccordion: PropTypes__default["default"].shape({
    title: PropTypes__default["default"].string,
    content: PropTypes__default["default"].content
  }),
  className: PropTypes__default["default"].string
};

var _excluded$r = ["imageSrc", "imageAlt", "notificationCount", "sm", "md", "lg"];
var config$q = {
  types: [{
    title: 'sm',
    isDefault: true
  }, 'md', 'lg'],
  modifiers: ['picture', 'action']
};

var renderNotication = function renderNotication(notificationCount) {
  notificationCount = Number(notificationCount);
  if (notificationCount === 0) return '';
  var content = '';

  if (notificationCount > 0 && notificationCount <= 9) {
    content = notificationCount;
  } else if (notificationCount > 9) {
    content = '+9';
  }

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Avatar-notification mdn-Avatar-notification"
  }, content);
};

function Avatar(props) {
  var imageSrc = props.imageSrc,
      imageAlt = props.imageAlt,
      notificationCount = props.notificationCount;
      props.sm;
      var md = props.md,
      lg = props.lg,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$r);

  var spanClassName = 'sm';

  if (md) {
    spanClassName = 'md';
  } else if (lg) {
    spanClassName = 'lg';
  }

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$q, 'Avatar')
  }), imageSrc ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Avatar-image"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: imageSrc || config$q && config$q.imageSrc,
    alt: imageAlt || config$q && config$q.imageAlt,
    role: "img"
  })) : /*#__PURE__*/React__default["default"].createElement("span", {
    className: 'mdn-Avatar-icon mdn-Icon-minha-claro mdn-Icon--' + spanClassName
  }), (notificationCount || (config$q || {}).notificationCount) && renderNotication(notificationCount || config$q.notificationCount));
}
Avatar.propTypes = {
  imageSrc: PropTypes__default["default"].string,
  imageAlt: PropTypes__default["default"].string,
  notificationCount: PropTypes__default["default"].number,
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  config: PropTypes__default["default"].object,
  picture: PropTypes__default["default"].bool
};

var _excluded$q = ["id", "parentId", "className", "parentClassName", "name", "value", "checked", "inverse", "children", "disabled", "onChange", "parentProps", "hasError", "errorMessage"];
var config$p = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: ['inverse'],
  states: []
};

var Checkbox = function Checkbox(props) {
  var id = props.id;
      props.parentId;
      props.className;
      var parentClassName = props.parentClassName;
      props.name;
      props.value;
      var _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked;
      props.inverse;
      var children = props.children,
      disabled = props.disabled,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      parentProps = props.parentProps,
      _props$hasError = props.hasError,
      hasError = _props$hasError === void 0 ? false : _props$hasError,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? 'Por favor, preencha este campo corretamente.' : _props$errorMessage,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$q);

  var _React$useState = React__default["default"].useState(checked),
      isCheck = _React$useState[0],
      setIsCheck = _React$useState[1];

  var _input = React__default["default"].useRef(null);

  var _React$useState2 = React__default["default"].useState({
    message: errorMessage,
    // erroMessage
    hasError: hasError
  }),
      error = _React$useState2[0];

  React__default["default"].useEffect(function () {
    setIsCheck(checked);
    _input.current.checked = checked;
  }, [checked]);

  var handleChange = function handleChange(e) {
    var status = !isCheck;
    _input.current.checked = status;
    setIsCheck(status);
    !!onChange && onChange(status);
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleChange();
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({
    tabIndex: 0,
    "aria-label": "checkbox",
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    },
    className: resolveProps(props, config$p, 'Checkbox') + " " + (parentClassName || '') + "\n        " + (error.hasError ? 'mdn-Checkbox--attentionField' : '')
  }, parentProps), /*#__PURE__*/React__default["default"].createElement("input", _extends$8({
    className: "mdn-Checkbox-input",
    id: id,
    type: "checkbox",
    ref: _input,
    onChange: function onChange(e) {
      return handleChange();
    },
    disabled: disabled
  }, rest)), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-Checkbox-label",
    htmlFor: id
  }), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-Checkbox-text",
    htmlFor: id
  }, children), !error.hasError ? '' : /*#__PURE__*/React__default["default"].createElement("small", {
    className: "mdn-Input-errorFeedback"
  }, error.message));
};
Checkbox.propTypes = {
  id: PropTypes__default["default"].string,
  parentId: PropTypes__default["default"].string,
  className: PropTypes__default["default"].string,
  parentClassName: PropTypes__default["default"].string,
  name: PropTypes__default["default"].string,
  value: PropTypes__default["default"].string,
  checked: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  disabled: PropTypes__default["default"].bool,
  config: PropTypes__default["default"].object,
  hasError: PropTypes__default["default"].bool,
  parentProps: PropTypes__default["default"].string,
  errorMessage: PropTypes__default["default"].string,
  onChange: PropTypes__default["default"].func,
  error: PropTypes__default["default"].shape({
    message: PropTypes__default["default"].string,
    hasError: PropTypes__default["default"].bool
  })
};

var _excluded$p = ["highlight", "feedback", "hat", "category", "reverse", "medium", "inverse", "children"];
var config$o = {
  types: [{
    title: 'highlight',
    isDefault: true
  }, 'feedback', 'hat', 'reverse', 'category', 'medium', 'inverse'],
  modifiers: [//mdn-Tag--default
  {
    title: 'default',
    isDefault: true
  }, 'inverse', 'medium'],
  states: []
};
function Tag(props) {
  props.highlight;
      var feedback = props.feedback;
      props.hat;
      props.category;
      var reverse = props.reverse;
      props.medium;
      props.inverse;
      var children = props.children,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$p);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$o, 'Tag')
  }), feedback && !reverse && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Tag-icon mdn-Icon-informacoes mdn-Icon--sm"
  }), /*#__PURE__*/React__default["default"].createElement("p", null, children), feedback && reverse && /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Tag-icon mdn-Icon-informacoes mdn-Icon--sm"
  }));
}
Tag.propTypes = {
  feedback: PropTypes__default["default"].bool,
  highlight: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  hat: PropTypes__default["default"].bool,
  category: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  reverse: PropTypes__default["default"].bool,
  medium: PropTypes__default["default"].bool,
  etc: PropTypes__default["default"].object
};

var _excluded$o = ["id", "value", "disabled", "inverse", "checked", "parentId", "parentClassName", "onChange"];
var config$n = {
  types: [],
  modifiers: [{
    title: 'default',
    isDefault: true
  }, 'inverse'],
  states: []
};

var Toggle = function Toggle(props) {
  var id = props.id,
      value = props.value,
      disabled = props.disabled;
      props.inverse;
      var _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked;
      props.parentId;
      var parentClassName = props.parentClassName,
      _onChange = props.onChange,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$o);

  var _useState = React.useState(!!checked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var _input = React__default["default"].useRef(null);

  React__default["default"].useEffect(function () {
    setIsChecked(!!checked);
    _input.current.checked = !!checked;
  }, [props.checked]);

  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleToggle();
    }
  };

  var handleToggle = function handleToggle(disabled) {
    if (disabled === void 0) {
      disabled = false;
    }

    if (disabled) return;
    var status = !isChecked;
    setIsChecked(status);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: props.parentId,
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    },
    className: resolveProps(props, config$n, 'Toggle') + ' ' + (parentClassName || ''),
    onClick: function onClick() {
      return handleToggle(disabled);
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Toggle-list"
  }, /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, {
    id: id,
    className: "mdn-Toggle-item mdn-Toggle-item-primary",
    type: "checkbox",
    role: "checkbox",
    ref: _input,
    onChange: function onChange(e) {
      return !!_onChange && _onChange(e, isChecked);
    },
    value: value || isChecked,
    checked: isChecked,
    disabled: disabled
  })), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-Toggle-button",
    htmlFor: id
  })));
};
Toggle.propTypes = {
  etc: PropTypes__default["default"].object,
  parentId: PropTypes__default["default"].string,
  disabled: PropTypes__default["default"].bool,
  id: PropTypes__default["default"].string,
  inverse: PropTypes__default["default"].bool,
  parentClassName: PropTypes__default["default"].string,
  checked: PropTypes__default["default"].bool,
  onChange: PropTypes__default["default"].func,
  value: PropTypes__default["default"].string
};

/* eslint-disable multiline-ternary */
var config$m = {
  types: [],
  modifiers: [{
    title: 'default',
    isDefault: true
  }, 'inverse'],
  states: []
};

var Spinner = function Spinner(props) {
  var isLoading = props.isLoading;
      props.inverse;

  var _useState = React.useState(!!isLoading),
      loading = _useState[0];

  return loading ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$m, 'Spinner')
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-claro mdn-Icon--lg"
  })) : '';
};
Spinner.propTypes = {
  isLoading: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool
};

var _excluded$n = ["id", "parentId", "className", "inverse", "parentClassName", "name", "value", "children", "defaultChecked", "currentValue", "onClick", "onChange", "checked", "parentProps"];
var config$l = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: ['inverse'],
  states: []
};
function Radio(props) {
  var _extends2;

  var id = props.id,
      parentId = props.parentId,
      className = props.className;
      props.inverse;
      var parentClassName = props.parentClassName,
      name = props.name,
      value = props.value,
      children = props.children,
      defaultChecked = props.defaultChecked,
      _props$currentValue = props.currentValue,
      currentValue = _props$currentValue === void 0 ? '' : _props$currentValue;
      props.onClick;
      var onChange = props.onChange,
      _props$checked = props.checked,
      checked = _props$checked === void 0 ? false : _props$checked,
      parentProps = props.parentProps,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$n);

  var _input = React__default["default"].useRef(null);

  if (checked) {
    currentValue = value;
  }

  if (defaultChecked) {
    currentValue = value;
  } // const initialState


  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 32 || e.charCode === 13) {
      !!onChange && onChange(_input.current.value);
    }
  };

  var handleChange = function handleChange(value) {
    !!onChange && onChange(value);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, parentProps, {
    id: parentId,
    tabIndex: 0,
    onClick: function onClick() {
      return !!onChange && onChange(_input.current.value);
    },
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    },
    htmlFor: id,
    className: resolveProps(props, config$l, 'Radio') + ' ' + (parentClassName || ''),
    "aria-label": "Radio button"
  }), /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, (_extends2 = {
    className: "mdn-Radio-input",
    type: "radio",
    id: id,
    ref: _input,
    name: name || id
  }, _extends2["className"] = 'mdn-Radio-input ' + (className || ''), _extends2.onChange = function onChange() {
    return handleChange(value);
  }, _extends2.checked = currentValue === value, _extends2.value = value, _extends2.role = "radio", _extends2["aria-label"] = "Radio button", _extends2))), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-Radio-label",
    htmlFor: id
  }), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-Radio-text",
    htmlFor: id
  }, children));
}
Radio.propTypes = {
  parentId: PropTypes__default["default"].string,
  className: PropTypes__default["default"].string,
  parentClassName: PropTypes__default["default"].string,
  name: PropTypes__default["default"].string,
  id: PropTypes__default["default"].string,
  value: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node,
  disabled: PropTypes__default["default"].bool,
  checked: PropTypes__default["default"].bool,
  config: PropTypes__default["default"].object,
  onChange: PropTypes__default["default"].func,
  onClick: PropTypes__default["default"].func,
  defaultChecked: PropTypes__default["default"].bool,
  currentValue: PropTypes__default["default"].string,
  inverse: PropTypes__default["default"].bool,
  parentProps: PropTypes__default["default"].string
};

var _excluded$m = ["icon", "children", "target", "inverse", "disabled", "href"];
var config$k = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: ['inverse'],
  states: []
};
function Shortcut(props) {
  var icon = props.icon,
      children = props.children,
      target = props.target;
      props.inverse;
      var disabled = props.disabled,
      href = props.href,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$m);

  return /*#__PURE__*/React__default["default"].createElement("a", _extends$8({}, rest, {
    className: resolveProps(props, config$k, 'Shortcut'),
    href: href,
    target: target,
    disabled: disabled
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: 'mdn-Shortcut-icon mdn-Icon-' + icon + ' mdn-Icon--md'
  }), /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Shortcut-text"
  }, children));
}
Shortcut.propTypes = {
  icon: PropTypes__default["default"].string,
  inverse: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  config: PropTypes__default["default"].object,
  disabled: PropTypes__default["default"].bool,
  href: PropTypes__default["default"].string
};

var _excluded$l = ["inverse", "children", "title", "className"];
var config$j = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'inverse'],
  modifiers: [],
  states: []
};

var Collapse = function Collapse(props) {
  props.inverse;
      var children = props.children,
      title = props.title,
      className = props.className,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$l);

  var _useState = React.useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _collapse = React__default["default"].useRef(null);

  var togglePanel = function togglePanel(e) {
    var currentState = !isOpen;
    setIsOpen(currentState);
  };

  var handleKeyPress = function handleKeyPress(e) {
    if (e.charCode === 32 || e.charCode === 13) {
      togglePanel();
    }
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    ref: _collapse,
    onKeyPress: function onKeyPress(e) {
      return handleKeyPress(e);
    },
    tabIndex: 0,
    className: resolveProps(props, config$j, 'Collapse') + " " + (isOpen ? ' mdn-Collapse-active ' : '') + " " + (className || '')
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Collapse-box",
    onClick: togglePanel
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: "mdn-Collapse-toggle mdn-Text mdn-Text--body"
  }, title, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Collapse-icon mdn-Icon-baixo mdn-Icon--md"
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Collapse-content"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Container mdn-u-color--secondary"
  }, children)));
};
Collapse.propTypes = {
  children: PropTypes__default["default"].node,
  title: PropTypes__default["default"].string,
  inverse: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].bool
};

var _excluded$k = ["value", "isVisible", "progress"];
var config$i = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: ['inverse'],
  states: []
};

var renderPercentage = function renderPercentage(value, progress) {
  var percentage = value * 100 / progress;
  return percentage;
};

var renderProgressbar = function renderProgressbar(value, progress, isVisible) {
  if (isVisible) {
    var sliderValueBar = renderPercentage(value, progress);
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-ProgressBar-percent",
      style: {
        left: sliderValueBar.toFixed(2) + '%'
      }
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-ProgressBar-percentText mdn-Heading"
    }, sliderValueBar.toFixed(0), "%")), /*#__PURE__*/React__default["default"].createElement("progress", {
      role: "progressbar",
      className: "mdn-ProgressBar-fill",
      value: value,
      max: progress
    }));
  }
};

function ProgressBar(props) {
  var value = props.value,
      isVisible = props.isVisible,
      progress = props.progress,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$k);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$i, 'ProgressBar'),
    style: {
      visibility: isVisible ? 'visible' : 'hidden'
    }
  }), renderProgressbar(value, progress, isVisible));
}
ProgressBar.propTypes = {
  value: PropTypes__default["default"].number,
  progress: PropTypes__default["default"].number,
  config: PropTypes__default["default"].object,
  isVisible: PropTypes__default["default"].bool
};

var config$h = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: [],
  states: [],
  starsLength: 5
};

var useRating = function useRating() {
  var renderRatingStars = function renderRatingStars(currentRate) {
    return currentRate && rateReadOnly(currentRate);
  };

  var rateReadOnly = function rateReadOnly(index, readOnly) {
    if (!readOnly) {
      return;
    }

    var decimalBR = String(index).replace('.', ',');
    return /*#__PURE__*/React__default["default"].createElement("h3", {
      className: "mdn-RatingStars-rate mdn-Heading mdn-Heading--sm"
    }, decimalBR);
  };

  var getType = function getType(currentRate, index) {
    var value = currentRate - index;
    if (value >= 0.7) return 'avaliacao';
    if (value < 0.7 && value >= 0.3) return 'avaliacao-meia';
    return 'avaliacao-vazia';
  };

  var renderTotalRating = function renderTotalRating(readOnly, children) {
    if (!readOnly) {
      return;
    }

    return /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-RatingStars-evaluation mdn-Text mdn-Text--caption "
    }, children);
  };

  return {
    config: config$h,
    getType: getType,
    renderRatingStars: renderRatingStars,
    rateReadOnly: rateReadOnly,
    renderTotalRating: renderTotalRating
  };
};

function RatingStars(props) {
  var rate = props.rate,
      readOnly = props.readOnly,
      children = props.children;

  var _useRating = useRating(),
      config = _useRating.config,
      rateReadOnly = _useRating.rateReadOnly,
      renderTotalRating = _useRating.renderTotalRating,
      getType = _useRating.getType;

  var _React$useState = React__default["default"].useState(rate),
      currentRate = _React$useState[0],
      setcurrentRate = _React$useState[1];

  var rest = clearProps(props);

  var handleKeyPress = function handleKeyPress(e, ratingValue, type) {
    if (e.charCode === 32 || e.charCode === 13) {
      handleStarsValue(ratingValue, type);
    }
  };

  var firstStar = function firstStar(ratingValue, type) {
    if (type !== 'avaliacao-vazia' || type !== 'meia-avaliacao') {
      setcurrentRate(1);
    }

    if (type !== 'avaliacao-vazia') {
      setcurrentRate(0);
    }
  };

  var middleStar = function middleStar(ratingValue, type) {
    setcurrentRate(ratingValue, readOnly);
  };

  var lastStar = function lastStar(ratingValue, type) {
    if (type !== 'avaliacao-vazia' || type !== 'meia-avaliacao') {
      setcurrentRate(5);
    }

    if (type === 'avaliacao') {
      setcurrentRate(0);
    }
  };

  var handleStarsValue = function handleStarsValue(ratingValue, type) {
    if (ratingValue !== 1 && ratingValue !== 5) middleStar(ratingValue);

    if (ratingValue === 1) {
      firstStar(ratingValue, type);
    }

    if (ratingValue === 5) lastStar(ratingValue, type);
  };

  var renderStars = function renderStars(readOnly, rate) {
    var stars = Array.from({
      length: 5
    }).map(function (_, index) {
      var _React$createElement;

      var ratingValue = index + 1;
      var type = getType(currentRate, index);
      return /*#__PURE__*/React__default["default"].createElement("span", (_React$createElement = {
        key: ratingValue,
        tabIndex: 0,
        className: 'mdn-Icon-' + type + ' mdn-Icon--sm mdn-Rating Stars-star'
      }, _React$createElement["key"] = ratingValue, _React$createElement["aria-label"] = type, _React$createElement.onKeyPress = function onKeyPress(e) {
        return handleKeyPress(e, ratingValue, type);
      }, _React$createElement.onClick = function onClick() {
        return handleStarsValue(ratingValue, type);
      }, _React$createElement));
    });
    return stars;
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config, 'RatingStars'),
    "data-mdn-rate": currentRate,
    tabIndex: 0
  }), rateReadOnly(currentRate, readOnly), /*#__PURE__*/React__default["default"].createElement("label", {
    className: "mdn-RatingStars-check",
    "aria-label": currentRate + " de " + config.starsLength + " avalia\xE7\xF5es"
  }, renderStars()), renderTotalRating(readOnly, children));
}
RatingStars.propTypes = {
  children: PropTypes__default["default"].node,
  rate: PropTypes__default["default"].number,
  readOnly: PropTypes__default["default"].bool,
  config: PropTypes__default["default"].object
};

var _excluded$j = ["data", "disabled", "inverse"];
var config$g = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: ['inverse'],
  states: []
};

var renderLinkList = function renderLinkList(props, disabled) {
  if (!props) return;
  var listItems = props.map(function (link, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: "mdn-LinkList-item"
    }, /*#__PURE__*/React__default["default"].createElement("a", _extends$8({}, link.linkProps, {
      className: "mdn-LinkList-anchor",
      target: link.target,
      href: link.href,
      disabled: link.isDisabled || disabled
    }), link.title));
  });
  return listItems;
};

function LinkList(props) {
  var data = props.data,
      disabled = props.disabled;
      props.inverse;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$j);

  return /*#__PURE__*/React__default["default"].createElement("ul", _extends$8({}, rest, {
    className: resolveProps(props, config$g, 'LinkList')
  }), renderLinkList(data, disabled));
}
LinkList.propTypes = {
  disabled: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].array,
  config: PropTypes__default["default"].object
};

var _excluded$i = ["onChange", "min", "max", "value", "step", "disabled", "id", "parentClassName"];
var config$f = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: [],
  states: []
};
function Slider(props) {
  var onChange = props.onChange,
      min = props.min,
      max = props.max,
      value = props.value,
      step = props.step,
      disabled = props.disabled,
      id = props.id,
      parentClassName = props.parentClassName,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$i);

  var _useState = React.useState(value),
      sliderValue = _useState[0],
      setSliderValue = _useState[1];

  min = min || 0;
  max = max || 100;
  step = step || 1;
  value = value || min;

  onChange = onChange || function () {};

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setSliderValue(value);
  };

  var renderPercentage = function renderPercentage(min, max) {
    var percentage = (sliderValue - min) * 100 / (max - min);
    return percentage;
  };

  var sliderValuePercentage = renderPercentage(min, max) + '%';

  var renderSlider = function renderSlider(props, step, min, max, _onChange, disabled) {
    var sliderValueBar = renderPercentage(min, max) + '%';
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Slider-contentBar"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-Slider-barRange",
      style: {
        width: sliderValueBar
      },
      htmlFor: id
    }), /*#__PURE__*/React__default["default"].createElement("input", _extends$8({}, rest, {
      className: "mdn-Slider-bar",
      type: "range",
      value: sliderValue,
      step: step,
      min: min,
      max: max,
      disabled: disabled,
      onChange: function onChange(evt) {
        handleChange(evt);

        _onChange(evt, evt.target.value);
      }
    })));
  };

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$f, 'Slider') + "  " + parentClassName,
    disabled: disabled
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Slider-percent"
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Slider-percentText mdn-Heading",
    style: {
      left: sliderValuePercentage,
      transform: "translateX(-" + sliderValuePercentage + ")"
    }
  }, sliderValue), /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Slider-percentText--init mdn-Heading"
  }, min), /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Slider-percentText--final mdn-Heading"
  }, max)), renderSlider(props, step, min, max, onChange, disabled));
}
Slider.propTypes = {
  onChange: PropTypes__default["default"].func,
  parentClassName: PropTypes__default["default"].string,
  config: PropTypes__default["default"].object,
  min: PropTypes__default["default"].number,
  max: PropTypes__default["default"].number,
  value: PropTypes__default["default"].number,
  step: PropTypes__default["default"].number,
  disabled: PropTypes__default["default"].bool
};

var _excluded$h = ["data", "inverse", "dataSteps", "xs", "sm", "md", "lg", "scroll", "darkest"];
var config$e = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'darkest'],
  modifiers: ['xs', 'sm', 'md', 'lg', 'scroll'],
  states: []
};

var renderListStep = function renderListStep(steps, props) {
  var list = steps.map(function (value, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: "mdn-Steps-list-item mdn-Steps-list-item--" + value.status + (value.status === 'disabled' ? 'mdn-Steps-list-item--disabled' : '')
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      className: 'mdn-Steps-text mdn-Heading ' + (props.inverse || props.darkest ? 'mdn-Heading--inverse' : '')
    }, value.title));
  });
  return list;
};

function Steps(props) {
  var data = props.data;
      props.inverse;
      var dataSteps = props.dataSteps;
      props.xs;
      props.sm;
      props.md;
      props.lg;
      props.scroll;
      props.darkest;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$h);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$e, 'Steps')
  }), /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "mdn-Steps-list"
  }, renderListStep(data || dataSteps, props)));
}
Steps.propTypes = {
  dataSteps: PropTypes__default["default"].array,
  inverse: PropTypes__default["default"].bool,
  "default": PropTypes__default["default"].bool,
  xs: PropTypes__default["default"].bool,
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  scroll: PropTypes__default["default"].bool,
  darkest: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    title: PropTypes__default["default"].string,
    status: PropTypes__default["default"].string
  })).isRequired
};

var _MIME;

var multiplies = {
  'mdn-Image--3-2': 2 / 3,
  'mdn-Image--1-1': 1 / 1,
  'mdn-Image--3-4': 4 / 3,
  'mdn-Image--1-2': 2 / 1
};
var config$d = {
  types: [],
  mainImg: '',
  modifiers: ['proportion-3-2', 'proportion-1-1', 'proportion-3-4', 'proportion-1-2'],
  states: []
};
var MIME = (_MIME = {
  jpg: 'image/jpeg',
  apng: 'image/apng',
  gif: 'image/gif'
}, _MIME["jpg"] = 'image/jpeg', _MIME.jpeg = 'image/jpeg', _MIME.jfif = 'image/jpeg', _MIME.pjpeg = 'image/jpeg', _MIME.pjp = 'image/jpeg', _MIME.png = 'image/jpeg', _MIME.svg = 'image/svg+xml', _MIME.webp = 'image/webp', _MIME);
function useImage() {
  var _React$useState = React__default["default"].useState({
    width: 'auto',
    height: 'auto'
  }),
      style = _React$useState[0],
      setStyle = _React$useState[1];

  var getImagetype = function getImagetype(src) {
    var _MIME$ext;

    var ext = src.substring(src.lastIndexOf(".") + 1);
    return (_MIME$ext = MIME[ext]) != null ? _MIME$ext : MIME.jpeg;
  };

  var resizeComponent = function resizeComponent() {};

  var handleImageLoaded = function handleImageLoaded(event, proportion) {
    var width = event.target.clientWidth;
    setStyle({
      width: width + "px",
      height: width * multiplies[proportion] + "px"
    });
  };

  return {
    style: style,
    handleImageLoaded: handleImageLoaded,
    getImagetype: getImagetype,
    resizeComponent: resizeComponent,
    config: config$d,
    multiplies: multiplies
  };
}

var _excluded$g = ["src", "srcMobile", "srcTablet", "alt", "fallback", "ariaHidden", "lazy", "webp", "gtm"];
function Image(props) {
  var src = props.src,
      srcMobile = props.srcMobile,
      srcTablet = props.srcTablet,
      alt = props.alt;
      props.fallback;
      var ariaHidden = props.ariaHidden,
      lazy = props.lazy,
      webp = props.webp,
      _props$gtm = props.gtm,
      gtm = _props$gtm === void 0 ? {
    className: ''
  } : _props$gtm,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$g);

  var imageRef = React__default["default"].useRef(null);

  var _useImage = useImage(),
      config = _useImage.config,
      style = _useImage.style,
      handleImageLoaded = _useImage.handleImageLoaded,
      getImagetype = _useImage.getImagetype;

  var className = resolveProps(props, config, 'Image').replace(/proportion-/g, '');
  var proportion = className.replace(/mdn-Image ?/, '').replace(/ /, '');
  var fixedProps = clearProps(rest);
  var type = getImagetype(src);
  var hasProportion = Object.keys(props).find(function (it) {
    return config.modifiers.includes(it);
  });
  return /*#__PURE__*/React__default["default"].createElement("picture", _extends$8({}, fixedProps, {
    "aria-hidden": !!ariaHidden,
    ref: imageRef,
    style: !!hasProportion ? {
      width: style.width,
      height: style.height
    } : {},
    className: className
  }), webp ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("source", _extends$8({
    srcSet: webp.srcSetMobileWebp,
    media: "(max-width: 768px)",
    type: "image/webp"
  }, gtm, {
    className: "mdn-Image-asset " + gtm.className
  })), /*#__PURE__*/React__default["default"].createElement("source", _extends$8({
    srcSet: webp.srcSetTabletWebp,
    media: "(max-width: 991px)",
    type: "image/webp"
  }, gtm, {
    className: "mdn-Image-asset " + gtm.className
  }))) : '', /*#__PURE__*/React__default["default"].createElement("source", _extends$8({
    srcSet: srcMobile || src,
    media: "(max-width: 768px)",
    type: type
  }, gtm, {
    className: "mdn-Image-asset " + gtm.className
  })), /*#__PURE__*/React__default["default"].createElement("source", _extends$8({
    srcSet: srcTablet || src,
    media: "(max-width: 991px)",
    type: type
  }, gtm, {
    className: "mdn-Image-asset " + gtm.className
  })), /*#__PURE__*/React__default["default"].createElement("img", _extends$8({
    src: src,
    alt: alt,
    onLoad: function onLoad(event) {
      return handleImageLoaded(event, proportion);
    },
    loading: lazy ? 'lazy' : 'eager',
    type: type
  }, gtm, {
    className: "mdn-Image-asset " + gtm.className
  })));
}
Image.propTypes = {
  src: PropTypes__default["default"].string.isRequired,
  fallback: PropTypes__default["default"].string,
  srcMobile: PropTypes__default["default"].string,
  srcTablet: PropTypes__default["default"].string,
  alt: PropTypes__default["default"].string.isRequired,
  data: PropTypes__default["default"].object,
  lazy: PropTypes__default["default"].bool,
  ariaHidden: PropTypes__default["default"].bool,
  webp: PropTypes__default["default"].shape({
    srcSetMobileWebp: PropTypes__default["default"].string,
    srcSetTabletWebp: PropTypes__default["default"].string
  }),
  'proportion-3-2': PropTypes__default["default"].bool,
  'proportion-1-1': PropTypes__default["default"].bool,
  'proportion-3-4': PropTypes__default["default"].bool,
  'proportion-1-2': PropTypes__default["default"].bool
};

var _excluded$f = ["right", "backgroundColorToken", "backgroundImageSrc", "children"];
var config$c = {
  types: [// pode ser string ou objeto caso necessite de alguma config especifica
  {
    title: 'left',
    isDefault: true
  }, 'right'],
  modifiers: [{
    title: 'white',
    isDefault: true
  }, 'transparent'],
  states: []
};
function Banner(props) {
  var right = props.right,
      backgroundColorToken = props.backgroundColorToken,
      backgroundImageSrc = props.backgroundImageSrc,
      children = props.children,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$f);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    tabIndex: 0,
    className: resolveProps(props, config$c, 'Banner') + ' mdn-Banner--slide'
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Banner-wrapper"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Banner-item",
    style: {
      backgroundImage: "url(" + backgroundImageSrc + ")",
      backgroundColor: "" + backgroundColorToken
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Container"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: right ? 'mdn-Row mdn-u-justifyContent-xs-end' : 'mdn-Row'
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Col-xs-12 mdn-Col-md-6"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Banner-shape"
  }, children)))))));
}
Banner.propTypes = {
  children: PropTypes__default["default"].node,
  backgroundImageSrc: PropTypes__default["default"].string,
  right: PropTypes__default["default"].bool,
  backgroundColorToken: PropTypes__default["default"].string
};

var _excluded$e = ["horizontal", "vertical", "inverse", "icon", "iconSrc", "number", "sm", "md", "lg", "fixedIcon", "children"];
var config$b = {
  types: [{
    title: 'horizontal',
    isDefault: true
  }, 'vertical', 'inverse', 'icon', 'number'],
  modifiers: [{
    title: 'sm',
    isDefault: true
  }, 'md', 'lg'],
  states: []
};
function Topic(props) {
  props.horizontal;
      var vertical = props.vertical;
      props.inverse;
      var icon = props.icon;
      props.iconSrc;
      var number = props.number;
      props.sm;
      props.md;
      props.lg;
      var fixedIcon = props.fixedIcon,
      children = props.children,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$e);

  var _icon = fixedIcon || icon;

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$b, 'Topic') + (vertical ? ' mdn-Topic--icon' : '')
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Topic-symbol"
  }, _icon ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-" + _icon + " mdn-Icon--md"
  }) : null, number && !fixedIcon ? number : null), typeof children === 'string' ? /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Topic-description"
  }, children) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Topic-description"
  }, children));
}
Topic.propTypes = {
  horizontal: PropTypes__default["default"].bool,
  vertical: PropTypes__default["default"].bool,
  inverse: PropTypes__default["default"].bool,
  icon: PropTypes__default["default"].string,
  iconSrc: PropTypes__default["default"].bool,
  number: PropTypes__default["default"].number,
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool,
  lg: PropTypes__default["default"].bool,
  fixedIcon: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node
};

var config$a = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'inverse'],
  modifiers: ["brand"],
  state: []
};

function TopicDetails(props) {
  var data = props.data;
      props.inverse;
  var hasBrand = Object.keys(props).find(function (t) {
    return t === 'brand';
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config$a, 'TopicDetails')
  }, !hasBrand ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, data == null ? void 0 : data.map(function (topic, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: "topic_" + index,
      className: "mdn-TopicDetails-group"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic mdn-Topic--horizontal mdn-Topic--sm"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic-symbol"
    }, /*#__PURE__*/React__default["default"].createElement("i", {
      className: topic.icon.name + " mdn-Icon--" + topic.icon.size
    })), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Topic-description"
    }, topic.description)), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Text mdn-Text--body"
    }, topic.body));
  })) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, data == null ? void 0 : data.map(function (topic, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: "topic_" + index,
      className: "mdn-TopicDetails-group"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic mdn-Topic--horizontal mdn-Topic--sm"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Topic-symbol"
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: topic.brand.src,
      alt: topic.brand.alt
    })), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Topic-description"
    }, topic.description)), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Text mdn-Text--body"
    }, topic.body));
  })));
}

TopicDetails.propTypes = {
  inverse: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].array
};

/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend$2(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject$2(src[key]) &&
            isObject$2(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend$2(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend$2(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend$2(win, ssrWindow);
    return win;
}

/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/* eslint-disable no-proto */
function makeReactive(obj) {
  var proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get: function get() {
      return proto;
    },
    set: function set(value) {
      proto.__proto__ = value;
    }
  });
}

var Dom7 = /*#__PURE__*/function (_Array) {
  _inheritsLoose(Dom7, _Array);

  function Dom7(items) {
    var _this;

    _this = _Array.call.apply(_Array, [this].concat(items)) || this;
    makeReactive(_assertThisInitialized(_this));
    return _this;
  }

  return Dom7;
}( /*#__PURE__*/_wrapNativeSuper(Array));

function arrayFlat(arr) {
  if (arr === void 0) {
    arr = [];
  }

  var res = [];
  arr.forEach(function (el) {
    if (Array.isArray(el)) {
      res.push.apply(res, arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  var uniqueArray = [];

  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  var a = [];
  var res = context.querySelectorAll(selector);

  for (var i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  var window = getWindow();
  var document = getDocument();
  var arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    var html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      var toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      var tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (var i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

function addClass() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList;

    (_el$classList = el.classList).add.apply(_el$classList, classNames);
  });
  return this;
}

function removeClass() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    var _el$classList2;

    (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
  });
  return this;
}

function toggleClass() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  this.forEach(function (el) {
    classNames.forEach(function (className) {
      el.classList.toggle(className);
    });
  });
}

function hasClass() {
  for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    classes[_key4] = arguments[_key4];
  }

  var classNames = arrayFlat(classes.map(function (c) {
    return c.split(' ');
  }));
  return arrayFilter(this, function (el) {
    return classNames.filter(function (className) {
      return el.classList.contains(className);
    }).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
  }

  return this;
}

function on() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line


      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  var events = eventType.split(' ');
  var j;

  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });

        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  var events = eventType.split(' ');

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger() {
  var window = getWindow();

  for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var events = args[0].split(' ');
  var eventData = args[1];

  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];

    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];

      if (window.CustomEvent) {
        var evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter(function (data, dataIndex) {
          return dataIndex > 0;
        });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  var dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles = this.styles();

      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      var _styles2 = this.styles();

      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    var window = getWindow();
    var document = getDocument();
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window ? window.scrollY : el.scrollTop;
    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  var window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css(props, value) {
  var window = getWindow();
  var i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach(function (el, index) {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  var result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  var window = getWindow();
  var document = getDocument();
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  var child = this[0];
  var i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    var returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append() {
  var newChild;
  var document = getDocument();

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  var document = getDocument();
  var i;
  var j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);

    el = _next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    var el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);

    el = _prev;
  }

  return $(prevEls);
}

function parent(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  var parents = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line

    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }

      _parent = _parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  var closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  var foundElements = [];

  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);

    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  var children = []; // eslint-disable-line

  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].children;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  transform: transform,
  transition: transition$1,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd$1,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  styles: styles,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  filter: filter,
  remove: remove
};
Object.keys(Methods).forEach(function (methodName) {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }

  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle$1(el) {
  var window = getWindow();
  var style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }

  var window = getWindow();
  var matrix;
  var curTransform;
  var transformMatrix;
  var curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$1() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];

  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });

      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function bindModuleMethods(instance, obj) {
  Object.keys(obj).forEach(function (key) {
    if (isObject$1(obj[key])) {
      Object.keys(obj[key]).forEach(function (subKey) {
        if (typeof obj[key][subKey] === 'function') {
          obj[key][subKey] = obj[key][subKey].bind(instance);
        }
      });
    }

    instance[key] = obj[key];
  });
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.');
}

function createElementIfNotDefined($container, params, createElements, checkProps) {
  var document = getDocument();

  if (createElements) {
    Object.keys(checkProps).forEach(function (key) {
      if (!params[key] && params.auto === true) {
        var element = document.createElement('div');
        element.className = checkProps[key];
        $container.append(element);
        params[key] = element;
      }
    });
  }

  return params;
}

var support;

function calcSupport() {
  var window = getWindow();
  var document = getDocument();
  return {
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
    observer: function checkObserver() {
      return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
    }(),
    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;

      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

var device;

function calcDevice(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      userAgent = _ref.userAgent;

  var support = getSupport();
  var window = getWindow();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel'; // iPadOs 13 fix

  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }

  if (!device) {
    device = calcDevice(overrides);
  }

  return device;
}

var browser;

function calcBrowser() {
  var window = getWindow();

  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

var supportsResizeObserver = function supportsResizeObserver() {
  var window = getWindow();
  return typeof window.ResizeObserver !== 'undefined';
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    extend$1(swiper, {
      resize: {
        observer: null,
        createObserver: function createObserver() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.resize.observer = new ResizeObserver(function (entries) {
            var width = swiper.width,
                height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function (_ref) {
              var contentBoxSize = _ref.contentBoxSize,
                  contentRect = _ref.contentRect,
                  target = _ref.target;
              if (target && target !== swiper.el) return;
              newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });

            if (newWidth !== width || newHeight !== height) {
              swiper.resize.resizeHandler();
            }
          });
          swiper.resize.observer.observe(swiper.el);
        },
        removeObserver: function removeObserver() {
          if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
            swiper.resize.observer.unobserve(swiper.el);
            swiper.resize.observer = null;
          }
        },
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },
  on: {
    init: function init(swiper) {
      var window = getWindow();

      if (swiper.params.resizeObserver && supportsResizeObserver()) {
        swiper.resize.createObserver();
        return;
      } // Emit resize


      window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

      window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy(swiper) {
      var window = getWindow();
      swiper.resize.removeObserver();
      window.removeEventListener('resize', swiper.resize.resizeHandler);
      window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var Observer = {
  attach: function attach(target, options) {
    if (options === void 0) {
      options = {};
    }

    var window = getWindow();
    var swiper = this;
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }

      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!swiper.support.observer || !swiper.params.observer) return;

    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();

      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    } // Observe container


    swiper.observer.attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    swiper.observer.attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};
var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      observer: _extends$7({}, Observer, {
        observers: []
      })
    });
  },
  on: {
    init: function init(swiper) {
      swiper.observer.init();
    },
    destroy: function destroy(swiper) {
      swiper.observer.destroy();
    }
  }
};

var modular = {
  useParams: function useParams(instanceParams) {
    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName]; // Extend params

      if (module.params) {
        extend$1(instanceParams, module.params);
      }
    });
  },
  useModules: function useModules(modulesParams) {
    if (modulesParams === void 0) {
      modulesParams = {};
    }

    var instance = this;
    if (!instance.modules) return;
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      } // Module create callback


      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  }
};

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;

    function onceHandler() {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners) return self;
    var events;
    var data;
    var context;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(data));
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  extend$1(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children("." + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  });
  var slidesNumberEvenToRows;

  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }

    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  } // Calc slides


  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);

    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;

      if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
        row = Math.floor(slideIndexInGroup / columnsInGroup);
        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - column * slidesPerColumn;

        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
          row += 1;

          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }

      slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = getComputedStyle(slide[0]);
      var currentTransform = slide[0].style.transform;
      var currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide$ = slide[0],
              clientWidth = _slide$.clientWidth,
              offsetWidth = _slide$.offsetWidth;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: swiper.virtualSize + params.spaceBetween + "px"
    });
  }

  if (params.setWrapperSize) {
    var _$wrapperEl$css;

    $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
  }

  if (params.slidesPerColumn > 1) {
    var _$wrapperEl$css2;

    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

    if (params.centeredSlides) {
      newSlidesGrid = [];

      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }

      snapGrid = newSlidesGrid;
    }
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    newSlidesGrid = [];

    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    var _slides$filter$css;

    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    _allSlidesSize -= params.spaceBetween;

    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  extend$1(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides.filter(function (el) {
        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
      })[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      swiper.visibleSlides.each(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }

  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

    if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

      if (isVisible) {
        swiper.visibleSlides.push(slide);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  var swiper = this;

  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  extend$1(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
  var activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  extend$1(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest("." + params.slideClass)[0];
  var slideFound = false;
  var slideIndex;

  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }

  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  var currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (translateBounds === void 0) {
    translateBounds = true;
  }

  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    var isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }

    swiper.emit('slideChangeTransitionStart');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex,
      params = swiper.params;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  var dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }

    swiper.emit('slideChangeTransitionEnd');

    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    var indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    var isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex]; // Update progress

  swiper.updateProgress(translate); // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGird = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGird) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = -translate;

    if (rtl) {
      t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
    }

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
    } else {
      // eslint-disable-next-line
      if (wrapperEl.scrollTo) {
        var _wrapperEl$scrollTo;

        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }

  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      enabled = swiper.enabled;
  if (!enabled) return swiper;
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  var translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    snapGrid.forEach(function (snap) {
      if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
  }

  var prevIndex;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }

  if (runCallbacks === void 0) {
    runCallbacks = true;
  }

  if (threshold === void 0) {
    threshold = 0.5;
  }

  var swiper = this;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
        nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
      nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
  var slides = $wrapperEl.children("." + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }

      slides = $wrapperEl.children("." + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (el, index) {
    var slide = $(el);

    if (index < swiper.loopedSlides) {
      appendSlides.push(el);
    }

    if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
      prependSlides.push(el);
    }

    slide.attr('data-swiper-slide-index', index);
  });

  for (var _i = 0; _i < appendSlides.length; _i += 1) {
    $wrapperEl.append($(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
    $wrapperEl.prepend($(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  swiper.emit('beforeLoopFix');
  var activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;

    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;
  $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }

  var newActiveIndex = activeIndex + 1;

  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }

    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var baseLength = swiper.slides.length;

  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }

  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }

  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  var slidesBuffer = [];

  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if (typeof slides === 'object' && 'length' in slides) {
    for (var _i = 0; _i < slides.length; _i += 1) {
      if (slides[_i]) $wrapperEl.append(slides[_i]);
    }

    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
    $wrapperEl.append(slidesBuffer[_i2]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;
  var activeIndexBuffer = activeIndex;

  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children("." + params.slideClass);
  }

  var newActiveIndex = activeIndexBuffer;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }

    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && swiper.support.observer)) {
    swiper.update();
  }

  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }

  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  var swiper = this;
  var document = getDocument();
  var window = getWindow();
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

  if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
    $targetEl = $(event.path[0]);
  }

  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  extend$1(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($targetEl.is(data.focusableElements)) preventDefault = false;

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = getDocument();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;

    if (data.isTouched) {
      extend$1(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      enabled = swiper.enabled;
  if (!enabled) return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  var touchEndTime = now();
  var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();
        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeModeMomentumVelocityRatio;
      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;
      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide;

        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeModeSticky) {
          // If freeModeSticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(function () {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      swiper.emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    return;
  } // Find current slide


  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];

  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  } // Find current slide size


  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    if (rtlTranslate) {
      swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollLeft;
    }
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === -0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

var dummyEventAttached = false;

function dummyEventListener() {}

function attachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
        passive: false,
        capture: capture
      } : capture);
      el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }

      if (!dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.addEventListener('mousedown', swiper.onTouchStart, false);
      document.addEventListener('mousemove', swiper.onTouchMove, capture);
      document.addEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.addEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.addEventListener('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper.on('observerUpdate', onResize, true);
  }
}

function detachEvents() {
  var swiper = this;
  var document = getDocument();
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device,
      support = swiper.support;
  var capture = !!params.nested; // Touch Events

  if (!support.touch && support.pointerEvents) {
    el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
    document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
    document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
  } else {
    if (support.touch) {
      var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
        passive: true,
        capture: false
      } : false;
      el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
      el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

      if (touchEvents.cancel) {
        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
      }
    }

    if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
      el.removeEventListener('mousedown', swiper.onTouchStart, false);
      document.removeEventListener('mousemove', swiper.onTouchMove, capture);
      document.removeEventListener('mouseup', swiper.onTouchEnd, false);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el.removeEventListener('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl.removeEventListener('scroll', swiper.onScroll);
  } // Resize handler


  swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
      params = swiper.params,
      $el = swiper.$el;
  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

  if (breakpointOnlyParams) {
    ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
      var paramValue = breakpointOnlyParams[param];
      if (typeof paramValue === 'undefined') return;

      if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
        breakpointOnlyParams[param] = 'auto';
      } else if (param === 'slidesPerView') {
        breakpointOnlyParams[param] = parseFloat(paramValue);
      } else {
        breakpointOnlyParams[param] = parseInt(paramValue, 10);
      }
    });
  }

  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = params.slidesPerColumn > 1;
  var isMultiRow = breakpointParams.slidesPerColumn > 1;
  var wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(params.containerModifierClass + "multirow");

    if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
      $el.addClass(params.containerModifierClass + "multirow-column");
    }

    swiper.emitContainerClasses();
  }

  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  extend$1(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }

  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = getWindow();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }

    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });

  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia("(min-width: " + value + "px)").matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if (typeof item === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el,
      device = swiper.device,
      support = swiper.support; // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': support.pointerEvents && !support.touch
  }, {
    'free-mode': params.freeMode
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'multirow': params.slidesPerColumn > 1
  }, {
    'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }], params.containerModifierClass);
  classNames.push.apply(classNames, suffixes);
  $el.addClass([].concat(classNames).join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var window = getWindow();
  var image;

  function onReady() {
    if (callback) callback();
  }

  var isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var params = swiper.params;
  var wasLocked = swiper.isLocked;
  var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

  if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
    swiper.isLocked = lastSlidePosition <= swiper.size;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked; // events

  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    if (swiper.navigation) swiper.navigation.update();
  }
}

var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: false,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  // NS
  containerModifierClass: 'swiper-container-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
var prototypes = {
  modular: modular,
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};
var extendedDefaults = {};

var Swiper$2 = /*#__PURE__*/function () {
  function Swiper() {
    var el;
    var params;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      var swipers = [];
      $(params.el).each(function (containerEl) {
        var newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    } // Swiper Instance


    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];

    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }

    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];

      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) return;

        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
          params[moduleParamName] = {
            auto: true
          };
        }

        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true
          };
        }

        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }

        if (!params[moduleParamName]) params[moduleParamName] = {
          enabled: false
        };
      }
    }); // Extend defaults with modules params

    var swiperParams = extend$1({}, defaults);
    swiper.useParams(swiperParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    extend$1(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];

        if (swiper.support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        }

        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }); // Install Modules

    swiper.useModules();
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance


    return swiper;
  }

  var _proto = Swiper.prototype;

  _proto.enable = function enable() {
    var swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  };

  _proto.disable = function disable() {
    var swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  };

  _proto.setProgress = function setProgress(progress, speed) {
    var swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    var min = swiper.minTranslate();
    var max = swiper.maxTranslate();
    var current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  };

  _proto.emitContainerClasses = function emitContainerClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var classes = swiper.el.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', classes.join(' '));
  };

  _proto.getSlideClasses = function getSlideClasses(slideEl) {
    var swiper = this;
    return slideEl.className.split(' ').filter(function (className) {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  };

  _proto.emitSlidesClasses = function emitSlidesClasses() {
    var swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    var updates = [];
    swiper.slides.each(function (slideEl) {
      var classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl: slideEl,
        classNames: classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  };

  _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
    var swiper = this;
    var params = swiper.params,
        slides = swiper.slides,
        slidesGrid = swiper.slidesGrid,
        swiperSize = swiper.size,
        activeIndex = swiper.activeIndex;
    var spv = 1;

    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;

      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
        if (slides[_i] && !breakLoop) {
          slideSize += slides[_i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }

    return spv;
  };

  _proto.update = function update() {
    var swiper = this;
    if (!swiper || swiper.destroyed) return;
    var snapGrid = swiper.snapGrid,
        params = swiper.params; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    var translated;

    if (swiper.params.freeMode) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  };

  _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }

    var swiper = this;
    var currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(function (slideEl) {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  };

  _proto.mount = function mount(el) {
    var swiper = this;
    if (swiper.mounted) return true; // Find el

    var $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    var getWrapperSelector = function getWrapperSelector() {
      return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
    };

    var getWrapper = function getWrapper() {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        var res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = function (options) {
          return $el.children(options);
        };

        return res;
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    var $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      var document = getDocument();
      var wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children("." + swiper.params.slideClass).each(function (slideEl) {
        $wrapperEl.append(slideEl);
      });
    }

    extend$1(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  };

  _proto.init = function init(el) {
    var swiper = this;
    if (swiper.initialized) return swiper;
    var mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  };

  _proto.destroy = function destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }

    if (cleanStyles === void 0) {
      cleanStyles = true;
    }

    var swiper = this;
    var params = swiper.params,
        $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  };

  Swiper.extendDefaults = function extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  };

  Swiper.installModule = function installModule(module) {
    if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
    var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
    Swiper.prototype.modules[name] = module;
  };

  Swiper.use = function use(module) {
    if (Array.isArray(module)) {
      module.forEach(function (m) {
        return Swiper.installModule(m);
      });
      return Swiper;
    }

    Swiper.installModule(module);
    return Swiper;
  };

  _createClass(Swiper, null, [{
    key: "extendedDefaults",
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: "defaults",
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper$2.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$2.use([Resize, Observer$1]);
var SwiperCore = Swiper$2;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;
    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;
    var offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    var slidesAfter;
    var slidesBefore;

    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = slidesPerGroup + addSlidesBefore;
    }

    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    extend$1(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, offset + "px");
      }

      swiper.updateProgress();
      return;
    }

    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];

          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }

          return slidesToRender;
        }()
      });

      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      }

      return;
    }

    var prependIndexes = [];
    var appendIndexes = [];

    if (force) {
      swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
        }
      }
    }

    for (var _i = 0; _i < slides.length; _i += 1) {
      if (_i >= from && _i <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i);
        } else {
          if (_i > previousTo) appendIndexes.push(_i);
          if (_i < previousFrom) prependIndexes.push(_i);
        }
      }
    }

    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;

    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }

    var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slides) {
    var swiper = this;

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }

    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slides) {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }

      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }

    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        var $cachedEl = cache[cachedIndex];
        var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');

        if (cachedElIndex) {
          $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + 1);
        }

        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
      });
      swiper.virtual.cache = newCache;
    }

    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide: function removeSlide(slidesIndexes) {
    var swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;

    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);

        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }

        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);

      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }

      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }

    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides: function removeAllSlides() {
    var swiper = this;
    swiper.virtual.slides = [];

    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }

    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  }
};
var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      virtual: _extends$6({}, Virtual, {
        slides: swiper.params.virtual.slides,
        cache: {}
      })
    });
  },
  on: {
    beforeInit: function beforeInit(swiper) {
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
      var overwriteParams = {
        watchSlidesProgress: true
      };
      extend$1(swiper.params, overwriteParams);
      extend$1(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate: function setTranslate(swiper) {
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
};

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = $(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = $(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    extend$1(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      navigation: _extends$5({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el; // Current/Total

    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;

      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }

        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

      if ($el.length > 1) {
        bullets.each(function (bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + "-main");
            }

            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            }

            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        var bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);

          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + "-main");
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
              for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
            } else {
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          } else {
            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
          }
        }
      }

      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      var progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', $el[0]);
    } else {
      swiper.emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    var paginationHTML = '';

    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
      el: 'swiper-pagination'
    });
    var params = swiper.params.pagination;
    if (!params.el) return;
    var $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass("" + params.modifierClass + params.type + "-dynamic");
      swiper.pagination.dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    extend$1(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }
};
var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-',
      // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable',
      // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      pagination: _extends$4({
        dynamicBulletIndex: 0
      }, Pagination)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange(swiper) {
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange(swiper) {
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy(swiper) {
      swiper.pagination.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.pagination.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
      }
    },
    click: function click(swiper, e) {
      var targetEl = e.target;

      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

        if (isHidden === true) {
          swiper.emit('paginationShow');
        } else {
          swiper.emit('paginationHide');
        }

        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    var params = swiper.params.scrollbar;
    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
      $dragEl[0].style.width = newSize + "px";
    } else {
      $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
      $dragEl[0].style.height = newSize + "px";
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + "px";
    } else {
      $dragEl[0].style.height = dragSize + "px";
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    extend$1(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;

    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;
    var positionRatio;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);
    clearTimeout(swiper.scrollbar.dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;
    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    swiper.emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = getDocument();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var document = getDocument();
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params,
        support = swiper.support;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    var passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;

    if (!support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;
    swiper.params.scrollbar = createElementIfNotDefined($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
      el: 'swiper-scrollbar'
    });
    var params = swiper.params.scrollbar;
    if (!params.el) return;
    var $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

    if ($dragEl.length === 0) {
      $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
      $el.append($dragEl);
    }

    extend$1(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};
var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      scrollbar: _extends$3({
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }, Scrollbar)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update(swiper) {
      swiper.scrollbar.updateSize();
    },
    resize: function resize(swiper) {
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate(swiper) {
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate(swiper) {
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(swiper, duration) {
      swiper.scrollbar.setTransition(duration);
    },
    'enable disable': function enableDisable(swiper) {
      var $el = swiper.scrollbar.$el;

      if ($el) {
        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
      }
    },
    destroy: function destroy(swiper) {
      swiper.scrollbar.destroy();
    }
  }
};

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex;
      var minIndex;
      var guess;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;

        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;

          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }

        return maxIndex;
      };
    }();

    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.

    var i1;
    var i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };

    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;

    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier;
    var controlledTranslate;
    var Swiper = swiper.constructor;

    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out

        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }

      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }

    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var Swiper = swiper.constructor;
    var controlled = swiper.controller.control;
    var i;

    function setControlledTransition(c) {
      c.setTransition(duration, swiper);

      if (duration !== 0) {
        c.transitionStart();

        if (c.params.autoHeight) {
          nextTick(function () {
            c.updateAutoHeight();
          });
        }

        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;

          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }

          c.transitionEnd();
        });
      }
    }

    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'

    }
  },
  create: function create() {
    var swiper = this;
    bindModuleMethods(swiper, {
      controller: _extends$2({
        control: swiper.params.controller.control
      }, Controller)
    });
  },
  on: {
    update: function update(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate(swiper) {
      if (!swiper.controller.control) return;

      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(swiper, translate, byController) {
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(swiper, duration, byController) {
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var utils = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRef = exports.isModuleAvailable = exports.isReactElement = exports.validateChildren = exports.classNames = void 0;

exports.classNames = function (el) {
    if (typeof el === 'string') {
        return el.split('.').join(' ').trim();
    }
    else if (el instanceof HTMLElement) {
        return el.className;
    }
    return '';
};
exports.validateChildren = function (children) {
    var isValid = true;
    if (Array.isArray(children)) {
        React__default["default"].Children.forEach(children, function (child) {
            if (!React__default["default"].isValidElement(child)) {
                isValid = false;
            }
        });
    }
    else {
        isValid = React__default["default"].isValidElement(children);
    }
    return isValid;
};
exports.isReactElement = function (element) {
    return React__default["default"].isValidElement(element) &&
        (typeof element.type === 'string' ||
            typeof element.type === 'function' ||
            typeof element.type === 'object');
};
exports.isModuleAvailable = function (modules, moduleName) {
    var moduleAvailable = false;
    for (var i = 0; i < modules.length; i++) {
        if (modules[i].name === moduleName) {
            moduleAvailable = true;
            break;
        }
    }
    return moduleAvailable;
};
exports.setRef = function (ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
};
});

unwrapExports(utils);
utils.setRef;
utils.isModuleAvailable;
utils.isReactElement;
utils.validateChildren;
utils.classNames;

var hooks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForkRef = void 0;


exports.useForkRef = function (refA, refB) {
    return React__default["default"].useMemo(function () {
        if (refA == null && refB == null) {
            return null;
        }
        return function (refValue) {
            utils.setRef(refA, refValue);
            utils.setRef(refB, refValue);
        };
    }, [refA, refB]);
};
});

unwrapExports(hooks);
hooks.useForkRef;

var ReactIdSwiper_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(React__default["default"]);
var swiper_1 = __importDefault(SwiperCore);
var object_assign_1 = __importDefault(objectAssign);


var ReactIdSwiper = react_1.forwardRef(function (props, externalRef) {
    var activeSlideKey = props.activeSlideKey, ContainerEl = props.ContainerEl, children = props.children, containerClass = props.containerClass, navigation = props.navigation, noSwiping = props.noSwiping, pagination = props.pagination, parallax = props.parallax, parallaxEl = props.parallaxEl, WrapperEl = props.WrapperEl, wrapperClass = props.wrapperClass, rebuildOnUpdate = props.rebuildOnUpdate, renderScrollbar = props.renderScrollbar, renderPagination = props.renderPagination, renderPrevButton = props.renderPrevButton, renderNextButton = props.renderNextButton, renderParallax = props.renderParallax, rtl = props.rtl, scrollbar = props.scrollbar, shouldSwiperUpdate = props.shouldSwiperUpdate, slideClass = props.slideClass, loop = props.loop;
    // Define swiper instance ref
    var swiperInstanceRef = react_1.useRef(null);
    // Internal ref
    var swiperNodeRef = react_1.useRef(null);
    // Forked ref
    var ref = hooks.useForkRef(swiperNodeRef, externalRef);
    // Get current active slide key
    var getActiveSlideIndexFromProps = react_1.useCallback(function () {
        if (!activeSlideKey) {
            return null;
        }
        var activeSlideId = 0;
        // In loop mode first slide index should be 1
        var id = loop ? 1 : 0;
        react_1.Children.forEach(children, function (child) {
            if (react_1.isValidElement(child)) {
                if (child.key === activeSlideKey) {
                    activeSlideId = id;
                }
                id += 1;
            }
        });
        return activeSlideId;
    }, [activeSlideKey, children, loop]);
    // Destroy swiper
    var destroySwiper = react_1.useCallback(function () {
        if (swiperInstanceRef.current !== null) {
            swiperInstanceRef.current.destroy(true, true);
            utils.setRef(swiperInstanceRef, null);
        }
    }, []);
    // Initialize swiper
    var buildSwiper = react_1.useCallback(function () {
        if (swiperNodeRef.current && swiperInstanceRef.current === null) {
            utils.setRef(swiperInstanceRef, new swiper_1.default(swiperNodeRef.current, object_assign_1.default({}, props)));
        }
    }, [props]);
    // Render slides
    var renderContent = function (e) {
        if (!utils.isReactElement(e)) {
            return null;
        }
        var slideClassNames = [slideClass, e.props.className];
        if (noSwiping) {
            slideClassNames.push('swiper-no-swiping');
        }
        return react_1.cloneElement(e, __assign(__assign({}, e.props), { className: slideClassNames.join(' ').trim() }));
    };
    // Destroy Swiper instance when component is unmounted
    react_1.useEffect(function () {
        return function () { return destroySwiper(); };
    }, [destroySwiper]);
    react_1.useEffect(function () {
        buildSwiper();
        if (swiperInstanceRef.current !== null) {
            if (rebuildOnUpdate) {
                destroySwiper();
                buildSwiper();
            }
            else if (shouldSwiperUpdate) {
                swiperInstanceRef.current.update();
            }
            var numSlides = swiperInstanceRef.current.slides.length;
            if (numSlides <= swiperInstanceRef.current.activeIndex) {
                var index = Math.max(numSlides - 1, 0);
                swiperInstanceRef.current.slideTo(index);
            }
            var slideToIndex = getActiveSlideIndexFromProps();
            if (slideToIndex !== null) {
                swiperInstanceRef.current.slideTo(slideToIndex);
            }
        }
    }, [
        destroySwiper,
        getActiveSlideIndexFromProps,
        rebuildOnUpdate,
        shouldSwiperUpdate,
        buildSwiper
    ]);
    // No render if wrapper elements are not provided
    if (!children || !ContainerEl || !WrapperEl) {
        return null;
    }
    // Validate children props
    if (!utils.validateChildren(children)) {
        return null;
    }
    return (react_1.default.createElement(ContainerEl, { className: containerClass, dir: rtl && 'rtl', ref: ref },
        parallax && parallaxEl && renderParallax && renderParallax(props),
        react_1.default.createElement(WrapperEl, { className: wrapperClass }, react_1.Children.map(children, renderContent)),
        pagination && pagination.el && renderPagination && renderPagination(props),
        scrollbar && scrollbar.el && renderScrollbar && renderScrollbar(props),
        navigation && navigation.nextEl && renderNextButton && renderNextButton(props),
        navigation && navigation.prevEl && renderPrevButton && renderPrevButton(props)));
});
// Default props
ReactIdSwiper.defaultProps = {
    containerClass: 'swiper-container',
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
    ContainerEl: 'div',
    WrapperEl: 'div',
    renderScrollbar: function (_a) {
        var scrollbar = _a.scrollbar;
        return scrollbar ? react_1.default.createElement("div", { className: utils.classNames(scrollbar.el) }) : null;
    },
    renderPagination: function (_a) {
        var pagination = _a.pagination;
        return pagination ? react_1.default.createElement("div", { className: utils.classNames(pagination.el) }) : null;
    },
    renderPrevButton: function (_a) {
        var navigation = _a.navigation;
        return navigation ? react_1.default.createElement("div", { className: utils.classNames(navigation.prevEl) }) : null;
    },
    renderNextButton: function (_a) {
        var navigation = _a.navigation;
        return navigation ? react_1.default.createElement("div", { className: utils.classNames(navigation.nextEl) }) : null;
    },
    renderParallax: function (_a) {
        var parallaxEl = _a.parallaxEl;
        return parallaxEl ? (react_1.default.createElement("div", { className: utils.classNames(parallaxEl.el), "data-swiper-parallax": parallaxEl.value })) : null;
    }
};
ReactIdSwiper.displayName = 'ReactIdSwiper';
exports.default = ReactIdSwiper;
});

unwrapExports(ReactIdSwiper_1);

var lib = createCommonjsModule(function (module, exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReactIdSwiper_1$1 = __importDefault(ReactIdSwiper_1);
// React-id-swiper
exports.default = ReactIdSwiper_1$1.default;
});

var SwiperComponent = unwrapExports(lib);

function useValidations() {

  //utilizar quando for comparar objetos NÃO aninhdos
  function shallowEqualObj(object1, object2) {
    return Object.entries(object1).toString() === Object.entries(object2).toString();
  }

  //utilizar quando for comparar objetos aninhdos
  function deepEqualObj(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if (
        areObjects && !deepEqualObj(val1, val2) ||
        !areObjects && val1 !== val2
      ) {
        return false;
      }
    }
    return true;
  }

  function isObject(object) {
    return object != null && typeof object === 'object';
  }
  return {
    shallowEqualObj,
    deepEqualObj,
    isObject
  }
}

var _excluded$d = ["inverse", "data", "dataTabSelect", "swiperConfigs", "onClick", "children", "gtm", "currentTab"];
var config$9 = {
  types: ['inverse'],
  modifiers: [],
  states: []
};
var params = {
  ContainerEl: 'div',
  containerClass: 'mdn-Swiper mdn-Steps-swiper',
  WrapperEl: 'ul',
  rebuildOnUpdate: true,
  wrapperClass: 'mdn-TabSelect-list mdn-Swiper-wrapper',
  slideClass: 'mdn-TabSelect-item',
  slidesPerView: 'auto',
  pagination: {},
  navigation: {},
  grabCursor: true
};
function TabSelect(props) {
  var _ref, _tabs$items;

  props.inverse;
      var data = props.data,
      dataTabSelect = props.dataTabSelect;
      props.swiperConfigs;
      var onClick = props.onClick;
      props.children;
      props.gtm;
      var currentTab = props.currentTab,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$d);

  var tabsRef = React__default["default"].useRef(null);
  var tabsId = "tab__" + new Date().valueOf().toString().match(/\d{6}$/)[0];

  var _useValidations = useValidations(),
      shallowEqualObj = _useValidations.shallowEqualObj;

  var items = data || dataTabSelect;
  var currentIndex = (_ref = [].concat(items)) == null ? void 0 : _ref.findIndex(function (item) {
    var _item$props;

    return (item == null ? void 0 : item.isActive) === true || (item == null ? void 0 : (_item$props = item.props) == null ? void 0 : _item$props.isActive) === true;
  });
  var initialTab = currentIndex === -1 ? 0 : currentIndex;

  var _React$useState = React__default["default"].useState({
    currentTab: initialTab,
    items: items
  }),
      tabs = _React$useState[0],
      setTabs = _React$useState[1];

  React__default["default"].useEffect(function () {
    if (!shallowEqualObj(tabs.items, data)) {
      var currentPos = tabs.currentTab >= data.length ? data.length - 1 : tabs.currentTab;
      setTabs({
        currentTab: currentPos,
        items: data
      });
    }
  }, [data]);
  var handleOnclick = React__default["default"].useCallback(function (index, isVirtual) {
    tabsRef.current.swiper.slideTo(tabs.currentTab, 0, false);
    setTabs(function (state) {
      return _extends$8({}, state, {
        currentTab: index
      });
    });
    !!onClick && !isVirtual && onClick();
  }, []);
  React__default["default"].useEffect(function () {
    if (!!currentTab) {
      handleOnclick(currentTab, true);
    }
  }, [currentTab]);
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({
    className: resolveProps(props, config$9, 'TabSelect')
  }, rest), /*#__PURE__*/React__default["default"].createElement(SwiperComponent, _extends$8({}, params, {
    activeSlideKey: currentIndex,
    ref: tabsRef,
    a11y: false,
    threshold: 10
  }), tabs.items.map(function (item, index) {
    var _item$gtm = item.gtm,
        gtm = _item$gtm === void 0 ? {} : _item$gtm;
    var _gtm$gtmClassName = gtm.gtmClassName,
        gtmClassName = _gtm$gtmClassName === void 0 ? '' : _gtm$gtmClassName,
        _gtm$dataGTM = gtm.dataGTM,
        dataGTM = _gtm$dataGTM === void 0 ? {} : _gtm$dataGTM;
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: "tab_" + index,
      className: (tabs.currentTab === index ? 'mdn-TabSelect-active' : '') + " ",
      "aria-owns": "item-tab-" + tabsId + "-" + index,
      "aria-controls": "item-tab-" + tabsId + "-" + index
    }, /*#__PURE__*/React__default["default"].createElement("button", _extends$8({}, dataGTM, {
      onClick: function onClick() {
        return handleOnclick(index);
      },
      type: "button",
      className: "mdn-TabSelect-anchor " + gtmClassName
    }), item.title));
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-TabSelect-content"
  }, tabs == null ? void 0 : (_tabs$items = tabs.items) == null ? void 0 : _tabs$items.map(function (item, index) {
    var _items$index;

    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: "tab_" + index,
      id: "item-tab-" + tabsId + "-" + index,
      "aria-hidden": tabs.currentTab !== index,
      style: {
        display: "" + (tabs.currentTab === index ? 'flex' : 'none')
      },
      className: "mdn-TabSelect-panel mdn-TabSelect-active"
    }, tabs.currentTab === index ? (_items$index = items[index]) == null ? void 0 : _items$index.content : null);
  })));
}
TabSelect.propTypes = {
  swiperConfigs: PropTypes__default["default"].bool
};

var _excluded$c = ["dataBreadcrumb", "data"];
var config$8 = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: [],
  states: []
};

var renderPages = function renderPages(dataBreadcrumb) {
  return dataBreadcrumb == null ? void 0 : dataBreadcrumb.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: "mdn-Breadcrumb-list-item"
    }, /*#__PURE__*/React__default["default"].createElement("a", _extends$8({
      className: "mdn-Breadcrumb-link",
      role: "link",
      "aria-current": "location",
      target: item.target,
      href: item.url
    }, item.props), item.page), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-Breadcrumb-icon mdn-Icon-direita mdn-Icon--md"
    }));
  });
};

function Breadcrumb(props) {
  var dataBreadcrumb = props.dataBreadcrumb,
      data = props.data,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$c);

  var _props = clearProps(props);

  return /*#__PURE__*/React__default["default"].createElement("nav", _extends$8({}, rest, {
    "aria-label": "breadcrumbs",
    className: resolveProps(_props, config$8, 'Breadcrumb')
  }), /*#__PURE__*/React__default["default"].createElement("ol", {
    className: "mdn-Breadcrumb-list"
  }, renderPages(data || dataBreadcrumb)));
}
Breadcrumb.propTypes = {
  dataBreadcrumb: PropTypes__default["default"].shape({
    page: PropTypes__default["default"].string,
    url: PropTypes__default["default"].string
  }),
  data: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    page: PropTypes__default["default"].string,
    url: PropTypes__default["default"].string
  }))
};

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(function (key) {
    return noExtend.indexOf(key) < 0;
  }).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }

  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }

  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }

  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }

  var classes = classNames.split(' ').map(function (c) {
    return c.trim();
  }).filter(function (c) {
    return !!c;
  });
  var unique = [];
  classes.forEach(function (c) {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
var paramsList = ['init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_freeModeMomentum', '_freeModeMomentumRatio', '_freeModeMomentumBounce', '_freeModeMomentumBounceRatio', '_freeModeMomentumVelocityRatio', '_freeModeSticky', '_freeModeMinimumVelocity', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', '_slidesPerColumn', '_slidesPerColumnFill', '_slidesPerGroup', '_slidesPerGroupSkip', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_watchSlidesVisibility', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', 'autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

// eslint-disable-next-line

function getParams(obj) {
  if (obj === void 0) {
    obj = {};
  }

  var params = {
    on: {}
  };
  var events = {};
  var passedParams = {};
  extend(params, SwiperCore.defaults);
  extend(params, SwiperCore.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  var rest = {};
  var allowedParams = paramsList.map(function (key) {
    return key.replace(/_/, '');
  });
  Object.keys(obj).forEach(function (key) {
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      events["" + key[2].toLowerCase() + key.substr(3)] = obj[key];
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(function (key) {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params: params,
    passedParams: passedParams,
    rest: rest,
    events: events
  };
}

// eslint-disable-next-line

function initSwiper(swiperParams) {
  return new SwiperCore(swiperParams);
}

function mountSwiper(_ref, swiperParams) {
  var el = _ref.el,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      paginationEl = _ref.paginationEl,
      scrollbarEl = _ref.scrollbarEl,
      swiper = _ref.swiper;

  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

function calcLoopedSlides(slides, swiperParams) {
  var slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    var breakpoint = SwiperCore.prototype.getBreakpoint(swiperParams.breakpoints);
    var breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  var loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
}

function renderLoop(swiper, slides, swiperParams) {
  var modifiedSlides = slides.map(function (child, index) {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      swiper: swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      key: child.key + "-duplicate-" + index + "-" + position,
      className: (child.props.className || '') + " " + swiperParams.slideDuplicateClass
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    var blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankSlide = /*#__PURE__*/React__default["default"].createElement("div", {
          className: swiperParams.slideClass + " " + swiperParams.slideBlankClass
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  var loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  var prependSlides = [];
  var appendSlides = [];
  modifiedSlides.forEach(function (child, index) {
    if (index < loopedSlides) {
      appendSlides.push(duplicateSlide(child, index, 'prepend'));
    }

    if (index < modifiedSlides.length && index >= modifiedSlides.length - loopedSlides) {
      prependSlides.push(duplicateSlide(child, index, 'append'));
    }
  });

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [].concat(prependSlides, modifiedSlides, appendSlides);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren) {
  var keys = [];
  if (!oldParams) return keys;

  var addKey = function addKey(key) {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  var oldChildrenKeys = oldChildren.map(function (child) {
    return child.key;
  });
  var childrenKeys = children.map(function (child) {
    return child.key;
  });
  if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
  if (oldChildren.length !== children.length) addKey('children');
  var watchParams = paramsList.filter(function (key) {
    return key[0] === '_';
  }).map(function (key) {
    return key.replace(/_/, '');
  });
  watchParams.forEach(function (key) {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        var newKeys = Object.keys(swiperParams[key]);
        var oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(function (newKey) {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(function (oldKey) {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function processChildren(c) {
  var slides = [];
  React__default["default"].Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(function (slide) {
        return slides.push(slide);
      });
    }
  });
  return slides;
}

function getChildren(c) {
  var slides = [];
  var slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default["default"].Children.toArray(c).forEach(function (child) {
    if (child.type && child.type.displayName === 'SwiperSlide') {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      var foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(function (slide) {
          return slides.push(slide);
        });
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides: slides,
    slots: slots
  };
}

function updateSwiper(_ref) {
  var swiper = _ref.swiper,
      slides = _ref.slides,
      passedParams = _ref.passedParams,
      changedParams = _ref.changedParams,
      nextEl = _ref.nextEl,
      prevEl = _ref.prevEl,
      scrollbarEl = _ref.scrollbarEl,
      paginationEl = _ref.paginationEl;
  var updateParams = changedParams.filter(function (key) {
    return key !== 'children' && key !== 'direction';
  });
  var currentParams = swiper.params,
      pagination = swiper.pagination,
      navigation = swiper.navigation,
      scrollbar = swiper.scrollbar,
      virtual = swiper.virtual,
      thumbs = swiper.thumbs;
  var needThumbsInit;
  var needControllerInit;
  var needPaginationInit;
  var needScrollbarInit;
  var needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  var destroyModule = function destroyModule(mod) {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(function (key) {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      var newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (changedParams.includes('children') && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    var initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function updateOnVirtualData(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
}

function renderVirtual(swiper, slides, virtualData) {
  var _ref;

  if (!virtualData) return null;
  var style = swiper.isHorizontal() ? (_ref = {}, _ref[swiper.rtlTranslate ? 'right' : 'left'] = virtualData.offset + "px", _ref) : {
    top: virtualData.offset + "px"
  };
  return slides.filter(function (child, index) {
    return index >= virtualData.from && index <= virtualData.to;
  }).map(function (child) {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      swiper: swiper,
      style: style
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return React.useEffect(callback, deps);
  return React.useLayoutEffect(callback, deps);
}

var _excluded$b = ["className", "tag", "wrapperTag", "children", "onSwiper"];

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Swiper$1 = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      _ref$wrapperTag = _ref.wrapperTag,
      WrapperTag = _ref$wrapperTag === void 0 ? 'div' : _ref$wrapperTag,
      children = _ref.children,
      onSwiper = _ref.onSwiper,
      rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$b);

  var eventsAssigned = false;

  var _useState = React.useState('swiper-container'),
      containerClasses = _useState[0],
      setContainerClasses = _useState[1];

  var _useState2 = React.useState(null),
      virtualData = _useState2[0],
      setVirtualData = _useState2[1];

  var _useState3 = React.useState(false),
      breakpointChanged = _useState3[0],
      setBreakpointChanged = _useState3[1];

  var initializedRef = React.useRef(false);
  var swiperElRef = React.useRef(null);
  var swiperRef = React.useRef(null);
  var oldPassedParamsRef = React.useRef(null);
  var oldSlides = React.useRef(null);
  var nextElRef = React.useRef(null);
  var prevElRef = React.useRef(null);
  var paginationElRef = React.useRef(null);
  var scrollbarElRef = React.useRef(null);

  var _getParams = getParams(rest),
      swiperParams = _getParams.params,
      passedParams = _getParams.passedParams,
      restProps = _getParams.rest,
      events = _getParams.events;

  var _getChildren = getChildren(children),
      slides = _getChildren.slides,
      slots = _getChildren.slots;

  var onBeforeBreakpoint = function onBeforeBreakpoint() {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses: function _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });

  if (!swiperElRef.current) {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = initSwiper(swiperParams);

    swiperRef.current.loopCreate = function () {};

    swiperRef.current.loopDestroy = function () {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      var extendWith = {
        cache: false,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  var attachEvents = function attachEvents() {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  var detachEvents = function detachEvents() {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(function (eventName) {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  React.useEffect(function () {
    return function () {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  React.useEffect(function () {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(function () {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return function () {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(function () {
    attachEvents();
    var changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides: slides,
        passedParams: passedParams,
        changedParams: changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return function () {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(function () {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(function (child) {
        return /*#__PURE__*/React__default["default"].cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default["default"].createElement(Tag, _extends$1({
    ref: swiperElRef,
    className: uniqueClasses("" + containerClasses + (className ? " " + className : ''))
  }, restProps), slots['container-start'], needsNavigation(swiperParams) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), /*#__PURE__*/React__default["default"].createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), slots['container-end']);
});
Swiper$1.displayName = 'Swiper';

var _excluded$a = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      swiper = _ref.swiper,
      zoom = _ref.zoom,
      virtualIndex = _ref.virtualIndex,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  var slideElRef = React.useRef(null);

  var _useState = React.useState('swiper-slide'),
      slideClasses = _useState[0],
      setSlideClasses = _useState[1];

  function updateClasses(swiper, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return function () {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(function () {
    if (swiper && slideElRef.current) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  var slideData;

  if (typeof children === 'function') {
    slideData = {
      isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
      isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
      isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
      isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
      isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
    };
  }

  var renderChildren = function renderChildren() {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default["default"].createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses("" + slideClasses + (className ? " " + className : '')),
    "data-swiper-slide-index": virtualIndex
  }, rest), zoom ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren());
});
SwiperSlide.displayName = 'SwiperSlide';

var css_248z = "@font-face {\n  font-family: 'swiper-icons';\n  src: url(\"data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal; }\n\n:root {\n  --swiper-theme-color: #007aff; }\n\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  /* Fix of Webkit flickering */\n  z-index: 1; }\n\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column; }\n\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box; }\n\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0); }\n\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap; }\n\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column; }\n\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto; }\n\n.swiper-container-pointer-events {\n  touch-action: pan-y; }\n  .swiper-container-pointer-events.swiper-container-vertical {\n    touch-action: pan-x; }\n\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform; }\n\n.swiper-slide-invisible-blank {\n  visibility: hidden; }\n\n/* Auto Height */\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto; }\n\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height; }\n\n/* 3D Effects */\n.swiper-container-3d {\n  perspective: 1200px; }\n  .swiper-container-3d .swiper-wrapper,\n  .swiper-container-3d .swiper-slide,\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom,\n  .swiper-container-3d .swiper-cube-shadow {\n    transform-style: preserve-3d; }\n  .swiper-container-3d .swiper-slide-shadow-left,\n  .swiper-container-3d .swiper-slide-shadow-right,\n  .swiper-container-3d .swiper-slide-shadow-top,\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 10; }\n  .swiper-container-3d .swiper-slide-shadow-left {\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-right {\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-top {\n    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n  .swiper-container-3d .swiper-slide-shadow-bottom {\n    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0)); }\n\n/* CSS Mode */\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  /* For Firefox */\n  -ms-overflow-style: none;\n  /* For Internet Explorer and Edge */ }\n  .swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n    display: none; }\n\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start; }\n\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory; }\n\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory; }\n\n/* a11y */\n.swiper-container .swiper-notification {\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  opacity: 0;\n  z-index: -1000; }\n\n:root {\n  --swiper-navigation-size: 44px;\n  /*\n  --swiper-navigation-color: var(--swiper-theme-color);\n  */ }\n\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - (var(--swiper-navigation-size) / 2));\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color)); }\n  .swiper-button-prev.swiper-button-disabled,\n  .swiper-button-next.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: auto;\n    pointer-events: none; }\n  .swiper-button-prev:after,\n  .swiper-button-next:after {\n    font-family: swiper-icons;\n    font-size: var(--swiper-navigation-size);\n    text-transform: none !important;\n    letter-spacing: 0;\n    text-transform: none;\n    font-variant: initial;\n    line-height: 1; }\n\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto; }\n  .swiper-button-prev:after,\n  .swiper-container-rtl .swiper-button-next:after {\n    content: 'prev'; }\n\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto; }\n  .swiper-button-next:after,\n  .swiper-container-rtl .swiper-button-prev:after {\n    content: 'next'; }\n\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff; }\n\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000; }\n\n.swiper-button-lock {\n  display: none; }\n\n:root {\n  /*\n  --swiper-pagination-color: var(--swiper-theme-color);\n  */ }\n\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10; }\n  .swiper-pagination.swiper-pagination-hidden {\n    opacity: 0; }\n\n/* Common Styles */\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%; }\n\n/* Bullets */\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0; }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transform: scale(0.33);\n    position: relative; }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n    transform: scale(1); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n    transform: scale(1); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n    transform: scale(0.66); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n    transform: scale(0.33); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n    transform: scale(0.66); }\n  .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n    transform: scale(0.33); }\n\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #000;\n  opacity: 0.2; }\n  button.swiper-pagination-bullet {\n    border: none;\n    margin: 0;\n    padding: 0;\n    box-shadow: none;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none; }\n  .swiper-pagination-clickable .swiper-pagination-bullet {\n    cursor: pointer; }\n  .swiper-pagination-bullet:only-child {\n    display: none !important; }\n\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color)); }\n\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0); }\n  .swiper-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 6px 0;\n    display: block; }\n  .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n    top: 50%;\n    transform: translateY(-50%);\n    width: 8px; }\n    .swiper-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n      display: inline-block;\n      transition: 200ms transform, 200ms top; }\n\n.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {\n  margin: 0 4px; }\n\n.swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap; }\n  .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n    transition: 200ms transform, 200ms left; }\n\n.swiper-container-horizontal.swiper-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right; }\n\n/* Progress */\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute; }\n  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    background: var(--swiper-pagination-color, var(--swiper-theme-color));\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    transform: scale(0);\n    transform-origin: left top; }\n  .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n    transform-origin: right top; }\n  .swiper-container-horizontal > .swiper-pagination-progressbar,\n  .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 100%;\n    height: 4px;\n    left: 0;\n    top: 0; }\n  .swiper-container-vertical > .swiper-pagination-progressbar,\n  .swiper-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n    width: 4px;\n    height: 100%;\n    left: 0;\n    top: 0; }\n\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff; }\n\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000; }\n\n.swiper-pagination-lock {\n  display: none; }\n\n/* Scrollbar */\n.swiper-scrollbar {\n  border-radius: 10px;\n  position: relative;\n  -ms-touch-action: none;\n  background: rgba(0, 0, 0, 0.1); }\n  .swiper-container-horizontal > .swiper-scrollbar {\n    position: absolute;\n    left: 1%;\n    bottom: 3px;\n    z-index: 50;\n    height: 5px;\n    width: 98%; }\n  .swiper-container-vertical > .swiper-scrollbar {\n    position: absolute;\n    right: 3px;\n    top: 1%;\n    z-index: 50;\n    width: 5px;\n    height: 98%; }\n\n.swiper-scrollbar-drag {\n  height: 100%;\n  width: 100%;\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  left: 0;\n  top: 0; }\n\n.swiper-scrollbar-cursor-drag {\n  cursor: move; }\n\n.swiper-scrollbar-lock {\n  display: none; }\n\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out; }\n\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity; }\n  .swiper-container-fade .swiper-slide .swiper-slide {\n    pointer-events: none; }\n\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto; }\n\n.mdn-Swiper * {\n  box-sizing: border-box;\n  position: relative; }\n\n.mdn-Swiper .mdn-Image {\n  width: auto; }\n\n.mdn-Swiper .mdn-Swiper-slide {\n  display: initial; }\n\n.mdn-Swiper .mdn-SwiperSlide-buttons {\n  display: flex;\n  width: 100% !important; }\n\n.mdn-Swiper .mdn-Swiper-button-next {\n  margin-left: var(--theme-spacing-inline-xxs); }\n\n.mdn-Swiper--auto .swiper-slide {\n  width: auto !important; }\n\n.mdn-Swiper--bullets .mdn-SwiperSlide-buttonNext,\n.mdn-Swiper--bullets .mdn-SwiperSlide-buttonPrev {\n  display: none; }\n\n.mdn-Swiper--bullets .swiper-button-prev,\n.mdn-Swiper--bullets .swiper-button-next {\n  display: none; }\n\n.mdn-Swiper--bullets .mdn-SwiperSlide-pagination {\n  display: block;\n  display: flex;\n  justify-content: center;\n  width: 100% !important; }\n\n.mdn-Swiper--bullets .swiper-pagination-bullets {\n  margin-top: var(--spacing-stack-md); }\n\n.mdn-Swiper--bullets .swiper-pagination-bullet {\n  width: var(--theme-font-size-sm) !important;\n  height: var(--theme-border-radius-xs) !important;\n  background-color: var(--theme-color-neutral-medium) !important;\n  border-radius: 0 !important;\n  display: inline-block !important;\n  opacity: 1 !important;\n  transition: 300ms ease-out !important;\n  margin: 0 var(--spacing-stack-xxxs); }\n\n.mdn-Swiper--bullets .swiper-pagination-bullet-active {\n  width: 40px !important;\n  height: var(--theme-border-radius-xs) !important;\n  background-color: var(--theme-color-brand-primary-medium) !important;\n  transition: 300ms ease-in !important; }\n\n.mdn-Swiper .swiper-button-prev,\n.mdn-Swiper .swiper-button-next {\n  display: none !important; }\n";
styleInject(css_248z);

function useSwipper(_ref) {
  var navigationPrevRef = _ref.navigationPrevRef,
      navigationNextRef = _ref.navigationNextRef;
      _ref.paginationElementRef;

  var hasNavigation = function hasNavigation(children) {
    return [].concat(children).length > 1 ? {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current
    } : {};
  };

  var hasPagination = function hasPagination(children, pagination) {
    return {
      el: '.mdn-SwiperSlide-pagination.mdn-Swiper-pagination',
      type: 'bullets',
      clickable: true
    };
  };

  var setSwipperAttrs = function setSwipperAttrs(props, swiperRef) {
    var children = props.children,
        slidesPerView = props.slidesPerView,
        slidesPerViewMobile = props.slidesPerViewMobile,
        slidesPerViewTablet = props.slidesPerViewTablet,
        slidesPerViewSmallDesktop = props.slidesPerViewSmallDesktop,
        sliderDelay = props.sliderDelay,
        spaceBetween = props.spaceBetween,
        spaceBetweenMobile = props.spaceBetweenMobile,
        spaceBetweenTablet = props.spaceBetweenTablet,
        spaceBetweenSmallDesktop = props.spaceBetweenSmallDesktop,
        autoPlay = props.autoPlay,
        breakpoints = props.breakpoints,
        _props$customParams = props.customParams,
        customParams = _props$customParams === void 0 ? {} : _props$customParams;
        props.pagination;
    var mdnslidesPerView = Number(slidesPerView || 'auto');
    var mdnslidesPerViewMobile = Number(slidesPerViewMobile || '1');
    var mdnslidesPerViewTablet = Number(slidesPerViewTablet || '1');
    var mdnslidesPerViewSmallDesktop = Number(slidesPerViewSmallDesktop || '1');
    var mdnSliderDelay = Number(sliderDelay || 5000);
    var mdnSpaceBetween = Number(spaceBetween || claroTokensLatest_common.spacingInlineXs.replace('px', ''));
    var mdnSpaceBetweenMobile = Number(spaceBetweenMobile || claroTokensLatest_common.spacingInlineXs.replace('px', ''));
    var mdnSpaceBetweenTablet = Number(spaceBetweenTablet || claroTokensLatest_common.spacingInlineXs.replace('px', ''));
    var mdnSpaceBetweenSmallDesktop = Number(spaceBetweenSmallDesktop || claroTokensLatest_common.spacingInlineXs.replace('px', ''));
    var __breakpoints = {};

    if (slidesPerViewMobile && slidesPerViewMobile != 'auto') {
      __breakpoints[320] = {
        slidesPerView: isNaN(mdnslidesPerViewMobile) ? 'auto' : mdnslidesPerViewMobile,
        spaceBetween: isNaN(mdnSpaceBetweenMobile) ? 'auto' : mdnSpaceBetweenMobile
      };
    }

    if (slidesPerViewTablet && slidesPerViewTablet != 'auto') {
      __breakpoints[claroTokensLatest_common.screenSizeMd.replace('px', '')] = {
        slidesPerView: isNaN(mdnslidesPerViewTablet) ? 'auto' : mdnslidesPerViewTablet,
        spaceBetween: isNaN(mdnSpaceBetweenTablet) ? 'auto' : mdnSpaceBetweenTablet
      };
    }

    if (slidesPerViewSmallDesktop && slidesPerViewSmallDesktop != 'auto') {
      __breakpoints[claroTokensLatest_common.screenSizeXl.replace('px', '')] = {
        slidesPerView: isNaN(mdnslidesPerViewSmallDesktop) ? 'auto' : mdnslidesPerViewSmallDesktop,
        spaceBetween: isNaN(mdnSpaceBetweenSmallDesktop) ? 'auto' : mdnSpaceBetweenSmallDesktop
      };
    }

    var params = {
      containerClass: 'mdn-Swiper-container',
      wrapperClass: 'mdn-Swiper-wrapper',
      slideClass: 'mdn-Swiper-slide',
      slidesPerView: isNaN(mdnslidesPerView) ? 'auto' : mdnslidesPerView,
      spaceBetween: isNaN(mdnSpaceBetween) ? 'auto' : mdnSpaceBetween,
      watchOverflow: true,
      autoplay: autoPlay ? {
        delay: mdnSliderDelay
      } : false,
      pagination: React__default["default"].Children.toArray(children).length > 1 ? hasPagination() : {},
      navigation: React__default["default"].Children.toArray(children).length > 1 && swiperRef ? hasNavigation(children) : {},
      breakpoints: breakpoints || __breakpoints
    };
    return _extends$8({}, params, customParams);
  };

  return {
    setSwipperAttrs: setSwipperAttrs
  };
}

var _excluded$9 = ["slidesPerView", "beta", "bullets", "children", "id", "currentSlide", "navigationButtons", "pagination", "onBeforeInit"];
var config$7 = {
  types: ['inverse', 'bullets', 'beta'],
  modifiers: [],
  state: []
};
SwiperCore.use([Navigation$1, Pagination$1, Scrollbar$1, Controller$1, Virtual$1]);
function Swiper(props) {
  var _props$slidesPerView = props.slidesPerView,
      slidesPerView = _props$slidesPerView === void 0 ? 'auto' : _props$slidesPerView;
      props.beta;
      var bullets = props.bullets,
      children = props.children,
      id = props.id,
      currentSlide = props.currentSlide,
      _props$navigationButt = props.navigationButtons,
      navigationButtons = _props$navigationButt === void 0 ? {} : _props$navigationButt,
      _props$pagination = props.pagination,
      pagination = _props$pagination === void 0 ? {} : _props$pagination,
      _onBeforeInit = props.onBeforeInit,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$9);

  var swiperRef = React__default["default"].useRef(null);
  var navigationPrevRef = React__default["default"].useRef(null);
  var navigationNextRef = React__default["default"].useRef(null);
  var paginationElementRef = React__default["default"].useRef(null);
  var _navigationButtons$pr = navigationButtons.prevProps,
      prevProps = _navigationButtons$pr === void 0 ? {} : _navigationButtons$pr,
      _navigationButtons$ne = navigationButtons.nextProps,
      nextProps = _navigationButtons$ne === void 0 ? {} : _navigationButtons$ne,
      _navigationButtons$pa = navigationButtons.parentProps,
      parentProps = _navigationButtons$pa === void 0 ? {} : _navigationButtons$pa;
  pagination.bulletProps;
  var paginationParentProps = pagination.parentProps || {};

  var _React$useState = React__default["default"].useState(null),
      controlledSwiper = _React$useState[0],
      setControlledSwiper = _React$useState[1];

  var _React$useState2 = React__default["default"].useState(null),
      swiperRoot = _React$useState2[0],
      setSwiperRoot = _React$useState2[1];

  var mdnClasses = "" + resolveProps(props, config$7, 'Swiper');
  var arrayChildren = React__default["default"].Children.toArray(children);

  var _useSwipper = useSwipper({
    navigationPrevRef: navigationPrevRef,
    navigationNextRef: navigationNextRef,
    paginationElementRef: paginationElementRef
  }),
      setSwipperAttrs = _useSwipper.setSwipperAttrs;

  var swipperParams = setSwipperAttrs(props, swiperRef);
  var customParams = swipperParams.customParams;
  var templateClasses = (mdnClasses + " " + (slidesPerView === 'auto' ? 'mdn-Swiper--auto' : '')).trim();
  var parentNavigationClassName = ('mdn-SwiperSlide-buttons' + (" " + (parentProps.className || ''))).trim();
  var parentPaginationClassName = (['mdn-SwiperSlide-pagination', 'mdn-Swiper-pagination'].join(' ') + (" " + (paginationParentProps.className || ''))).trim();
  var buttonPrevClassName = (['mdn-SwiperSlide-buttonPrev', 'mdn-Swiper-button-prev', 'mdn-Icon-esquerda', 'mdn-Icon--lg', 'mdn-SwiperSlide-buttonNavigation'].join(' ') + (" " + ((prevProps == null ? void 0 : prevProps.className) || ''))).trim();
  var buttonNextClassName = (['mdn-SwiperSlide-buttonNext', 'mdn-Swiper-button-next', 'mdn-Icon-direita', 'mdn-Icon--lg', 'mdn-SwiperSlide-buttonNavigation'].join(' ') + (" " + ((nextProps == null ? void 0 : nextProps.className) || ''))).trim();
  var swipperId = id || "" + new Date().valueOf().toString().match(/\d{6}$/)[0];
  React__default["default"].useEffect(function () {
    swiperRoot == null ? void 0 : swiperRoot.slideTo(currentSlide);
  }, [currentSlide, swiperRoot]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: templateClasses + " "
  }, /*#__PURE__*/React__default["default"].createElement(Swiper$1, _extends$8({
    className: "mdn-Swiper-container",
    ref: swiperRef,
    watchSlidesProgress: true,
    watchOverflow: true,
    id: "" + swipperId,
    navigation: swipperParams.navigation //{swipperParams.navigation} {true}
    ,
    breakpoints: swipperParams.breakpoints,
    pagination: swipperParams.pagination,
    slidesPerView: swipperParams.slidesPerView,
    observer: true,
    spaceBetween: swipperParams.spaceBetween,
    onBeforeInit: function onBeforeInit(swiper) {
      setSwiperRoot(swiper); // save swiper original methods to be invoked anywhere

      swiper.params.navigation.prevEl = navigationPrevRef.current;
      swiper.params.navigation.nextEl = navigationNextRef.current;
      swiper.params.pagination.el = paginationElementRef.current;
      _onBeforeInit && _onBeforeInit(swiper);
    },
    controller: {
      control: controlledSwiper
    },
    onSwiper: setControlledSwiper
  }, customParams, rest), /*#__PURE__*/React__default["default"].createElement("div", {
    className: 'mdn-Swiper-wrapper'
  }, React__default["default"].Children.map(arrayChildren, function (child, index) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      virtualIndex: index,
      key: "slide_" + index,
      id: "slide_" + swipperId + "_" + index,
      className: 'mdn-Swiper-slide'
    }, child);
  })), !!bullets && React__default["default"].Children.toArray(children).length > 1 ? /*#__PURE__*/React__default["default"].createElement("div", _extends$8({
    ref: paginationElementRef,
    slot: 'container-end'
  }, paginationParentProps, {
    className: parentPaginationClassName
  })) : /*#__PURE__*/React__default["default"].createElement("div", _extends$8({
    slot: 'container-end'
  }, parentProps, {
    className: parentNavigationClassName
  }), /*#__PURE__*/React__default["default"].createElement("button", _extends$8({
    ref: navigationPrevRef
  }, prevProps, {
    className: buttonPrevClassName
  })), /*#__PURE__*/React__default["default"].createElement("button", _extends$8({
    ref: navigationNextRef
  }, nextProps, {
    className: buttonNextClassName
  })))));
}

/* eslint-disable multiline-ternary */

var CardInstitutional = function CardInstitutional(props) {
  props.inverse;
      var icon = props.icon,
      children = props.children,
      _props$imgSrc = props.imgSrc,
      imgSrc = _props$imgSrc === void 0 ? '' : _props$imgSrc;
      props.image;
      var imgAlt = props.imgAlt;
      props.video;
      var videoSrc = props.videoSrc,
      videoAlt = props.videoAlt,
      config = props.config,
      getCardIcon = props.getCardIcon; // const { getCardIcon } = useCard()

  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config, 'CardInstitutional')
  }, !!imgSrc && imgSrc ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardInstitutional--imageThumb"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: imgSrc,
    alt: imgAlt
  })) : '', videoSrc ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardInstitutional--videoThumb"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: videoSrc,
    alt: videoAlt
  })) : '', getCardIcon(icon), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardInstitutional-content"
  }, children));
};
CardInstitutional.propTypes = {
  inverse: PropTypes__default["default"].bool,
  image: PropTypes__default["default"].bool,
  imgSrc: PropTypes__default["default"].string,
  imgAlt: PropTypes__default["default"].string,
  video: PropTypes__default["default"].bool,
  videoSrc: PropTypes__default["default"].string,
  videoAlt: PropTypes__default["default"].string
};

/* eslint-disable multiline-ternary */

var CardProduct = function CardProduct(props) {
  props.inverse;
      props.icon;
      var children = props.children,
      _props$imgSrc = props.imgSrc,
      imgSrc = _props$imgSrc === void 0 ? '' : _props$imgSrc;
      props.image;
      var config = props.config,
      imgAlt = props.imgAlt;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config, 'CardProduct')
  }, !!imgSrc && imgSrc ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardProduct-image"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: imgSrc,
    alt: imgAlt
  })) : '', /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardProduct-content"
  }, children));
};
CardProduct.propTypes = {
  inverse: PropTypes__default["default"].bool,
  image: PropTypes__default["default"].bool,
  imgSrc: PropTypes__default["default"].string,
  imgAlt: PropTypes__default["default"].string
};

/* eslint-disable multiline-ternary */

var CardRetail = function CardRetail(props) {
  props.inverse;
      props.icon;
      var children = props.children,
      _props$imgSrc = props.imgSrc,
      imgSrc = _props$imgSrc === void 0 ? '' : _props$imgSrc;
      props.image;
      var imgAlt = props.imgAlt,
      config = props.config;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: resolveProps(props, config, 'CardRetail')
  }, !!imgSrc && imgSrc ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardRetail-image"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: imgSrc,
    alt: imgAlt
  })) : '', /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-CardRetail-content"
  }, children));
};
CardRetail.propTypes = {
  inverse: PropTypes__default["default"].bool,
  image: PropTypes__default["default"].bool,
  imgSrc: PropTypes__default["default"].string,
  imgAlt: PropTypes__default["default"].string
};

var config$6 = {
  types: [],
  modifiers: [{
    title: 'default',
    isDefault: true
  }, 'inverse', 'image', 'video', 'inverse', 'horizontal'],
  states: []
};
var cards = {
  retails: 'CardRetail',
  product: 'CardProduct',
  institutional: 'CardInstitutional'
};
function useCard() {
  var getCardType = function getCardType(keys) {
    var _cards$currentCard;

    var currentCard = keys.find(function (it) {
      return Object.keys(cards).includes(it);
    });
    return (_cards$currentCard = cards[currentCard]) != null ? _cards$currentCard : cards.institutional;
  };

  var getCardIcon = function getCardIcon(icon) {
    return icon ? /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-CardInstitutional-icon mdn-Icon--lg mdn-Icon-" + icon,
      "aria-hidden": "" + (icon ? 'false' : 'true')
    }) : '';
  };

  var renderComponent = function renderComponent(cardType, props) {
    var children = props.children;

    switch (cardType) {
      case 'CardRetail':
        return /*#__PURE__*/React__default["default"].createElement(CardRetail, _extends$8({}, props, {
          config: config$6
        }));

      case 'CardProduct':
        return /*#__PURE__*/React__default["default"].createElement(CardProduct, _extends$8({}, props, {
          config: config$6
        }));

      default:
        return /*#__PURE__*/React__default["default"].createElement(CardInstitutional, _extends$8({}, props, {
          config: config$6,
          getCardIcon: getCardIcon
        }), ' ', children, ' ');
    }
  };

  return {
    config: config$6,
    getCardIcon: getCardIcon,
    getCardType: getCardType,
    renderComponent: renderComponent
  };
}

var _excluded$8 = ["children", "icon", "body", "surface", "imgSrc", "imageBlackout"];
function Card(props) {
  props.children;
      props.icon;
      props.body;
      props.surface;
      props.imgSrc;
      props.imageBlackout;
      _objectWithoutPropertiesLoose$2(props, _excluded$8);

  var _useCard = useCard(),
      getCardType = _useCard.getCardType,
      renderComponent = _useCard.renderComponent;

  var cardType = getCardType(Object.keys(props));
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, " ", renderComponent(cardType, props), " ");
}
Card.propTypes = {
  icon: PropTypes__default["default"].string,
  children: PropTypes__default["default"].node,
  surface: PropTypes__default["default"].bool,
  body: PropTypes__default["default"].bool,
  imageBlackout: PropTypes__default["default"].bool,
  imgSrc: PropTypes__default["default"].string
};

function Calendar() {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Calendar",
    "data-mdn-selected-day": "31",
    "data-mdn-selected-month": "august",
    "data-mdn-selected-year": "2020"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Calendar-header"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Input mdn-Input--activatedField mdn-Calendar-header-month"
  }, /*#__PURE__*/React__default["default"].createElement("select", {
    id: "calendar-month",
    className: "mdn-Input-field",
    type: "text",
    "data-mdn-type": "select"
  }, /*#__PURE__*/React__default["default"].createElement("option", {
    value: "january"
  }, "Janeiro"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "february"
  }, "Fevereiro"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "march"
  }, "Mar\xE7o"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "april"
  }, "Abril"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "may"
  }, "Maio"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "june"
  }, "Junho"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "july"
  }, "Julho"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "august"
  }, "Agosto"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "september"
  }, "Setembro"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "october"
  }, "Outubro"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "november"
  }, "Novembro"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "december"
  }, "Dezembro")), /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: "calendar-month",
    className: "mdn-Input-label"
  }, "M\xEAs"), /*#__PURE__*/React__default["default"].createElement("small", {
    className: "mdn-Input-errorFeedback"
  }, "Por favor, preencha este campo corretamente.")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Input mdn-Input--activatedField mdn-Calendar-header-year"
  }, /*#__PURE__*/React__default["default"].createElement("select", {
    id: "search",
    className: "mdn-Input-field",
    type: "text",
    "data-mdn-type": "select"
  }, /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2018"
  }, "2018"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2019"
  }, "2019"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2020"
  }, "2020"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2021"
  }, "2021"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2022"
  }, "2022"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2022"
  }, "2022"), /*#__PURE__*/React__default["default"].createElement("option", {
    value: "2023"
  }, "2023")), /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: "search",
    className: "mdn-Input-label"
  }, "Ano"), /*#__PURE__*/React__default["default"].createElement("small", {
    className: "mdn-Input-errorFeedback"
  }, "Por favor, preencha este campo corretamente."))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Calendar-body"
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "mdn-Calendar-weekDays"
  }, /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Domingo"
  }, "DOM"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Segunda-Feira"
  }, "SEG"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Ter\xE7a-Feira"
  }, "TER"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Quarta-Feira"
  }, "QUA"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Quinta-Feira"
  }, "QUI"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "Sexta-Feira"
  }, "SEX"), /*#__PURE__*/React__default["default"].createElement("li", {
    className: "mdn-Calendar-weekDays-day",
    "aria-label": "S\xE1bado"
  }, "S\xC1B")), /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "mdn-Calendar-weeks"
  })));
}

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var regeneratorRuntime$1 = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(regeneratorRuntime$1);

// TODO(Babel 8): Remove this file.

var runtime = regeneratorRuntime$1();
var regenerator = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

function Countdown(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      hideOnEnd = props.hideOnEnd;

  var _React$useState = React__default["default"].useState(endDate - startDate),
      timeLeft = _React$useState[0],
      setTimeLeft = _React$useState[1];

  var _React$useState2 = React__default["default"].useState(new Date(timeLeft).toISOString().slice(11, 19)),
      currentTime = _React$useState2[0],
      setCurrentTime = _React$useState2[1];

  React__default["default"].useEffect(function () {
    if (!timeLeft) return;
    var intervalId = setTimeout(function () {
      var timeDiff = timeLeft - 1;
      console.log(timeLeft, currentTime);
      setTimeLeft(timeDiff);
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [timeLeft, currentTime]);
  React__default["default"].useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var formatTime;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Date(timeLeft).toISOString().slice(11, 19);

          case 2:
            formatTime = _context.sent;
            console.log(timeLeft, formatTime);
            setCurrentTime(formatTime);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [timeLeft]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Countdown mdn-Countdown--sm",
    "data-mdn-start-date": startDate,
    "data-mdn-end-date": endDate,
    "data-mdn-hide-on-end": hideOnEnd
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Countdown-content-title"
  }, "SM - Acaba em: "), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Countdown-timer"
  }, currentTime, " || ", timeLeft, ' '));
}

var _excluded$7 = ["children", "tag", "inverse", "xs", "sm", "md"];
var config$5 = {
  types: [],
  modifiers: [{
    title: 'sm',
    isDefault: true
  }, 'md', 'xs', 'inverse'],
  states: []
};
function Subtitle(props) {
  var children = props.children,
      tag = props.tag;
      props.inverse;
      props.xs;
      props.sm;
      props.md;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$7);

  var CustomTag = tag || 'h2';
  return /*#__PURE__*/React__default["default"].createElement(CustomTag, _extends$8({}, rest, {
    className: resolveProps(props, config$5, 'Subtitle')
  }), children);
}
Subtitle.propTypes = {
  inverse: PropTypes__default["default"].bool,
  tag: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  xs: PropTypes__default["default"].bool,
  sm: PropTypes__default["default"].bool,
  md: PropTypes__default["default"].bool
};

var _excluded$6 = ["data", "children"];
var config$4 = {
  types: [{
    title: 'default',
    isDefault: true
  }],
  modifiers: [],
  states: []
};

var renderList = function renderList(topic) {
  return topic.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: 'mdn-HelpPassword-list-item ' + (item.isDone ? 'mdn-HelpPassword-list-item-done' : null)
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-HelpPassword-icon mdn-Icon-" + (item.isDone ? 'verificado' : 'fechar') + " mdn-Icon--sm\""
    }), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Text mdn-Text--caption"
    }, item.requirement));
  });
};

function HelpPassword(props) {
  var data = props.data;
      props.children;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$6);

  var dataHelpPassword = data || this.props.dataHelpPassword || {};
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$4, 'HelpPassword')
  }), /*#__PURE__*/React__default["default"].createElement("h3", {
    className: "mdn-HelpPassword-title"
  }, props.children), /*#__PURE__*/React__default["default"].createElement("ul", {
    className: "mdn-HelpPassword-list"
  }, renderList(dataHelpPassword)));
}
HelpPassword.propTypes = {
  dataHelpPassword: PropTypes__default["default"].array,
  children: PropTypes__default["default"].node,
  data: PropTypes__default["default"].shape({
    isDone: PropTypes__default["default"].bool,
    requirement: PropTypes__default["default"].string
  })
};

var _excluded$5 = ["data", "inverse"];
var config$3 = {
  types: [],
  modifiers: ['inverse'],
  states: []
};
function Price(props) {
  var data = props.data;
      props.inverse;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$5);

  return /*#__PURE__*/React__default["default"].createElement("dl", _extends$8({}, rest, {
    className: resolveProps(props, config$3, 'Price')
  }), /*#__PURE__*/React__default["default"].createElement("dt", {
    className: "mdn-Price-prefix"
  }, data.prefix), /*#__PURE__*/React__default["default"].createElement("dd", {
    className: "mdn-Price-price"
  }, data.price, /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Price-price-period"
  }, data.period ? '/' + data.period : '')), /*#__PURE__*/React__default["default"].createElement("dd", {
    className: "mdn-Price-suffix"
  }, data.suffix));
}
Price.propTypes = {
  data: PropTypes__default["default"].shape({
    prefix: PropTypes__default["default"].string.isRequired,
    price: PropTypes__default["default"].string.isRequired,
    period: PropTypes__default["default"].string.isRequired,
    suffix: PropTypes__default["default"].string.isRequired,
    inverse: PropTypes__default["default"].bool
  })
};

var _excluded$4 = ["data", "inverse"];
var config$2 = {
  types: ['inverse'],
  modifiers: [],
  states: []
};

var renderLinkDetailsGroup = function renderLinkDetailsGroup(data) {
  var listItems = data.map(function (link, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: index,
      className: "mdn-LinkDetails-group"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "mdn-Link mdn-Link--arrow"
    }, /*#__PURE__*/React__default["default"].createElement("a", _extends$8({}, link.linkProps, {
      className: "mdn-Link-anchor",
      target: link.target,
      href: link.href
    }), link.title), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--md"
    })), /*#__PURE__*/React__default["default"].createElement("p", {
      className: "mdn-Text mdn-Text--caption"
    }, link.description));
  });
  return listItems;
};

function LinkDetails(props) {
  var data = props.data;
      props.inverse;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$4);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config$2, 'LinkDetails')
  }), renderLinkDetailsGroup(data));
}
LinkDetails.propTypes = {
  inverse: PropTypes__default["default"].bool,
  data: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    title: PropTypes__default["default"].string.isRequired,
    description: PropTypes__default["default"].string.isRequired,
    href: PropTypes__default["default"].string.isRequired
  }))
};

var _excluded$3 = ["data", "isOpen", "sm", "heightAuto", "onCloseClick"];
var config$1 = {
  types: [{
    title: 'lg',
    isDefault: true
  }, 'sm'],
  modifiers: ['heightAuto']
};
function Modal(props) {
  var data = props.data,
      isOpen = props.isOpen;
      props.sm;
      props.heightAuto;
      var onCloseClick = props.onCloseClick,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$3);

  data = data || {};
  onCloseClick = onCloseClick || data.onCloseClick;
  isOpen = isOpen || data.isOpen;
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    "aria-hidden": isOpen ? 'false' : 'true',
    className: resolveProps(props, config$1, 'Modal') + (isOpen ? ' mdn-isOpen' : '')
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-content"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-header"
  }, data.header, /*#__PURE__*/React__default["default"].createElement("button", _extends$8({}, data.buttonProps, {
    onClick: onCloseClick,
    "aria-label": "Button close modal",
    role: "button",
    className: "mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: "mdn-Icon-fechar mdn-Icon--md",
    "aria-label": "Fechar modal"
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Divider mdn-Divider--primary"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-body"
  }, data.content), data.footer ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-footer"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-footer-start"
  }, data.footer.content), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-footer-end"
  }, data.footer.action)) : ''));
}
Modal.propTypes = {
  data: PropTypes__default["default"].shape({
    header: PropTypes__default["default"].node,
    buttonProps: PropTypes__default["default"].object,
    content: PropTypes__default["default"].node,
    footer: PropTypes__default["default"].object,
    isOpen: PropTypes__default["default"].bool,
    sm: PropTypes__default["default"].bool,
    md: PropTypes__default["default"].bool,
    lg: PropTypes__default["default"].bool,
    heightAuto: PropTypes__default["default"].bool,
    onCloseClick: PropTypes__default["default"].func
  })
};

var _excluded$2 = ["data", "isOpen", "sm", "onCloseClick"];
function Multimedia(props) {
  var data = props.data,
      isOpen = props.isOpen;
      props.sm;
      var onCloseClick = props.onCloseClick,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded$2);

  data = data || {};
  onCloseClick = onCloseClick || data.onCloseClick;
  isOpen = isOpen || data.isOpen;
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    "aria-hidden": isOpen ? 'false' : 'true',
    className: "mdn-Modal mdn-Modal--lg mdn-Modal--multimedia\n      " + (isOpen ? ' mdn-isOpen' : '') + " "
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-content"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-header"
  }, /*#__PURE__*/React__default["default"].createElement("button", {
    onClick: onCloseClick,
    "aria-label": "Button close modal",
    role: "button",
    className: "mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondaryInverse"
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: "mdn-Icon-fechar mdn-Icon--sm",
    "aria-label": "Fechar modal"
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Divider mdn-Divider--default"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "mdn-Modal-body"
  }, data.content)));
}
Multimedia.propTypes = {
  data: PropTypes__default["default"].shape({
    header: PropTypes__default["default"].node,
    buttonProps: PropTypes__default["default"].object,
    content: PropTypes__default["default"].node,
    footer: PropTypes__default["default"].node,
    isOpen: PropTypes__default["default"].bool,
    sm: PropTypes__default["default"].object,
    onCloseClick: PropTypes__default["default"].func
  })
};

var _excluded$1 = ["isVisible", "children", "top", "left", "right", "bottom"];
var config = {
  types: [{
    title: 'top',
    isDefault: true
  }, 'right', 'bottom', 'left'],
  modifiers: [],
  states: []
};
function Tooltip(props) {
  var isVisible = props.isVisible,
      children = props.children;
      props.top;
      props.left;
      props.right;
      props.bottom;
      var rest = _objectWithoutPropertiesLoose$2(props, _excluded$1); // const _props = clearProps(props)


  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, rest, {
    className: resolveProps(props, config, 'Tooltip'),
    style: {
      display: isVisible ? 'inline-flex' : 'none'
    }
  }), /*#__PURE__*/React__default["default"].createElement("p", {
    className: "mdn-Text mdn-Text--body mdn-Text--inverse"
  }, children));
}
Tooltip.propTypes = {
  children: PropTypes__default["default"].node,
  isVisible: PropTypes__default["default"].bool,
  iconSrc: PropTypes__default["default"].string,
  text: PropTypes__default["default"].string,
  vertical: PropTypes__default["default"].bool,
  top: PropTypes__default["default"].bool,
  left: PropTypes__default["default"].bool,
  right: PropTypes__default["default"].bool,
  bottom: PropTypes__default["default"].bool
};

var _excluded = ["id", "disabled", "children", "onChange", "options", "value", "parentProps", "label"];

function Select(props) {
  var id = props.id,
      disabled = props.disabled,
      children = props.children,
      onChange = props.onChange,
      options = props.options,
      value = props.value,
      parentProps = props.parentProps,
      label = props.label,
      rest = _objectWithoutPropertiesLoose$2(props, _excluded);

  var _React$useState = React__default["default"].useState(value),
      currentValue = _React$useState[0],
      setCurrentValue = _React$useState[1];

  var option = React__default["default"].useRef('');

  var _rest = clearProps(rest);

  var selfId = id || "" + new Date().valueOf().toString().match(/\d{6}$/)[0];

  var handleChange = function handleChange(event) {
    setCurrentValue(event.target.value.trim());
    !!onChange && onChange(event);
  };

  return /*#__PURE__*/React__default["default"].createElement("div", _extends$8({}, parentProps, {
    className: "mdn-Input mdn-Select\n       " + (currentValue ? 'mdn-Input--activatedField' : '')
  }), /*#__PURE__*/React__default["default"].createElement("select", _extends$8({
    id: "search",
    className: "mdn-Input-field",
    type: "text",
    ref: option,
    value: currentValue,
    "data-mdn-type": "select",
    disabled: disabled,
    onChange: handleChange
  }, _rest), children || (options == null ? void 0 : options.map(function (option, index) {
    return /*#__PURE__*/React__default["default"].createElement("option", {
      key: index,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: selfId,
    className: "mdn-Input-label"
  }, label), /*#__PURE__*/React__default["default"].createElement("small", {
    className: "mdn-Input-errorFeedback"
  }, "Por favor, preencha este campo corretamente."));
}

Select.propTypes = {
  disabled: PropTypes__default["default"].bool,
  children: PropTypes__default["default"].node,
  value: PropTypes__default["default"].string,
  label: PropTypes__default["default"].string,
  defaultValue: PropTypes__default["default"].string,
  id: PropTypes__default["default"].string,
  onChange: PropTypes__default["default"].func,
  options: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    value: PropTypes__default["default"].string,
    label: PropTypes__default["default"].string
  }))
};

try {
  window.MondrianReact = {
    setTheme: themeChanger,
    version: version
  };
} catch (err) {
  console.log(
    'Warning! Window object not founded. SeTheme will not be set globally.\nHint:If you want to use setTheme, use withs imports.'
  );
}

Object.defineProperty(exports, 'ReactDOM', {
  enumerable: true,
  get: function () { return reactDom__default["default"]; }
});
Object.defineProperty(exports, 'React', {
  enumerable: true,
  get: function () { return React__default["default"]; }
});
exports.Accordion = Accordion;
exports.Alert = Alert;
exports.Avatar = Avatar;
exports.Banner = Banner;
exports.BrandGroup = BrandGroup;
exports.Breadcrumb = Breadcrumb;
exports.Button = Button;
exports.Calendar = Calendar;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.Col = Col;
exports.Collapse = Collapse;
exports.Container = Container;
exports.CopyContainer = CopyContainer;
exports.Countdown = Countdown;
exports.Divider = Divider;
exports.Footer = Footer;
exports.FooterList = FooterList;
exports.Header = Header;
exports.Heading = Heading;
exports.HelpPassword = HelpPassword;
exports.IconGroup = IconGroup;
exports.Image = Image;
exports.Input = Input;
exports.Link = Link;
exports.LinkDetails = LinkDetails;
exports.LinkList = LinkList;
exports.Modal = Modal;
exports.Multimedia = Multimedia;
exports.Price = Price;
exports.ProgressBar = ProgressBar;
exports.Radio = Radio;
exports.RatingStars = RatingStars;
exports.Row = Row;
exports.Select = Select;
exports.Shortcut = Shortcut;
exports.Slider = Slider;
exports.Spinner = Spinner;
exports.Steps = Steps;
exports.Subtitle = Subtitle;
exports.Swiper = Swiper;
exports.TabSelect = TabSelect;
exports.Tag = Tag;
exports.Text = Text;
exports.Toggle = Toggle;
exports.Tooltip = Tooltip;
exports.Topic = Topic;
exports.TopicDetails = TopicDetails;
exports.setTheme = themeChanger;
exports.version = version;
//# sourceMappingURL=mondrian-react-3.2.21.js.map
